/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Scalephant API
 * Generated from the route definitions in apps/api; packages/contract turns it into the SPA client. Registration, sign-in, two-factor and organization membership are served by Better Auth under /api/auth (not part of this document).
 * OpenAPI spec version: 2.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AcceptSuggestion200,
  AddOwnCampaignCopy201,
  AddOwnCampaignCopyBody,
  AddProductOwnAd201,
  AddProductOwnAdBody,
  AdjustCreditsRequest,
  AdjustCreditsResponse,
  AdminAddModelCandidate202,
  AdminAddModelCandidateBody,
  AdminAiUsage200,
  AdminAiUsageParams,
  AdminApproveModel200,
  AdminAuditResponse,
  AdminCostSupervision200,
  AdminCostSupervisionParams,
  AdminLaunchFailures200,
  AdminLearningStats200,
  AdminListAuditParams,
  AdminMarketing200,
  AdminMarketingParams,
  AdminModels200,
  AdminOrganizationsResponse,
  AdminProbeAiHealth202,
  AdminQueues200,
  AdminRejectModel200,
  AdminRestoreModel200,
  AdminRunWatchdog202,
  AdminWatchdog200,
  AnalyzeBrandVoice200,
  AnalyzeWebsite200,
  AnalyzeWebsiteBody,
  BillingSummaryResponse,
  CancelAccountDeletion200,
  ChangeCampaignBudget200,
  ChangeCampaignBudgetBody,
  ChangeDraftTargetingBody,
  ChangeLiveCountriesBody,
  ClearMetaPixel200,
  ConfirmAdAccountConnect200,
  ConfirmAdAccountConnectBody,
  ConfirmCheckoutRequest,
  ConfirmCheckoutResponse,
  ConfirmConversionRule200,
  CreateCampaignGroup201,
  CreateCampaignGroupBody,
  CreateConversionRule201,
  CreateConversionRuleBody,
  CreateForecast201,
  CreateForecastBody,
  CreateProductProfile201,
  CreateProductProfileBody,
  CreateTrackingApiKey201,
  CreateTrackingApiKeyBody,
  DiscoverLogo200,
  DiscoverLogoBody,
  DismissSuggestion200,
  DismissTargetingSuggestion200,
  DownloadDataExport200,
  EditCampaignCopy200,
  EditCampaignCopyBody,
  ErrorResponse,
  FillCampaignCreatives200,
  FillCampaignCreativesBody,
  GenerateCampaignCopy201,
  GenerateCampaignCopyBody,
  GenerateCampaignImages202,
  GenerateCampaignImagesBody,
  GenerateCampaignStory201,
  GenerateCampaignVideo201,
  GenerateCampaignVideoBody,
  GetActivity200,
  GetActivityParams,
  GetAiImageProcessing200,
  GetAssetUrl200,
  GetAssetUrlParams,
  GetAutopilotSettings200,
  GetBrandVoice200,
  GetCampaign200,
  GetCampaignBrandProfile200,
  GetCampaignBrandProfileParams,
  GetCampaignCreatives200,
  GetCampaignGroup200,
  GetCampaignIntel200,
  GetCampaignMetrics200,
  GetCampaignMetricsParams,
  GetCampaignPolicy200,
  GetDeletionReceiptStatus200,
  GetDeletionReceiptStatusBody,
  GetLatestForecast200,
  GetLatestInsight200,
  GetPendingAdAccountConnect200,
  GetProductLibrary200,
  GetProductProfile200,
  GetRetargetingState200,
  GetTrackingHealth200,
  GetTrackingSettings200,
  LaunchCampaign202,
  LaunchCampaignBody,
  LinkHostedVideo200,
  LinkHostedVideoBody,
  ListAdAccounts200,
  ListAudiences200,
  ListCampaignEvents200,
  ListCampaignEventsParams,
  ListCampaignGroups200,
  ListCampaignStories200,
  ListCampaignVideos200,
  ListCampaigns200,
  ListCampaignsParams,
  ListConversionCandidates200,
  ListMetaPixels200,
  ListNotifications200,
  ListProductOwnAds200,
  ListProductProfiles200,
  ListTrackedConversions200,
  ListTrackedConversionsParams,
  ListWeeklyInsights200,
  MeResponse,
  PauseCampaign200,
  PrivacySummaryResponse,
  RedirectResponse,
  RefreshCampaignIntel202,
  RegisterUpload201,
  RegisterUploadBody,
  RemoveCampaignAdExtensionBody,
  RequestAccountDeletion202,
  RequestDataExport202,
  RequestDeletionRequest,
  RequestUpload200,
  RequestUploadBody,
  RequestVideoRender202,
  ResumeCampaign200,
  ReviewCampaignCopy200,
  ReviewCampaignImage200,
  SelectMetaPixel200,
  SelectMetaPixelBody,
  SetActiveOrganizationRequest,
  SetAiImageProcessing200,
  SetAiImageProcessingBody,
  SetCampaignBrandColours200,
  SetCampaignBrandColoursBody,
  SetImageCrop200,
  SetImageCropBody,
  SetLogo200,
  SetLogoBody,
  StartAdAccountConnectBody,
  StartCheckoutRequest,
  StepUpRequest,
  StepUpResponse,
  SystemStatus,
  UpdateAutopilotSettings200,
  UpdateAutopilotSettingsBody,
  UpdateCampaignPolicy200,
  UpdateCampaignPolicyBody,
  UpdateProductProfile200,
  UpdateProductProfileBody,
  UpdateTrackingSettings200,
  UpdateTrackingSettingsBody
} from './api.schemas';

import { apiFetch } from '../client/fetcher';
import type { ErrorType , BodyType } from '../client/fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetSystemStatusUrl = () => {




  return `/api/v1/system/status`
}

/**
 * @summary Service identity and time
 */
export const getSystemStatus = async ( options?: Parameters<typeof apiFetch>[1]): Promise<SystemStatus> => {

  return apiFetch<SystemStatus>(getGetSystemStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSystemStatusQueryKey = () => {
    return [
    `/api/v1/system/status`
    ] as const;
    }


export const getGetSystemStatusQueryOptions = <TData = Awaited<ReturnType<typeof getSystemStatus>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSystemStatus>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSystemStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSystemStatus>>> = ({ signal }) => getSystemStatus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSystemStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSystemStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getSystemStatus>>>
export type GetSystemStatusQueryError = ErrorType<unknown>


export function useGetSystemStatus<TData = Awaited<ReturnType<typeof getSystemStatus>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSystemStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSystemStatus>>,
          TError,
          Awaited<ReturnType<typeof getSystemStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSystemStatus<TData = Awaited<ReturnType<typeof getSystemStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSystemStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSystemStatus>>,
          TError,
          Awaited<ReturnType<typeof getSystemStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSystemStatus<TData = Awaited<ReturnType<typeof getSystemStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSystemStatus>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Service identity and time
 */

export function useGetSystemStatus<TData = Awaited<ReturnType<typeof getSystemStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSystemStatus>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSystemStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMeUrl = () => {




  return `/api/v1/me`
}

/**
 * @summary The signed-in user, their session and organizations
 */
export const getMe = async ( options?: Parameters<typeof apiFetch>[1]): Promise<MeResponse> => {

  return apiFetch<MeResponse>(getGetMeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMeQueryKey = () => {
    return [
    `/api/v1/me`
    ] as const;
    }


export const getGetMeQueryOptions = <TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({ signal }) => getMe({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>
export type GetMeQueryError = ErrorType<ErrorResponse>


export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMe>>,
          TError,
          Awaited<ReturnType<typeof getMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMe>>,
          TError,
          Awaited<ReturnType<typeof getMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The signed-in user, their session and organizations
 */

export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSetActiveOrganizationUrl = () => {




  return `/api/v1/organizations/active`
}

/**
 * @summary Switch the session to another organization the user belongs to
 */
export const setActiveOrganization = async (setActiveOrganizationRequest: SetActiveOrganizationRequest, options?: Parameters<typeof apiFetch>[1]): Promise<MeResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return apiFetch<MeResponse>(getSetActiveOrganizationUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(setActiveOrganizationRequest)
  }
);}





export const getSetActiveOrganizationMutationKey = () => ['setActiveOrganization'] as const;

export const getSetActiveOrganizationMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setActiveOrganization>>, TError,SetActiveOrganizationMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setActiveOrganization>>, TError,SetActiveOrganizationMutationVariables, TContext> => {

const mutationKey = getSetActiveOrganizationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setActiveOrganization>>, SetActiveOrganizationMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setActiveOrganization(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetActiveOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof setActiveOrganization>>>
    export type SetActiveOrganizationMutationBody = BodyType<SetActiveOrganizationRequest>
    export type SetActiveOrganizationMutationError = ErrorType<ErrorResponse>
    export type SetActiveOrganizationMutationVariables = {data: BodyType<SetActiveOrganizationRequest>}

    /**
 * @summary Switch the session to another organization the user belongs to
 */
export const useSetActiveOrganization = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setActiveOrganization>>, TError,SetActiveOrganizationMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setActiveOrganization>>,
        TError,
        SetActiveOrganizationMutationVariables,
        TContext
      > => {
      return useMutation(getSetActiveOrganizationMutationOptions(options), queryClient);
    }

export const getSendStepUpEmailCodeUrl = () => {




  return `/api/v1/auth/step-up/email-code`
}

/**
 * @summary E-mail a code for the step-up dialog (two-factor users only)
 */
export const sendStepUpEmailCode = async ( options?: Parameters<typeof apiFetch>[1]): Promise<void> => {

  return apiFetch<void>(getSendStepUpEmailCodeUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSendStepUpEmailCodeMutationKey = () => ['sendStepUpEmailCode'] as const;

export const getSendStepUpEmailCodeMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendStepUpEmailCode>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendStepUpEmailCode>>, TError,void, TContext> => {

const mutationKey = getSendStepUpEmailCodeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendStepUpEmailCode>>, void> = () => {


          return  sendStepUpEmailCode(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendStepUpEmailCodeMutationResult = NonNullable<Awaited<ReturnType<typeof sendStepUpEmailCode>>>

    export type SendStepUpEmailCodeMutationError = ErrorType<ErrorResponse>


    /**
 * @summary E-mail a code for the step-up dialog (two-factor users only)
 */
export const useSendStepUpEmailCode = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendStepUpEmailCode>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendStepUpEmailCode>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getSendStepUpEmailCodeMutationOptions(options), queryClient);
    }

export const getStepUpUrl = () => {




  return `/api/v1/auth/step-up`
}

/**
 * @summary Re-enter the password or a code to unlock sensitive actions for 30 minutes
 */
export const stepUp = async (stepUpRequest: StepUpRequest, options?: Parameters<typeof apiFetch>[1]): Promise<StepUpResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return apiFetch<StepUpResponse>(getStepUpUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(stepUpRequest)
  }
);}





export const getStepUpMutationKey = () => ['stepUp'] as const;

export const getStepUpMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stepUp>>, TError,StepUpMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stepUp>>, TError,StepUpMutationVariables, TContext> => {

const mutationKey = getStepUpMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stepUp>>, StepUpMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  stepUp(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StepUpMutationResult = NonNullable<Awaited<ReturnType<typeof stepUp>>>
    export type StepUpMutationBody = BodyType<StepUpRequest>
    export type StepUpMutationError = ErrorType<ErrorResponse>
    export type StepUpMutationVariables = {data: BodyType<StepUpRequest>}

    /**
 * @summary Re-enter the password or a code to unlock sensitive actions for 30 minutes
 */
export const useStepUp = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stepUp>>, TError,StepUpMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stepUp>>,
        TError,
        StepUpMutationVariables,
        TContext
      > => {
      return useMutation(getStepUpMutationOptions(options), queryClient);
    }

export const getGetBillingSummaryUrl = () => {




  return `/api/v1/billing`
}

/**
 * @summary The active organization's plan, subscription, usage in the period and payments
 */
export const getBillingSummary = async ( options?: Parameters<typeof apiFetch>[1]): Promise<BillingSummaryResponse> => {

  return apiFetch<BillingSummaryResponse>(getGetBillingSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBillingSummaryQueryKey = () => {
    return [
    `/api/v1/billing`
    ] as const;
    }


export const getGetBillingSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getBillingSummary>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingSummary>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBillingSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBillingSummary>>> = ({ signal }) => getBillingSummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBillingSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBillingSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getBillingSummary>>>
export type GetBillingSummaryQueryError = ErrorType<ErrorResponse>


export function useGetBillingSummary<TData = Awaited<ReturnType<typeof getBillingSummary>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBillingSummary>>,
          TError,
          Awaited<ReturnType<typeof getBillingSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBillingSummary<TData = Awaited<ReturnType<typeof getBillingSummary>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBillingSummary>>,
          TError,
          Awaited<ReturnType<typeof getBillingSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBillingSummary<TData = Awaited<ReturnType<typeof getBillingSummary>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingSummary>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The active organization's plan, subscription, usage in the period and payments
 */

export function useGetBillingSummary<TData = Awaited<ReturnType<typeof getBillingSummary>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingSummary>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBillingSummaryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getStartCheckoutUrl = () => {




  return `/api/v1/billing/checkout`
}

/**
 * @summary Start Stripe Checkout for a plan (owner or admin, recent step-up required)
 */
export const startCheckout = async (startCheckoutRequest: StartCheckoutRequest, options?: Parameters<typeof apiFetch>[1]): Promise<RedirectResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return apiFetch<RedirectResponse>(getStartCheckoutUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(startCheckoutRequest)
  }
);}





export const getStartCheckoutMutationKey = () => ['startCheckout'] as const;

export const getStartCheckoutMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startCheckout>>, TError,StartCheckoutMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof startCheckout>>, TError,StartCheckoutMutationVariables, TContext> => {

const mutationKey = getStartCheckoutMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startCheckout>>, StartCheckoutMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  startCheckout(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartCheckoutMutationResult = NonNullable<Awaited<ReturnType<typeof startCheckout>>>
    export type StartCheckoutMutationBody = BodyType<StartCheckoutRequest>
    export type StartCheckoutMutationError = ErrorType<ErrorResponse>
    export type StartCheckoutMutationVariables = {data: BodyType<StartCheckoutRequest>}

    /**
 * @summary Start Stripe Checkout for a plan (owner or admin, recent step-up required)
 */
export const useStartCheckout = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startCheckout>>, TError,StartCheckoutMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startCheckout>>,
        TError,
        StartCheckoutMutationVariables,
        TContext
      > => {
      return useMutation(getStartCheckoutMutationOptions(options), queryClient);
    }

export const getConfirmCheckoutUrl = () => {




  return `/api/v1/billing/checkout/confirm`
}

/**
 * @summary Activate the plan on the return from Stripe Checkout, without waiting for the webhook
 */
export const confirmCheckout = async (confirmCheckoutRequest: ConfirmCheckoutRequest, options?: Parameters<typeof apiFetch>[1]): Promise<ConfirmCheckoutResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return apiFetch<ConfirmCheckoutResponse>(getConfirmCheckoutUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(confirmCheckoutRequest)
  }
);}





export const getConfirmCheckoutMutationKey = () => ['confirmCheckout'] as const;

export const getConfirmCheckoutMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmCheckout>>, TError,ConfirmCheckoutMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof confirmCheckout>>, TError,ConfirmCheckoutMutationVariables, TContext> => {

const mutationKey = getConfirmCheckoutMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmCheckout>>, ConfirmCheckoutMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  confirmCheckout(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmCheckoutMutationResult = NonNullable<Awaited<ReturnType<typeof confirmCheckout>>>
    export type ConfirmCheckoutMutationBody = BodyType<ConfirmCheckoutRequest>
    export type ConfirmCheckoutMutationError = ErrorType<ErrorResponse>
    export type ConfirmCheckoutMutationVariables = {data: BodyType<ConfirmCheckoutRequest>}

    /**
 * @summary Activate the plan on the return from Stripe Checkout, without waiting for the webhook
 */
export const useConfirmCheckout = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmCheckout>>, TError,ConfirmCheckoutMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof confirmCheckout>>,
        TError,
        ConfirmCheckoutMutationVariables,
        TContext
      > => {
      return useMutation(getConfirmCheckoutMutationOptions(options), queryClient);
    }

export const getOpenBillingPortalUrl = () => {




  return `/api/v1/billing/portal`
}

/**
 * @summary Open the Stripe customer portal (owner or admin, recent step-up required)
 */
export const openBillingPortal = async ( options?: Parameters<typeof apiFetch>[1]): Promise<RedirectResponse> => {

  return apiFetch<RedirectResponse>(getOpenBillingPortalUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getOpenBillingPortalMutationKey = () => ['openBillingPortal'] as const;

export const getOpenBillingPortalMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof openBillingPortal>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof openBillingPortal>>, TError,void, TContext> => {

const mutationKey = getOpenBillingPortalMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof openBillingPortal>>, void> = () => {


          return  openBillingPortal(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OpenBillingPortalMutationResult = NonNullable<Awaited<ReturnType<typeof openBillingPortal>>>

    export type OpenBillingPortalMutationError = ErrorType<ErrorResponse>


    /**
 * @summary Open the Stripe customer portal (owner or admin, recent step-up required)
 */
export const useOpenBillingPortal = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof openBillingPortal>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof openBillingPortal>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getOpenBillingPortalMutationOptions(options), queryClient);
    }

export const getAdminListOrganizationsUrl = () => {




  return `/api/v1/admin/organizations`
}

/**
 * @summary Every organization with its members, subscription and credit balance (staff only)
 */
export const adminListOrganizations = async ( options?: Parameters<typeof apiFetch>[1]): Promise<AdminOrganizationsResponse> => {

  return apiFetch<AdminOrganizationsResponse>(getAdminListOrganizationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListOrganizationsQueryKey = () => {
    return [
    `/api/v1/admin/organizations`
    ] as const;
    }


export const getAdminListOrganizationsQueryOptions = <TData = Awaited<ReturnType<typeof adminListOrganizations>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListOrganizations>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminListOrganizationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListOrganizations>>> = ({ signal }) => adminListOrganizations({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListOrganizations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminListOrganizationsQueryResult = NonNullable<Awaited<ReturnType<typeof adminListOrganizations>>>
export type AdminListOrganizationsQueryError = ErrorType<ErrorResponse>


export function useAdminListOrganizations<TData = Awaited<ReturnType<typeof adminListOrganizations>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListOrganizations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListOrganizations>>,
          TError,
          Awaited<ReturnType<typeof adminListOrganizations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListOrganizations<TData = Awaited<ReturnType<typeof adminListOrganizations>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListOrganizations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListOrganizations>>,
          TError,
          Awaited<ReturnType<typeof adminListOrganizations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListOrganizations<TData = Awaited<ReturnType<typeof adminListOrganizations>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListOrganizations>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Every organization with its members, subscription and credit balance (staff only)
 */

export function useAdminListOrganizations<TData = Awaited<ReturnType<typeof adminListOrganizations>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListOrganizations>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminListOrganizationsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAdminListAuditUrl = (params?: AdminListAuditParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/audit?${stringifiedParams}` : `/api/v1/admin/audit`
}

/**
 * @summary Recent audit entries across tenants, optionally for one organization (staff only)
 */
export const adminListAudit = async (params?: AdminListAuditParams, options?: Parameters<typeof apiFetch>[1]): Promise<AdminAuditResponse> => {

  return apiFetch<AdminAuditResponse>(getAdminListAuditUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminListAuditQueryKey = (params?: AdminListAuditParams,) => {
    return [
    `/api/v1/admin/audit`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminListAuditQueryOptions = <TData = Awaited<ReturnType<typeof adminListAudit>>, TError = ErrorType<ErrorResponse>>(params?: AdminListAuditParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListAudit>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminListAuditQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminListAudit>>> = ({ signal }) => adminListAudit(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminListAudit>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminListAuditQueryResult = NonNullable<Awaited<ReturnType<typeof adminListAudit>>>
export type AdminListAuditQueryError = ErrorType<ErrorResponse>


export function useAdminListAudit<TData = Awaited<ReturnType<typeof adminListAudit>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  AdminListAuditParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListAudit>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListAudit>>,
          TError,
          Awaited<ReturnType<typeof adminListAudit>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListAudit<TData = Awaited<ReturnType<typeof adminListAudit>>, TError = ErrorType<ErrorResponse>>(
 params?: AdminListAuditParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListAudit>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListAudit>>,
          TError,
          Awaited<ReturnType<typeof adminListAudit>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListAudit<TData = Awaited<ReturnType<typeof adminListAudit>>, TError = ErrorType<ErrorResponse>>(
 params?: AdminListAuditParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListAudit>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Recent audit entries across tenants, optionally for one organization (staff only)
 */

export function useAdminListAudit<TData = Awaited<ReturnType<typeof adminListAudit>>, TError = ErrorType<ErrorResponse>>(
 params?: AdminListAuditParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminListAudit>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminListAuditQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAdminAdjustCreditsUrl = (organizationId: string,) => {




  return `/api/v1/admin/organizations/${organizationId}/credits`
}

/**
 * @summary Add or remove credits for an organization with a reason (staff only, audited)
 */
export const adminAdjustCredits = async (organizationId: string,
    adjustCreditsRequest: AdjustCreditsRequest, options?: Parameters<typeof apiFetch>[1]): Promise<AdjustCreditsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return apiFetch<AdjustCreditsResponse>(getAdminAdjustCreditsUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adjustCreditsRequest)
  }
);}





export const getAdminAdjustCreditsMutationKey = () => ['adminAdjustCredits'] as const;

export const getAdminAdjustCreditsMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAdjustCredits>>, TError,AdminAdjustCreditsMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminAdjustCredits>>, TError,AdminAdjustCreditsMutationVariables, TContext> => {

const mutationKey = getAdminAdjustCreditsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminAdjustCredits>>, AdminAdjustCreditsMutationVariables> = (props) => {
          const {organizationId,data} = props ?? {};

          return  adminAdjustCredits(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminAdjustCreditsMutationResult = NonNullable<Awaited<ReturnType<typeof adminAdjustCredits>>>
    export type AdminAdjustCreditsMutationBody = BodyType<AdjustCreditsRequest>
    export type AdminAdjustCreditsMutationError = ErrorType<ErrorResponse>
    export type AdminAdjustCreditsMutationVariables = {organizationId: string;data: BodyType<AdjustCreditsRequest>}

    /**
 * @summary Add or remove credits for an organization with a reason (staff only, audited)
 */
export const useAdminAdjustCredits = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAdjustCredits>>, TError,AdminAdjustCreditsMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminAdjustCredits>>,
        TError,
        AdminAdjustCreditsMutationVariables,
        TContext
      > => {
      return useMutation(getAdminAdjustCreditsMutationOptions(options), queryClient);
    }

export const getGetDeletionReceiptStatusUrl = () => {




  return `/api/v1/account/deletion/receipt`
}

/**
 * @summary Read committed account-erasure status with a short-lived bearer capability
 */
export const getDeletionReceiptStatus = async (getDeletionReceiptStatusBody: GetDeletionReceiptStatusBody, options?: Parameters<typeof apiFetch>[1]): Promise<GetDeletionReceiptStatus200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return apiFetch<GetDeletionReceiptStatus200>(getGetDeletionReceiptStatusUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(getDeletionReceiptStatusBody)
  }
);}





export const getGetDeletionReceiptStatusMutationKey = () => ['getDeletionReceiptStatus'] as const;

export const getGetDeletionReceiptStatusMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getDeletionReceiptStatus>>, TError,GetDeletionReceiptStatusMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof getDeletionReceiptStatus>>, TError,GetDeletionReceiptStatusMutationVariables, TContext> => {

const mutationKey = getGetDeletionReceiptStatusMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getDeletionReceiptStatus>>, GetDeletionReceiptStatusMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  getDeletionReceiptStatus(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetDeletionReceiptStatusMutationResult = NonNullable<Awaited<ReturnType<typeof getDeletionReceiptStatus>>>
    export type GetDeletionReceiptStatusMutationBody = BodyType<GetDeletionReceiptStatusBody>
    export type GetDeletionReceiptStatusMutationError = ErrorType<ErrorResponse>
    export type GetDeletionReceiptStatusMutationVariables = {data: BodyType<GetDeletionReceiptStatusBody>}

    /**
 * @summary Read committed account-erasure status with a short-lived bearer capability
 */
export const useGetDeletionReceiptStatus = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getDeletionReceiptStatus>>, TError,GetDeletionReceiptStatusMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getDeletionReceiptStatus>>,
        TError,
        GetDeletionReceiptStatusMutationVariables,
        TContext
      > => {
      return useMutation(getGetDeletionReceiptStatusMutationOptions(options), queryClient);
    }

export const getGetPrivacySummaryUrl = () => {




  return `/api/v1/account/privacy`
}

/**
 * @summary The signed-in person's data exports, pending deletion and ownership blockers
 */
export const getPrivacySummary = async ( options?: Parameters<typeof apiFetch>[1]): Promise<PrivacySummaryResponse> => {

  return apiFetch<PrivacySummaryResponse>(getGetPrivacySummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPrivacySummaryQueryKey = () => {
    return [
    `/api/v1/account/privacy`
    ] as const;
    }


export const getGetPrivacySummaryQueryOptions = <TData = Awaited<ReturnType<typeof getPrivacySummary>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPrivacySummary>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPrivacySummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPrivacySummary>>> = ({ signal }) => getPrivacySummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPrivacySummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPrivacySummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getPrivacySummary>>>
export type GetPrivacySummaryQueryError = ErrorType<ErrorResponse>


export function useGetPrivacySummary<TData = Awaited<ReturnType<typeof getPrivacySummary>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPrivacySummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPrivacySummary>>,
          TError,
          Awaited<ReturnType<typeof getPrivacySummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPrivacySummary<TData = Awaited<ReturnType<typeof getPrivacySummary>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPrivacySummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPrivacySummary>>,
          TError,
          Awaited<ReturnType<typeof getPrivacySummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPrivacySummary<TData = Awaited<ReturnType<typeof getPrivacySummary>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPrivacySummary>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The signed-in person's data exports, pending deletion and ownership blockers
 */

export function useGetPrivacySummary<TData = Awaited<ReturnType<typeof getPrivacySummary>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPrivacySummary>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPrivacySummaryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRequestDataExportUrl = () => {




  return `/api/v1/account/exports`
}

/**
 * @summary Ask for a copy of your data (GDPR art. 20); built by a job, notice by e-mail
 */
export const requestDataExport = async ( options?: Parameters<typeof apiFetch>[1]): Promise<RequestDataExport202> => {

  return apiFetch<RequestDataExport202>(getRequestDataExportUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRequestDataExportMutationKey = () => ['requestDataExport'] as const;

export const getRequestDataExportMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestDataExport>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestDataExport>>, TError,void, TContext> => {

const mutationKey = getRequestDataExportMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestDataExport>>, void> = () => {


          return  requestDataExport(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestDataExportMutationResult = NonNullable<Awaited<ReturnType<typeof requestDataExport>>>

    export type RequestDataExportMutationError = ErrorType<ErrorResponse>


    /**
 * @summary Ask for a copy of your data (GDPR art. 20); built by a job, notice by e-mail
 */
export const useRequestDataExport = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestDataExport>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requestDataExport>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRequestDataExportMutationOptions(options), queryClient);
    }

export const getDownloadDataExportUrl = (exportId: string,) => {




  return `/api/v1/account/exports/${exportId}`
}

/**
 * @summary The export document (JSON), for its owner while it is ready and unexpired
 */
export const downloadDataExport = async (exportId: string, options?: Parameters<typeof apiFetch>[1]): Promise<DownloadDataExport200> => {

  return apiFetch<DownloadDataExport200>(getDownloadDataExportUrl(exportId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadDataExportQueryKey = (exportId: string,) => {
    return [
    `/api/v1/account/exports/${exportId}`
    ] as const;
    }


export const getDownloadDataExportQueryOptions = <TData = Awaited<ReturnType<typeof downloadDataExport>>, TError = ErrorType<ErrorResponse>>(exportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDataExport>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadDataExportQueryKey(exportId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadDataExport>>> = ({ signal }) => downloadDataExport(exportId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: exportId !== null && exportId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadDataExport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadDataExportQueryResult = NonNullable<Awaited<ReturnType<typeof downloadDataExport>>>
export type DownloadDataExportQueryError = ErrorType<ErrorResponse>


export function useDownloadDataExport<TData = Awaited<ReturnType<typeof downloadDataExport>>, TError = ErrorType<ErrorResponse>>(
 exportId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDataExport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadDataExport>>,
          TError,
          Awaited<ReturnType<typeof downloadDataExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadDataExport<TData = Awaited<ReturnType<typeof downloadDataExport>>, TError = ErrorType<ErrorResponse>>(
 exportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDataExport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadDataExport>>,
          TError,
          Awaited<ReturnType<typeof downloadDataExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadDataExport<TData = Awaited<ReturnType<typeof downloadDataExport>>, TError = ErrorType<ErrorResponse>>(
 exportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDataExport>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The export document (JSON), for its owner while it is ready and unexpired
 */

export function useDownloadDataExport<TData = Awaited<ReturnType<typeof downloadDataExport>>, TError = ErrorType<ErrorResponse>>(
 exportId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadDataExport>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadDataExportQueryOptions(exportId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRequestAccountDeletionUrl = () => {




  return `/api/v1/account/deletion`
}

/**
 * @summary Start verified account deletion (GDPR art. 17)
 */
export const requestAccountDeletion = async (requestDeletionRequest: RequestDeletionRequest, options?: Parameters<typeof apiFetch>[1]): Promise<RequestAccountDeletion202> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return apiFetch<RequestAccountDeletion202>(getRequestAccountDeletionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(requestDeletionRequest)
  }
);}





export const getRequestAccountDeletionMutationKey = () => ['requestAccountDeletion'] as const;

export const getRequestAccountDeletionMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestAccountDeletion>>, TError,RequestAccountDeletionMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestAccountDeletion>>, TError,RequestAccountDeletionMutationVariables, TContext> => {

const mutationKey = getRequestAccountDeletionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestAccountDeletion>>, RequestAccountDeletionMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  requestAccountDeletion(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestAccountDeletionMutationResult = NonNullable<Awaited<ReturnType<typeof requestAccountDeletion>>>
    export type RequestAccountDeletionMutationBody = BodyType<RequestDeletionRequest>
    export type RequestAccountDeletionMutationError = ErrorType<ErrorResponse>
    export type RequestAccountDeletionMutationVariables = {data: BodyType<RequestDeletionRequest>}

    /**
 * @summary Start verified account deletion (GDPR art. 17)
 */
export const useRequestAccountDeletion = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestAccountDeletion>>, TError,RequestAccountDeletionMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requestAccountDeletion>>,
        TError,
        RequestAccountDeletionMutationVariables,
        TContext
      > => {
      return useMutation(getRequestAccountDeletionMutationOptions(options), queryClient);
    }

export const getCancelAccountDeletionUrl = () => {




  return `/api/v1/account/deletion`
}

/**
 * @summary Cancel a pending account deletion
 */
export const cancelAccountDeletion = async ( options?: Parameters<typeof apiFetch>[1]): Promise<CancelAccountDeletion200> => {

  return apiFetch<CancelAccountDeletion200>(getCancelAccountDeletionUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getCancelAccountDeletionMutationKey = () => ['cancelAccountDeletion'] as const;

export const getCancelAccountDeletionMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelAccountDeletion>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelAccountDeletion>>, TError,void, TContext> => {

const mutationKey = getCancelAccountDeletionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelAccountDeletion>>, void> = () => {


          return  cancelAccountDeletion(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelAccountDeletionMutationResult = NonNullable<Awaited<ReturnType<typeof cancelAccountDeletion>>>

    export type CancelAccountDeletionMutationError = ErrorType<ErrorResponse>


    /**
 * @summary Cancel a pending account deletion
 */
export const useCancelAccountDeletion = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelAccountDeletion>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelAccountDeletion>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCancelAccountDeletionMutationOptions(options), queryClient);
    }

export const getRequestUploadUrl = () => {




  return `/api/v1/uploads`
}

/**
 * @summary Ask for a short-lived URL to PUT one file to
 */
export const requestUpload = async (requestUploadBody: RequestUploadBody, options?: Parameters<typeof apiFetch>[1]): Promise<RequestUpload200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return apiFetch<RequestUpload200>(getRequestUploadUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(requestUploadBody)
  }
);}





export const getRequestUploadMutationKey = () => ['requestUpload'] as const;

export const getRequestUploadMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestUpload>>, TError,RequestUploadMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestUpload>>, TError,RequestUploadMutationVariables, TContext> => {

const mutationKey = getRequestUploadMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestUpload>>, RequestUploadMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  requestUpload(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestUploadMutationResult = NonNullable<Awaited<ReturnType<typeof requestUpload>>>
    export type RequestUploadMutationBody = BodyType<RequestUploadBody>
    export type RequestUploadMutationError = ErrorType<ErrorResponse>
    export type RequestUploadMutationVariables = {data: BodyType<RequestUploadBody>}

    /**
 * @summary Ask for a short-lived URL to PUT one file to
 */
export const useRequestUpload = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestUpload>>, TError,RequestUploadMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requestUpload>>,
        TError,
        RequestUploadMutationVariables,
        TContext
      > => {
      return useMutation(getRequestUploadMutationOptions(options), queryClient);
    }

export const getRegisterUploadUrl = () => {




  return `/api/v1/uploads/register`
}

/**
 * @summary Record a file that finished uploading, after checking what actually arrived
 */
export const registerUpload = async (registerUploadBody: RegisterUploadBody, options?: Parameters<typeof apiFetch>[1]): Promise<RegisterUpload201> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return apiFetch<RegisterUpload201>(getRegisterUploadUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(registerUploadBody)
  }
);}





export const getRegisterUploadMutationKey = () => ['registerUpload'] as const;

export const getRegisterUploadMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerUpload>>, TError,RegisterUploadMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof registerUpload>>, TError,RegisterUploadMutationVariables, TContext> => {

const mutationKey = getRegisterUploadMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof registerUpload>>, RegisterUploadMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  registerUpload(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegisterUploadMutationResult = NonNullable<Awaited<ReturnType<typeof registerUpload>>>
    export type RegisterUploadMutationBody = BodyType<RegisterUploadBody>
    export type RegisterUploadMutationError = ErrorType<ErrorResponse>
    export type RegisterUploadMutationVariables = {data: BodyType<RegisterUploadBody>}

    /**
 * @summary Record a file that finished uploading, after checking what actually arrived
 */
export const useRegisterUpload = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerUpload>>, TError,RegisterUploadMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof registerUpload>>,
        TError,
        RegisterUploadMutationVariables,
        TContext
      > => {
      return useMutation(getRegisterUploadMutationOptions(options), queryClient);
    }

export const getGetAssetUrlUrl = (assetId: string,
    params?: GetAssetUrlParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/assets/${assetId}/url?${stringifiedParams}` : `/api/v1/assets/${assetId}/url`
}

/**
 * @summary A short-lived URL for reading one asset
 */
export const getAssetUrl = async (assetId: string,
    params?: GetAssetUrlParams, options?: Parameters<typeof apiFetch>[1]): Promise<GetAssetUrl200> => {

  return apiFetch<GetAssetUrl200>(getGetAssetUrlUrl(assetId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAssetUrlQueryKey = (assetId: string,
    params?: GetAssetUrlParams,) => {
    return [
    `/api/v1/assets/${assetId}/url`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAssetUrlQueryOptions = <TData = Awaited<ReturnType<typeof getAssetUrl>>, TError = ErrorType<ErrorResponse>>(assetId: string,
    params?: GetAssetUrlParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetUrl>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAssetUrlQueryKey(assetId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssetUrl>>> = ({ signal }) => getAssetUrl(assetId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: assetId !== null && assetId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAssetUrl>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAssetUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getAssetUrl>>>
export type GetAssetUrlQueryError = ErrorType<ErrorResponse>


export function useGetAssetUrl<TData = Awaited<ReturnType<typeof getAssetUrl>>, TError = ErrorType<ErrorResponse>>(
 assetId: string,
    params: undefined |  GetAssetUrlParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetUrl>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssetUrl>>,
          TError,
          Awaited<ReturnType<typeof getAssetUrl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssetUrl<TData = Awaited<ReturnType<typeof getAssetUrl>>, TError = ErrorType<ErrorResponse>>(
 assetId: string,
    params?: GetAssetUrlParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetUrl>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssetUrl>>,
          TError,
          Awaited<ReturnType<typeof getAssetUrl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssetUrl<TData = Awaited<ReturnType<typeof getAssetUrl>>, TError = ErrorType<ErrorResponse>>(
 assetId: string,
    params?: GetAssetUrlParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetUrl>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary A short-lived URL for reading one asset
 */

export function useGetAssetUrl<TData = Awaited<ReturnType<typeof getAssetUrl>>, TError = ErrorType<ErrorResponse>>(
 assetId: string,
    params?: GetAssetUrlParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetUrl>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAssetUrlQueryOptions(assetId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListAdAccountsUrl = () => {




  return `/api/v1/ad-accounts`
}

/**
 * @summary The organization's connected advertising accounts
 */
export const listAdAccounts = async ( options?: Parameters<typeof apiFetch>[1]): Promise<ListAdAccounts200> => {

  return apiFetch<ListAdAccounts200>(getListAdAccountsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdAccountsQueryKey = () => {
    return [
    `/api/v1/ad-accounts`
    ] as const;
    }


export const getListAdAccountsQueryOptions = <TData = Awaited<ReturnType<typeof listAdAccounts>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdAccounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdAccountsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdAccounts>>> = ({ signal }) => listAdAccounts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdAccounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAdAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdAccounts>>>
export type ListAdAccountsQueryError = ErrorType<ErrorResponse>


export function useListAdAccounts<TData = Awaited<ReturnType<typeof listAdAccounts>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdAccounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdAccounts>>,
          TError,
          Awaited<ReturnType<typeof listAdAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdAccounts<TData = Awaited<ReturnType<typeof listAdAccounts>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdAccounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdAccounts>>,
          TError,
          Awaited<ReturnType<typeof listAdAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdAccounts<TData = Awaited<ReturnType<typeof listAdAccounts>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdAccounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The organization's connected advertising accounts
 */

export function useListAdAccounts<TData = Awaited<ReturnType<typeof listAdAccounts>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdAccounts>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdAccountsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getStartAdAccountConnectUrl = (platform: 'meta' | 'google',) => {




  return `/api/v1/ad-accounts/${platform}/connect`
}

/**
 * @summary Begin connecting an account (owner or admin, recent step-up required)
 */
export const startAdAccountConnect = async (platform: 'meta' | 'google',
    startAdAccountConnectBody?: StartAdAccountConnectBody, options?: Parameters<typeof apiFetch>[1]): Promise<RedirectResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return apiFetch<RedirectResponse>(getStartAdAccountConnectUrl(platform),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(startAdAccountConnectBody)
  }
);}





export const getStartAdAccountConnectMutationKey = () => ['startAdAccountConnect'] as const;

export const getStartAdAccountConnectMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startAdAccountConnect>>, TError,StartAdAccountConnectMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof startAdAccountConnect>>, TError,StartAdAccountConnectMutationVariables, TContext> => {

const mutationKey = getStartAdAccountConnectMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startAdAccountConnect>>, StartAdAccountConnectMutationVariables> = (props) => {
          const {platform,data} = props ?? {};

          return  startAdAccountConnect(platform,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartAdAccountConnectMutationResult = NonNullable<Awaited<ReturnType<typeof startAdAccountConnect>>>
    export type StartAdAccountConnectMutationBody = BodyType<StartAdAccountConnectBody> | undefined
    export type StartAdAccountConnectMutationError = ErrorType<ErrorResponse>
    export type StartAdAccountConnectMutationVariables = {platform: 'meta' | 'google';data?: BodyType<StartAdAccountConnectBody>}

    /**
 * @summary Begin connecting an account (owner or admin, recent step-up required)
 */
export const useStartAdAccountConnect = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startAdAccountConnect>>, TError,StartAdAccountConnectMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startAdAccountConnect>>,
        TError,
        StartAdAccountConnectMutationVariables,
        TContext
      > => {
      return useMutation(getStartAdAccountConnectMutationOptions(options), queryClient);
    }

export const getGetPendingAdAccountConnectUrl = (platform: 'meta' | 'google',
    id: string,) => {




  return `/api/v1/ad-accounts/${platform}/connect/pending/${id}`
}

/**
 * @summary List discovered accounts for explicit selection
 */
export const getPendingAdAccountConnect = async (platform: 'meta' | 'google',
    id: string, options?: Parameters<typeof apiFetch>[1]): Promise<GetPendingAdAccountConnect200> => {

  return apiFetch<GetPendingAdAccountConnect200>(getGetPendingAdAccountConnectUrl(platform,id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPendingAdAccountConnectQueryKey = (platform: 'meta' | 'google',
    id: string,) => {
    return [
    `/api/v1/ad-accounts/${platform}/connect/pending/${id}`
    ] as const;
    }


export const getGetPendingAdAccountConnectQueryOptions = <TData = Awaited<ReturnType<typeof getPendingAdAccountConnect>>, TError = ErrorType<ErrorResponse>>(platform: 'meta' | 'google',
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingAdAccountConnect>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPendingAdAccountConnectQueryKey(platform,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPendingAdAccountConnect>>> = ({ signal }) => getPendingAdAccountConnect(platform,id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: platform !== null && platform !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPendingAdAccountConnect>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPendingAdAccountConnectQueryResult = NonNullable<Awaited<ReturnType<typeof getPendingAdAccountConnect>>>
export type GetPendingAdAccountConnectQueryError = ErrorType<ErrorResponse>


export function useGetPendingAdAccountConnect<TData = Awaited<ReturnType<typeof getPendingAdAccountConnect>>, TError = ErrorType<ErrorResponse>>(
 platform: 'meta' | 'google',
    id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingAdAccountConnect>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingAdAccountConnect>>,
          TError,
          Awaited<ReturnType<typeof getPendingAdAccountConnect>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPendingAdAccountConnect<TData = Awaited<ReturnType<typeof getPendingAdAccountConnect>>, TError = ErrorType<ErrorResponse>>(
 platform: 'meta' | 'google',
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingAdAccountConnect>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingAdAccountConnect>>,
          TError,
          Awaited<ReturnType<typeof getPendingAdAccountConnect>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPendingAdAccountConnect<TData = Awaited<ReturnType<typeof getPendingAdAccountConnect>>, TError = ErrorType<ErrorResponse>>(
 platform: 'meta' | 'google',
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingAdAccountConnect>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List discovered accounts for explicit selection
 */

export function useGetPendingAdAccountConnect<TData = Awaited<ReturnType<typeof getPendingAdAccountConnect>>, TError = ErrorType<ErrorResponse>>(
 platform: 'meta' | 'google',
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingAdAccountConnect>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPendingAdAccountConnectQueryOptions(platform,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getConfirmAdAccountConnectUrl = (platform: 'meta' | 'google',
    id: string,) => {




  return `/api/v1/ad-accounts/${platform}/connect/pending/${id}`
}

/**
 * @summary Attach only explicitly selected accounts (recent step-up required)
 */
export const confirmAdAccountConnect = async (platform: 'meta' | 'google',
    id: string,
    confirmAdAccountConnectBody: ConfirmAdAccountConnectBody, options?: Parameters<typeof apiFetch>[1]): Promise<ConfirmAdAccountConnect200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return apiFetch<ConfirmAdAccountConnect200>(getConfirmAdAccountConnectUrl(platform,id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(confirmAdAccountConnectBody)
  }
);}





export const getConfirmAdAccountConnectMutationKey = () => ['confirmAdAccountConnect'] as const;

export const getConfirmAdAccountConnectMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmAdAccountConnect>>, TError,ConfirmAdAccountConnectMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof confirmAdAccountConnect>>, TError,ConfirmAdAccountConnectMutationVariables, TContext> => {

const mutationKey = getConfirmAdAccountConnectMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmAdAccountConnect>>, ConfirmAdAccountConnectMutationVariables> = (props) => {
          const {platform,id,data} = props ?? {};

          return  confirmAdAccountConnect(platform,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmAdAccountConnectMutationResult = NonNullable<Awaited<ReturnType<typeof confirmAdAccountConnect>>>
    export type ConfirmAdAccountConnectMutationBody = BodyType<ConfirmAdAccountConnectBody>
    export type ConfirmAdAccountConnectMutationError = ErrorType<ErrorResponse>
    export type ConfirmAdAccountConnectMutationVariables = {platform: 'meta' | 'google';id: string;data: BodyType<ConfirmAdAccountConnectBody>}

    /**
 * @summary Attach only explicitly selected accounts (recent step-up required)
 */
export const useConfirmAdAccountConnect = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmAdAccountConnect>>, TError,ConfirmAdAccountConnectMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof confirmAdAccountConnect>>,
        TError,
        ConfirmAdAccountConnectMutationVariables,
        TContext
      > => {
      return useMutation(getConfirmAdAccountConnectMutationOptions(options), queryClient);
    }

export const getDisconnectAdAccountUrl = (adAccountId: string,) => {




  return `/api/v1/ad-accounts/${adAccountId}`
}

/**
 * @summary Disconnect an account and forget its tokens (recent step-up required)
 */
export const disconnectAdAccount = async (adAccountId: string, options?: Parameters<typeof apiFetch>[1]): Promise<void> => {

  return apiFetch<void>(getDisconnectAdAccountUrl(adAccountId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDisconnectAdAccountMutationKey = () => ['disconnectAdAccount'] as const;

export const getDisconnectAdAccountMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectAdAccount>>, TError,DisconnectAdAccountMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof disconnectAdAccount>>, TError,DisconnectAdAccountMutationVariables, TContext> => {

const mutationKey = getDisconnectAdAccountMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disconnectAdAccount>>, DisconnectAdAccountMutationVariables> = (props) => {
          const {adAccountId} = props ?? {};

          return  disconnectAdAccount(adAccountId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisconnectAdAccountMutationResult = NonNullable<Awaited<ReturnType<typeof disconnectAdAccount>>>

    export type DisconnectAdAccountMutationError = ErrorType<ErrorResponse>
    export type DisconnectAdAccountMutationVariables = {adAccountId: string}

    /**
 * @summary Disconnect an account and forget its tokens (recent step-up required)
 */
export const useDisconnectAdAccount = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectAdAccount>>, TError,DisconnectAdAccountMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disconnectAdAccount>>,
        TError,
        DisconnectAdAccountMutationVariables,
        TContext
      > => {
      return useMutation(getDisconnectAdAccountMutationOptions(options), queryClient);
    }

export const getGetAiImageProcessingUrl = () => {




  return `/api/v1/product-profiles/ai-image-processing`
}

/**
 * @summary Read whether the organization's own images may be sent to an image model
 */
export const getAiImageProcessing = async ( options?: Parameters<typeof apiFetch>[1]): Promise<GetAiImageProcessing200> => {

  return apiFetch<GetAiImageProcessing200>(getGetAiImageProcessingUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAiImageProcessingQueryKey = () => {
    return [
    `/api/v1/product-profiles/ai-image-processing`
    ] as const;
    }


export const getGetAiImageProcessingQueryOptions = <TData = Awaited<ReturnType<typeof getAiImageProcessing>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiImageProcessing>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAiImageProcessingQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiImageProcessing>>> = ({ signal }) => getAiImageProcessing({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAiImageProcessing>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAiImageProcessingQueryResult = NonNullable<Awaited<ReturnType<typeof getAiImageProcessing>>>
export type GetAiImageProcessingQueryError = ErrorType<ErrorResponse>


export function useGetAiImageProcessing<TData = Awaited<ReturnType<typeof getAiImageProcessing>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiImageProcessing>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiImageProcessing>>,
          TError,
          Awaited<ReturnType<typeof getAiImageProcessing>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAiImageProcessing<TData = Awaited<ReturnType<typeof getAiImageProcessing>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiImageProcessing>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiImageProcessing>>,
          TError,
          Awaited<ReturnType<typeof getAiImageProcessing>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAiImageProcessing<TData = Awaited<ReturnType<typeof getAiImageProcessing>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiImageProcessing>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read whether the organization's own images may be sent to an image model
 */

export function useGetAiImageProcessing<TData = Awaited<ReturnType<typeof getAiImageProcessing>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiImageProcessing>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAiImageProcessingQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSetAiImageProcessingUrl = () => {




  return `/api/v1/product-profiles/ai-image-processing`
}

/**
 * @summary Approve or withdraw sending the organization's own images to an image model (owner/admin)
 */
export const setAiImageProcessing = async (setAiImageProcessingBody: SetAiImageProcessingBody, options?: Parameters<typeof apiFetch>[1]): Promise<SetAiImageProcessing200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return apiFetch<SetAiImageProcessing200>(getSetAiImageProcessingUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(setAiImageProcessingBody)
  }
);}





export const getSetAiImageProcessingMutationKey = () => ['setAiImageProcessing'] as const;

export const getSetAiImageProcessingMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAiImageProcessing>>, TError,SetAiImageProcessingMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setAiImageProcessing>>, TError,SetAiImageProcessingMutationVariables, TContext> => {

const mutationKey = getSetAiImageProcessingMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setAiImageProcessing>>, SetAiImageProcessingMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setAiImageProcessing(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetAiImageProcessingMutationResult = NonNullable<Awaited<ReturnType<typeof setAiImageProcessing>>>
    export type SetAiImageProcessingMutationBody = BodyType<SetAiImageProcessingBody>
    export type SetAiImageProcessingMutationError = ErrorType<ErrorResponse>
    export type SetAiImageProcessingMutationVariables = {data: BodyType<SetAiImageProcessingBody>}

    /**
 * @summary Approve or withdraw sending the organization's own images to an image model (owner/admin)
 */
export const useSetAiImageProcessing = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAiImageProcessing>>, TError,SetAiImageProcessingMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setAiImageProcessing>>,
        TError,
        SetAiImageProcessingMutationVariables,
        TContext
      > => {
      return useMutation(getSetAiImageProcessingMutationOptions(options), queryClient);
    }

export const getListProductProfilesUrl = () => {




  return `/api/v1/product-profiles`
}

/**
 * @summary The organization's product profiles
 */
export const listProductProfiles = async ( options?: Parameters<typeof apiFetch>[1]): Promise<ListProductProfiles200> => {

  return apiFetch<ListProductProfiles200>(getListProductProfilesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProductProfilesQueryKey = () => {
    return [
    `/api/v1/product-profiles`
    ] as const;
    }


export const getListProductProfilesQueryOptions = <TData = Awaited<ReturnType<typeof listProductProfiles>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProductProfiles>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProductProfilesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProductProfiles>>> = ({ signal }) => listProductProfiles({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProductProfiles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProductProfilesQueryResult = NonNullable<Awaited<ReturnType<typeof listProductProfiles>>>
export type ListProductProfilesQueryError = ErrorType<ErrorResponse>


export function useListProductProfiles<TData = Awaited<ReturnType<typeof listProductProfiles>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProductProfiles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProductProfiles>>,
          TError,
          Awaited<ReturnType<typeof listProductProfiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProductProfiles<TData = Awaited<ReturnType<typeof listProductProfiles>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProductProfiles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProductProfiles>>,
          TError,
          Awaited<ReturnType<typeof listProductProfiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProductProfiles<TData = Awaited<ReturnType<typeof listProductProfiles>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProductProfiles>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The organization's product profiles
 */

export function useListProductProfiles<TData = Awaited<ReturnType<typeof listProductProfiles>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProductProfiles>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProductProfilesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateProductProfileUrl = () => {




  return `/api/v1/product-profiles`
}

/**
 * @summary Describe a product (owner, admin or member)
 */
export const createProductProfile = async (createProductProfileBody: CreateProductProfileBody, options?: Parameters<typeof apiFetch>[1]): Promise<CreateProductProfile201> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return apiFetch<CreateProductProfile201>(getCreateProductProfileUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createProductProfileBody)
  }
);}





export const getCreateProductProfileMutationKey = () => ['createProductProfile'] as const;

export const getCreateProductProfileMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProductProfile>>, TError,CreateProductProfileMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createProductProfile>>, TError,CreateProductProfileMutationVariables, TContext> => {

const mutationKey = getCreateProductProfileMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProductProfile>>, CreateProductProfileMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createProductProfile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProductProfileMutationResult = NonNullable<Awaited<ReturnType<typeof createProductProfile>>>
    export type CreateProductProfileMutationBody = BodyType<CreateProductProfileBody>
    export type CreateProductProfileMutationError = ErrorType<ErrorResponse>
    export type CreateProductProfileMutationVariables = {data: BodyType<CreateProductProfileBody>}

    /**
 * @summary Describe a product (owner, admin or member)
 */
export const useCreateProductProfile = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProductProfile>>, TError,CreateProductProfileMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createProductProfile>>,
        TError,
        CreateProductProfileMutationVariables,
        TContext
      > => {
      return useMutation(getCreateProductProfileMutationOptions(options), queryClient);
    }

export const getAnalyzeWebsiteUrl = () => {




  return `/api/v1/product-profiles/analyze-website`
}

/**
 * @summary Read a business's website into suggestions for its profile (costs credits)
 */
export const analyzeWebsite = async (analyzeWebsiteBody: AnalyzeWebsiteBody, options?: Parameters<typeof apiFetch>[1]): Promise<AnalyzeWebsite200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return apiFetch<AnalyzeWebsite200>(getAnalyzeWebsiteUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(analyzeWebsiteBody)
  }
);}





export const getAnalyzeWebsiteMutationKey = () => ['analyzeWebsite'] as const;

export const getAnalyzeWebsiteMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof analyzeWebsite>>, TError,AnalyzeWebsiteMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof analyzeWebsite>>, TError,AnalyzeWebsiteMutationVariables, TContext> => {

const mutationKey = getAnalyzeWebsiteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof analyzeWebsite>>, AnalyzeWebsiteMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  analyzeWebsite(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AnalyzeWebsiteMutationResult = NonNullable<Awaited<ReturnType<typeof analyzeWebsite>>>
    export type AnalyzeWebsiteMutationBody = BodyType<AnalyzeWebsiteBody>
    export type AnalyzeWebsiteMutationError = ErrorType<ErrorResponse>
    export type AnalyzeWebsiteMutationVariables = {data: BodyType<AnalyzeWebsiteBody>}

    /**
 * @summary Read a business's website into suggestions for its profile (costs credits)
 */
export const useAnalyzeWebsite = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof analyzeWebsite>>, TError,AnalyzeWebsiteMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof analyzeWebsite>>,
        TError,
        AnalyzeWebsiteMutationVariables,
        TContext
      > => {
      return useMutation(getAnalyzeWebsiteMutationOptions(options), queryClient);
    }

export const getGetProductProfileUrl = (profileId: string,) => {




  return `/api/v1/product-profiles/${profileId}`
}

/**
 * @summary One product profile
 */
export const getProductProfile = async (profileId: string, options?: Parameters<typeof apiFetch>[1]): Promise<GetProductProfile200> => {

  return apiFetch<GetProductProfile200>(getGetProductProfileUrl(profileId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProductProfileQueryKey = (profileId: string,) => {
    return [
    `/api/v1/product-profiles/${profileId}`
    ] as const;
    }


export const getGetProductProfileQueryOptions = <TData = Awaited<ReturnType<typeof getProductProfile>>, TError = ErrorType<ErrorResponse>>(profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductProfile>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductProfileQueryKey(profileId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductProfile>>> = ({ signal }) => getProductProfile(profileId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: profileId !== null && profileId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getProductProfile>>>
export type GetProductProfileQueryError = ErrorType<ErrorResponse>


export function useGetProductProfile<TData = Awaited<ReturnType<typeof getProductProfile>>, TError = ErrorType<ErrorResponse>>(
 profileId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductProfile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductProfile>>,
          TError,
          Awaited<ReturnType<typeof getProductProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductProfile<TData = Awaited<ReturnType<typeof getProductProfile>>, TError = ErrorType<ErrorResponse>>(
 profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductProfile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductProfile>>,
          TError,
          Awaited<ReturnType<typeof getProductProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductProfile<TData = Awaited<ReturnType<typeof getProductProfile>>, TError = ErrorType<ErrorResponse>>(
 profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductProfile>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One product profile
 */

export function useGetProductProfile<TData = Awaited<ReturnType<typeof getProductProfile>>, TError = ErrorType<ErrorResponse>>(
 profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductProfile>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductProfileQueryOptions(profileId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateProductProfileUrl = (profileId: string,) => {




  return `/api/v1/product-profiles/${profileId}`
}

/**
 * @summary Change a product profile
 */
export const updateProductProfile = async (profileId: string,
    updateProductProfileBody: UpdateProductProfileBody, options?: Parameters<typeof apiFetch>[1]): Promise<UpdateProductProfile200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return apiFetch<UpdateProductProfile200>(getUpdateProductProfileUrl(profileId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateProductProfileBody)
  }
);}





export const getUpdateProductProfileMutationKey = () => ['updateProductProfile'] as const;

export const getUpdateProductProfileMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProductProfile>>, TError,UpdateProductProfileMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProductProfile>>, TError,UpdateProductProfileMutationVariables, TContext> => {

const mutationKey = getUpdateProductProfileMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProductProfile>>, UpdateProductProfileMutationVariables> = (props) => {
          const {profileId,data} = props ?? {};

          return  updateProductProfile(profileId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProductProfileMutationResult = NonNullable<Awaited<ReturnType<typeof updateProductProfile>>>
    export type UpdateProductProfileMutationBody = BodyType<UpdateProductProfileBody>
    export type UpdateProductProfileMutationError = ErrorType<ErrorResponse>
    export type UpdateProductProfileMutationVariables = {profileId: string;data: BodyType<UpdateProductProfileBody>}

    /**
 * @summary Change a product profile
 */
export const useUpdateProductProfile = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProductProfile>>, TError,UpdateProductProfileMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateProductProfile>>,
        TError,
        UpdateProductProfileMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateProductProfileMutationOptions(options), queryClient);
    }

export const getListProductOwnAdsUrl = (profileId: string,) => {




  return `/api/v1/product-profiles/${profileId}/own-ads`
}

/**
 * @summary The customer's own ready-made ads for one product
 */
export const listProductOwnAds = async (profileId: string, options?: Parameters<typeof apiFetch>[1]): Promise<ListProductOwnAds200> => {

  return apiFetch<ListProductOwnAds200>(getListProductOwnAdsUrl(profileId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProductOwnAdsQueryKey = (profileId: string,) => {
    return [
    `/api/v1/product-profiles/${profileId}/own-ads`
    ] as const;
    }


export const getListProductOwnAdsQueryOptions = <TData = Awaited<ReturnType<typeof listProductOwnAds>>, TError = ErrorType<ErrorResponse>>(profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProductOwnAds>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProductOwnAdsQueryKey(profileId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProductOwnAds>>> = ({ signal }) => listProductOwnAds(profileId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: profileId !== null && profileId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProductOwnAds>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListProductOwnAdsQueryResult = NonNullable<Awaited<ReturnType<typeof listProductOwnAds>>>
export type ListProductOwnAdsQueryError = ErrorType<ErrorResponse>


export function useListProductOwnAds<TData = Awaited<ReturnType<typeof listProductOwnAds>>, TError = ErrorType<ErrorResponse>>(
 profileId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProductOwnAds>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProductOwnAds>>,
          TError,
          Awaited<ReturnType<typeof listProductOwnAds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProductOwnAds<TData = Awaited<ReturnType<typeof listProductOwnAds>>, TError = ErrorType<ErrorResponse>>(
 profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProductOwnAds>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProductOwnAds>>,
          TError,
          Awaited<ReturnType<typeof listProductOwnAds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProductOwnAds<TData = Awaited<ReturnType<typeof listProductOwnAds>>, TError = ErrorType<ErrorResponse>>(
 profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProductOwnAds>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The customer's own ready-made ads for one product
 */

export function useListProductOwnAds<TData = Awaited<ReturnType<typeof listProductOwnAds>>, TError = ErrorType<ErrorResponse>>(
 profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProductOwnAds>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListProductOwnAdsQueryOptions(profileId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAddProductOwnAdUrl = (profileId: string,) => {




  return `/api/v1/product-profiles/${profileId}/own-ads`
}

/**
 * @summary Add one of the customer's own ads to a product's library
 */
export const addProductOwnAd = async (profileId: string,
    addProductOwnAdBody: AddProductOwnAdBody, options?: Parameters<typeof apiFetch>[1]): Promise<AddProductOwnAd201> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return apiFetch<AddProductOwnAd201>(getAddProductOwnAdUrl(profileId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(addProductOwnAdBody)
  }
);}





export const getAddProductOwnAdMutationKey = () => ['addProductOwnAd'] as const;

export const getAddProductOwnAdMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addProductOwnAd>>, TError,AddProductOwnAdMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addProductOwnAd>>, TError,AddProductOwnAdMutationVariables, TContext> => {

const mutationKey = getAddProductOwnAdMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addProductOwnAd>>, AddProductOwnAdMutationVariables> = (props) => {
          const {profileId,data} = props ?? {};

          return  addProductOwnAd(profileId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddProductOwnAdMutationResult = NonNullable<Awaited<ReturnType<typeof addProductOwnAd>>>
    export type AddProductOwnAdMutationBody = BodyType<AddProductOwnAdBody>
    export type AddProductOwnAdMutationError = ErrorType<ErrorResponse>
    export type AddProductOwnAdMutationVariables = {profileId: string;data: BodyType<AddProductOwnAdBody>}

    /**
 * @summary Add one of the customer's own ads to a product's library
 */
export const useAddProductOwnAd = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addProductOwnAd>>, TError,AddProductOwnAdMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addProductOwnAd>>,
        TError,
        AddProductOwnAdMutationVariables,
        TContext
      > => {
      return useMutation(getAddProductOwnAdMutationOptions(options), queryClient);
    }

export const getDeleteProductOwnAdUrl = (profileId: string,
    ownAdId: string,) => {




  return `/api/v1/product-profiles/${profileId}/own-ads/${ownAdId}`
}

/**
 * @summary Remove one own ad from a product's library
 */
export const deleteProductOwnAd = async (profileId: string,
    ownAdId: string, options?: Parameters<typeof apiFetch>[1]): Promise<void> => {

  return apiFetch<void>(getDeleteProductOwnAdUrl(profileId,ownAdId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteProductOwnAdMutationKey = () => ['deleteProductOwnAd'] as const;

export const getDeleteProductOwnAdMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductOwnAd>>, TError,DeleteProductOwnAdMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProductOwnAd>>, TError,DeleteProductOwnAdMutationVariables, TContext> => {

const mutationKey = getDeleteProductOwnAdMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProductOwnAd>>, DeleteProductOwnAdMutationVariables> = (props) => {
          const {profileId,ownAdId} = props ?? {};

          return  deleteProductOwnAd(profileId,ownAdId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProductOwnAdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProductOwnAd>>>

    export type DeleteProductOwnAdMutationError = ErrorType<ErrorResponse>
    export type DeleteProductOwnAdMutationVariables = {profileId: string;ownAdId: string}

    /**
 * @summary Remove one own ad from a product's library
 */
export const useDeleteProductOwnAd = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductOwnAd>>, TError,DeleteProductOwnAdMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProductOwnAd>>,
        TError,
        DeleteProductOwnAdMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteProductOwnAdMutationOptions(options), queryClient);
    }

export const getGetProductLibraryUrl = (profileId: string,) => {




  return `/api/v1/product-profiles/${profileId}/library`
}

/**
 * @summary A product's own images and the organization's logo
 */
export const getProductLibrary = async (profileId: string, options?: Parameters<typeof apiFetch>[1]): Promise<GetProductLibrary200> => {

  return apiFetch<GetProductLibrary200>(getGetProductLibraryUrl(profileId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProductLibraryQueryKey = (profileId: string,) => {
    return [
    `/api/v1/product-profiles/${profileId}/library`
    ] as const;
    }


export const getGetProductLibraryQueryOptions = <TData = Awaited<ReturnType<typeof getProductLibrary>>, TError = ErrorType<ErrorResponse>>(profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductLibrary>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductLibraryQueryKey(profileId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductLibrary>>> = ({ signal }) => getProductLibrary(profileId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: profileId !== null && profileId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductLibrary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductLibraryQueryResult = NonNullable<Awaited<ReturnType<typeof getProductLibrary>>>
export type GetProductLibraryQueryError = ErrorType<ErrorResponse>


export function useGetProductLibrary<TData = Awaited<ReturnType<typeof getProductLibrary>>, TError = ErrorType<ErrorResponse>>(
 profileId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductLibrary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductLibrary>>,
          TError,
          Awaited<ReturnType<typeof getProductLibrary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductLibrary<TData = Awaited<ReturnType<typeof getProductLibrary>>, TError = ErrorType<ErrorResponse>>(
 profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductLibrary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductLibrary>>,
          TError,
          Awaited<ReturnType<typeof getProductLibrary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductLibrary<TData = Awaited<ReturnType<typeof getProductLibrary>>, TError = ErrorType<ErrorResponse>>(
 profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductLibrary>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary A product's own images and the organization's logo
 */

export function useGetProductLibrary<TData = Awaited<ReturnType<typeof getProductLibrary>>, TError = ErrorType<ErrorResponse>>(
 profileId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductLibrary>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductLibraryQueryOptions(profileId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getDeleteProductLibraryImageUrl = (profileId: string,
    assetId: string,) => {




  return `/api/v1/product-profiles/${profileId}/library/${assetId}`
}

/**
 * @summary Remove one own image from a product's library; campaign copies stay
 */
export const deleteProductLibraryImage = async (profileId: string,
    assetId: string, options?: Parameters<typeof apiFetch>[1]): Promise<void> => {

  return apiFetch<void>(getDeleteProductLibraryImageUrl(profileId,assetId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteProductLibraryImageMutationKey = () => ['deleteProductLibraryImage'] as const;

export const getDeleteProductLibraryImageMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductLibraryImage>>, TError,DeleteProductLibraryImageMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProductLibraryImage>>, TError,DeleteProductLibraryImageMutationVariables, TContext> => {

const mutationKey = getDeleteProductLibraryImageMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProductLibraryImage>>, DeleteProductLibraryImageMutationVariables> = (props) => {
          const {profileId,assetId} = props ?? {};

          return  deleteProductLibraryImage(profileId,assetId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProductLibraryImageMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProductLibraryImage>>>

    export type DeleteProductLibraryImageMutationError = ErrorType<ErrorResponse>
    export type DeleteProductLibraryImageMutationVariables = {profileId: string;assetId: string}

    /**
 * @summary Remove one own image from a product's library; campaign copies stay
 */
export const useDeleteProductLibraryImage = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductLibraryImage>>, TError,DeleteProductLibraryImageMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProductLibraryImage>>,
        TError,
        DeleteProductLibraryImageMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteProductLibraryImageMutationOptions(options), queryClient);
    }

export const getSetImageCropUrl = (assetId: string,) => {




  return `/api/v1/assets/${assetId}/crop`
}

/**
 * @summary Frame one of the customer's own images per aspect ratio; the review is reset
 */
export const setImageCrop = async (assetId: string,
    setImageCropBody: SetImageCropBody, options?: Parameters<typeof apiFetch>[1]): Promise<SetImageCrop200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return apiFetch<SetImageCrop200>(getSetImageCropUrl(assetId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(setImageCropBody)
  }
);}





export const getSetImageCropMutationKey = () => ['setImageCrop'] as const;

export const getSetImageCropMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setImageCrop>>, TError,SetImageCropMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setImageCrop>>, TError,SetImageCropMutationVariables, TContext> => {

const mutationKey = getSetImageCropMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setImageCrop>>, SetImageCropMutationVariables> = (props) => {
          const {assetId,data} = props ?? {};

          return  setImageCrop(assetId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetImageCropMutationResult = NonNullable<Awaited<ReturnType<typeof setImageCrop>>>
    export type SetImageCropMutationBody = BodyType<SetImageCropBody>
    export type SetImageCropMutationError = ErrorType<ErrorResponse>
    export type SetImageCropMutationVariables = {assetId: string;data: BodyType<SetImageCropBody>}

    /**
 * @summary Frame one of the customer's own images per aspect ratio; the review is reset
 */
export const useSetImageCrop = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setImageCrop>>, TError,SetImageCropMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setImageCrop>>,
        TError,
        SetImageCropMutationVariables,
        TContext
      > => {
      return useMutation(getSetImageCropMutationOptions(options), queryClient);
    }

export const getAddOwnCampaignCopyUrl = (campaignId: string,) => {




  return `/api/v1/campaigns/${campaignId}/copy/own`
}

/**
 * @summary Add one of the customer's own ads to a campaign (owner/admin)
 */
export const addOwnCampaignCopy = async (campaignId: string,
    addOwnCampaignCopyBody: AddOwnCampaignCopyBody, options?: Parameters<typeof apiFetch>[1]): Promise<AddOwnCampaignCopy201> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return apiFetch<AddOwnCampaignCopy201>(getAddOwnCampaignCopyUrl(campaignId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(addOwnCampaignCopyBody)
  }
);}





export const getAddOwnCampaignCopyMutationKey = () => ['addOwnCampaignCopy'] as const;

export const getAddOwnCampaignCopyMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addOwnCampaignCopy>>, TError,AddOwnCampaignCopyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addOwnCampaignCopy>>, TError,AddOwnCampaignCopyMutationVariables, TContext> => {

const mutationKey = getAddOwnCampaignCopyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addOwnCampaignCopy>>, AddOwnCampaignCopyMutationVariables> = (props) => {
          const {campaignId,data} = props ?? {};

          return  addOwnCampaignCopy(campaignId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddOwnCampaignCopyMutationResult = NonNullable<Awaited<ReturnType<typeof addOwnCampaignCopy>>>
    export type AddOwnCampaignCopyMutationBody = BodyType<AddOwnCampaignCopyBody>
    export type AddOwnCampaignCopyMutationError = ErrorType<ErrorResponse>
    export type AddOwnCampaignCopyMutationVariables = {campaignId: string;data: BodyType<AddOwnCampaignCopyBody>}

    /**
 * @summary Add one of the customer's own ads to a campaign (owner/admin)
 */
export const useAddOwnCampaignCopy = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addOwnCampaignCopy>>, TError,AddOwnCampaignCopyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addOwnCampaignCopy>>,
        TError,
        AddOwnCampaignCopyMutationVariables,
        TContext
      > => {
      return useMutation(getAddOwnCampaignCopyMutationOptions(options), queryClient);
    }

export const getFillCampaignCreativesUrl = (campaignId: string,) => {




  return `/api/v1/campaigns/${campaignId}/fill`
}

/**
 * @summary Let AI fill what the customer's own creative does not cover (owner/admin)
 */
export const fillCampaignCreatives = async (campaignId: string,
    fillCampaignCreativesBody: FillCampaignCreativesBody, options?: Parameters<typeof apiFetch>[1]): Promise<FillCampaignCreatives200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return apiFetch<FillCampaignCreatives200>(getFillCampaignCreativesUrl(campaignId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(fillCampaignCreativesBody)
  }
);}





export const getFillCampaignCreativesMutationKey = () => ['fillCampaignCreatives'] as const;

export const getFillCampaignCreativesMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fillCampaignCreatives>>, TError,FillCampaignCreativesMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof fillCampaignCreatives>>, TError,FillCampaignCreativesMutationVariables, TContext> => {

const mutationKey = getFillCampaignCreativesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fillCampaignCreatives>>, FillCampaignCreativesMutationVariables> = (props) => {
          const {campaignId,data} = props ?? {};

          return  fillCampaignCreatives(campaignId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FillCampaignCreativesMutationResult = NonNullable<Awaited<ReturnType<typeof fillCampaignCreatives>>>
    export type FillCampaignCreativesMutationBody = BodyType<FillCampaignCreativesBody>
    export type FillCampaignCreativesMutationError = ErrorType<ErrorResponse>
    export type FillCampaignCreativesMutationVariables = {campaignId: string;data: BodyType<FillCampaignCreativesBody>}

    /**
 * @summary Let AI fill what the customer's own creative does not cover (owner/admin)
 */
export const useFillCampaignCreatives = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fillCampaignCreatives>>, TError,FillCampaignCreativesMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof fillCampaignCreatives>>,
        TError,
        FillCampaignCreativesMutationVariables,
        TContext
      > => {
      return useMutation(getFillCampaignCreativesMutationOptions(options), queryClient);
    }

export const getDiscoverLogoUrl = () => {




  return `/api/v1/logo/discover`
}

/**
 * @summary Look for the organization's logo on its website; nothing is used until approved
 */
export const discoverLogo = async (discoverLogoBody: DiscoverLogoBody, options?: Parameters<typeof apiFetch>[1]): Promise<DiscoverLogo200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return apiFetch<DiscoverLogo200>(getDiscoverLogoUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(discoverLogoBody)
  }
);}





export const getDiscoverLogoMutationKey = () => ['discoverLogo'] as const;

export const getDiscoverLogoMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discoverLogo>>, TError,DiscoverLogoMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof discoverLogo>>, TError,DiscoverLogoMutationVariables, TContext> => {

const mutationKey = getDiscoverLogoMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof discoverLogo>>, DiscoverLogoMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  discoverLogo(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DiscoverLogoMutationResult = NonNullable<Awaited<ReturnType<typeof discoverLogo>>>
    export type DiscoverLogoMutationBody = BodyType<DiscoverLogoBody>
    export type DiscoverLogoMutationError = ErrorType<ErrorResponse>
    export type DiscoverLogoMutationVariables = {data: BodyType<DiscoverLogoBody>}

    /**
 * @summary Look for the organization's logo on its website; nothing is used until approved
 */
export const useDiscoverLogo = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof discoverLogo>>, TError,DiscoverLogoMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof discoverLogo>>,
        TError,
        DiscoverLogoMutationVariables,
        TContext
      > => {
      return useMutation(getDiscoverLogoMutationOptions(options), queryClient);
    }

export const getGetCampaignBrandProfileUrl = (campaignId: string,
    params?: GetCampaignBrandProfileParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/campaigns/${campaignId}/brand-profile?${stringifiedParams}` : `/api/v1/campaigns/${campaignId}/brand-profile`
}

/**
 * @summary What the campaign's website looks like: the colours its images are made with
 */
export const getCampaignBrandProfile = async (campaignId: string,
    params?: GetCampaignBrandProfileParams, options?: Parameters<typeof apiFetch>[1]): Promise<GetCampaignBrandProfile200> => {

  return apiFetch<GetCampaignBrandProfile200>(getGetCampaignBrandProfileUrl(campaignId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCampaignBrandProfileQueryKey = (campaignId: string,
    params?: GetCampaignBrandProfileParams,) => {
    return [
    `/api/v1/campaigns/${campaignId}/brand-profile`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCampaignBrandProfileQueryOptions = <TData = Awaited<ReturnType<typeof getCampaignBrandProfile>>, TError = ErrorType<ErrorResponse>>(campaignId: string,
    params?: GetCampaignBrandProfileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignBrandProfile>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCampaignBrandProfileQueryKey(campaignId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCampaignBrandProfile>>> = ({ signal }) => getCampaignBrandProfile(campaignId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: campaignId !== null && campaignId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCampaignBrandProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCampaignBrandProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getCampaignBrandProfile>>>
export type GetCampaignBrandProfileQueryError = ErrorType<ErrorResponse>


export function useGetCampaignBrandProfile<TData = Awaited<ReturnType<typeof getCampaignBrandProfile>>, TError = ErrorType<ErrorResponse>>(
 campaignId: string,
    params: undefined |  GetCampaignBrandProfileParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignBrandProfile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaignBrandProfile>>,
          TError,
          Awaited<ReturnType<typeof getCampaignBrandProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignBrandProfile<TData = Awaited<ReturnType<typeof getCampaignBrandProfile>>, TError = ErrorType<ErrorResponse>>(
 campaignId: string,
    params?: GetCampaignBrandProfileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignBrandProfile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaignBrandProfile>>,
          TError,
          Awaited<ReturnType<typeof getCampaignBrandProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignBrandProfile<TData = Awaited<ReturnType<typeof getCampaignBrandProfile>>, TError = ErrorType<ErrorResponse>>(
 campaignId: string,
    params?: GetCampaignBrandProfileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignBrandProfile>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What the campaign's website looks like: the colours its images are made with
 */

export function useGetCampaignBrandProfile<TData = Awaited<ReturnType<typeof getCampaignBrandProfile>>, TError = ErrorType<ErrorResponse>>(
 campaignId: string,
    params?: GetCampaignBrandProfileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignBrandProfile>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCampaignBrandProfileQueryOptions(campaignId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSetCampaignBrandColoursUrl = (campaignId: string,) => {




  return `/api/v1/campaigns/${campaignId}/brand-profile/colours`
}

/**
 * @summary Use the person's own brand colours over what the website showed
 */
export const setCampaignBrandColours = async (campaignId: string,
    setCampaignBrandColoursBody: SetCampaignBrandColoursBody, options?: Parameters<typeof apiFetch>[1]): Promise<SetCampaignBrandColours200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return apiFetch<SetCampaignBrandColours200>(getSetCampaignBrandColoursUrl(campaignId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(setCampaignBrandColoursBody)
  }
);}





export const getSetCampaignBrandColoursMutationKey = () => ['setCampaignBrandColours'] as const;

export const getSetCampaignBrandColoursMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setCampaignBrandColours>>, TError,SetCampaignBrandColoursMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setCampaignBrandColours>>, TError,SetCampaignBrandColoursMutationVariables, TContext> => {

const mutationKey = getSetCampaignBrandColoursMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setCampaignBrandColours>>, SetCampaignBrandColoursMutationVariables> = (props) => {
          const {campaignId,data} = props ?? {};

          return  setCampaignBrandColours(campaignId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetCampaignBrandColoursMutationResult = NonNullable<Awaited<ReturnType<typeof setCampaignBrandColours>>>
    export type SetCampaignBrandColoursMutationBody = BodyType<SetCampaignBrandColoursBody>
    export type SetCampaignBrandColoursMutationError = ErrorType<ErrorResponse>
    export type SetCampaignBrandColoursMutationVariables = {campaignId: string;data: BodyType<SetCampaignBrandColoursBody>}

    /**
 * @summary Use the person's own brand colours over what the website showed
 */
export const useSetCampaignBrandColours = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setCampaignBrandColours>>, TError,SetCampaignBrandColoursMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setCampaignBrandColours>>,
        TError,
        SetCampaignBrandColoursMutationVariables,
        TContext
      > => {
      return useMutation(getSetCampaignBrandColoursMutationOptions(options), queryClient);
    }

export const getSetLogoUrl = () => {




  return `/api/v1/logo`
}

/**
 * @summary Use an image the person has seen as the organization's logo
 */
export const setLogo = async (setLogoBody: SetLogoBody, options?: Parameters<typeof apiFetch>[1]): Promise<SetLogo200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return apiFetch<SetLogo200>(getSetLogoUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(setLogoBody)
  }
);}





export const getSetLogoMutationKey = () => ['setLogo'] as const;

export const getSetLogoMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLogo>>, TError,SetLogoMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setLogo>>, TError,SetLogoMutationVariables, TContext> => {

const mutationKey = getSetLogoMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setLogo>>, SetLogoMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setLogo(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetLogoMutationResult = NonNullable<Awaited<ReturnType<typeof setLogo>>>
    export type SetLogoMutationBody = BodyType<SetLogoBody>
    export type SetLogoMutationError = ErrorType<ErrorResponse>
    export type SetLogoMutationVariables = {data: BodyType<SetLogoBody>}

    /**
 * @summary Use an image the person has seen as the organization's logo
 */
export const useSetLogo = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLogo>>, TError,SetLogoMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setLogo>>,
        TError,
        SetLogoMutationVariables,
        TContext
      > => {
      return useMutation(getSetLogoMutationOptions(options), queryClient);
    }

export const getListNotificationsUrl = () => {




  return `/api/v1/notifications`
}

/**
 * @summary Open notifications for the active organization
 */
export const listNotifications = async ( options?: Parameters<typeof apiFetch>[1]): Promise<ListNotifications200> => {

  return apiFetch<ListNotifications200>(getListNotificationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListNotificationsQueryKey = () => {
    return [
    `/api/v1/notifications`
    ] as const;
    }


export const getListNotificationsQueryOptions = <TData = Awaited<ReturnType<typeof listNotifications>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNotificationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNotifications>>> = ({ signal }) => listNotifications({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof listNotifications>>>
export type ListNotificationsQueryError = ErrorType<ErrorResponse>


export function useListNotifications<TData = Awaited<ReturnType<typeof listNotifications>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNotifications>>,
          TError,
          Awaited<ReturnType<typeof listNotifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNotifications<TData = Awaited<ReturnType<typeof listNotifications>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNotifications>>,
          TError,
          Awaited<ReturnType<typeof listNotifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListNotifications<TData = Awaited<ReturnType<typeof listNotifications>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Open notifications for the active organization
 */

export function useListNotifications<TData = Awaited<ReturnType<typeof listNotifications>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListNotificationsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getDismissNotificationUrl = (notificationId: string,) => {




  return `/api/v1/notifications/${notificationId}/dismiss`
}

/**
 * @summary Dismiss one notification
 */
export const dismissNotification = async (notificationId: string, options?: Parameters<typeof apiFetch>[1]): Promise<void> => {

  return apiFetch<void>(getDismissNotificationUrl(notificationId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDismissNotificationMutationKey = () => ['dismissNotification'] as const;

export const getDismissNotificationMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dismissNotification>>, TError,DismissNotificationMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof dismissNotification>>, TError,DismissNotificationMutationVariables, TContext> => {

const mutationKey = getDismissNotificationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dismissNotification>>, DismissNotificationMutationVariables> = (props) => {
          const {notificationId} = props ?? {};

          return  dismissNotification(notificationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DismissNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof dismissNotification>>>

    export type DismissNotificationMutationError = ErrorType<ErrorResponse>
    export type DismissNotificationMutationVariables = {notificationId: string}

    /**
 * @summary Dismiss one notification
 */
export const useDismissNotification = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dismissNotification>>, TError,DismissNotificationMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof dismissNotification>>,
        TError,
        DismissNotificationMutationVariables,
        TContext
      > => {
      return useMutation(getDismissNotificationMutationOptions(options), queryClient);
    }

export const getListCampaignGroupsUrl = () => {




  return `/api/v1/campaign-groups`
}

/**
 * @summary The organization's campaign groups
 */
export const listCampaignGroups = async ( options?: Parameters<typeof apiFetch>[1]): Promise<ListCampaignGroups200> => {

  return apiFetch<ListCampaignGroups200>(getListCampaignGroupsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCampaignGroupsQueryKey = () => {
    return [
    `/api/v1/campaign-groups`
    ] as const;
    }


export const getListCampaignGroupsQueryOptions = <TData = Awaited<ReturnType<typeof listCampaignGroups>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampaignGroups>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCampaignGroupsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCampaignGroups>>> = ({ signal }) => listCampaignGroups({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCampaignGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCampaignGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof listCampaignGroups>>>
export type ListCampaignGroupsQueryError = ErrorType<ErrorResponse>


export function useListCampaignGroups<TData = Awaited<ReturnType<typeof listCampaignGroups>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampaignGroups>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCampaignGroups>>,
          TError,
          Awaited<ReturnType<typeof listCampaignGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCampaignGroups<TData = Awaited<ReturnType<typeof listCampaignGroups>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampaignGroups>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCampaignGroups>>,
          TError,
          Awaited<ReturnType<typeof listCampaignGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCampaignGroups<TData = Awaited<ReturnType<typeof listCampaignGroups>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampaignGroups>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The organization's campaign groups
 */

export function useListCampaignGroups<TData = Awaited<ReturnType<typeof listCampaignGroups>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampaignGroups>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCampaignGroupsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateCampaignGroupUrl = () => {




  return `/api/v1/campaign-groups`
}

/**
 * @summary Create a group and its draft campaigns (owner or admin)
 */
export const createCampaignGroup = async (createCampaignGroupBody: CreateCampaignGroupBody, options?: Parameters<typeof apiFetch>[1]): Promise<CreateCampaignGroup201> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return apiFetch<CreateCampaignGroup201>(getCreateCampaignGroupUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createCampaignGroupBody)
  }
);}





export const getCreateCampaignGroupMutationKey = () => ['createCampaignGroup'] as const;

export const getCreateCampaignGroupMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCampaignGroup>>, TError,CreateCampaignGroupMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCampaignGroup>>, TError,CreateCampaignGroupMutationVariables, TContext> => {

const mutationKey = getCreateCampaignGroupMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCampaignGroup>>, CreateCampaignGroupMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createCampaignGroup(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCampaignGroupMutationResult = NonNullable<Awaited<ReturnType<typeof createCampaignGroup>>>
    export type CreateCampaignGroupMutationBody = BodyType<CreateCampaignGroupBody>
    export type CreateCampaignGroupMutationError = ErrorType<ErrorResponse>
    export type CreateCampaignGroupMutationVariables = {data: BodyType<CreateCampaignGroupBody>}

    /**
 * @summary Create a group and its draft campaigns (owner or admin)
 */
export const useCreateCampaignGroup = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCampaignGroup>>, TError,CreateCampaignGroupMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCampaignGroup>>,
        TError,
        CreateCampaignGroupMutationVariables,
        TContext
      > => {
      return useMutation(getCreateCampaignGroupMutationOptions(options), queryClient);
    }

export const getGetCampaignGroupUrl = (groupId: string,) => {




  return `/api/v1/campaign-groups/${groupId}`
}

/**
 * @summary One campaign group
 */
export const getCampaignGroup = async (groupId: string, options?: Parameters<typeof apiFetch>[1]): Promise<GetCampaignGroup200> => {

  return apiFetch<GetCampaignGroup200>(getGetCampaignGroupUrl(groupId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCampaignGroupQueryKey = (groupId: string,) => {
    return [
    `/api/v1/campaign-groups/${groupId}`
    ] as const;
    }


export const getGetCampaignGroupQueryOptions = <TData = Awaited<ReturnType<typeof getCampaignGroup>>, TError = ErrorType<ErrorResponse>>(groupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignGroup>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCampaignGroupQueryKey(groupId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCampaignGroup>>> = ({ signal }) => getCampaignGroup(groupId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: groupId !== null && groupId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCampaignGroup>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCampaignGroupQueryResult = NonNullable<Awaited<ReturnType<typeof getCampaignGroup>>>
export type GetCampaignGroupQueryError = ErrorType<ErrorResponse>


export function useGetCampaignGroup<TData = Awaited<ReturnType<typeof getCampaignGroup>>, TError = ErrorType<ErrorResponse>>(
 groupId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignGroup>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaignGroup>>,
          TError,
          Awaited<ReturnType<typeof getCampaignGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignGroup<TData = Awaited<ReturnType<typeof getCampaignGroup>>, TError = ErrorType<ErrorResponse>>(
 groupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignGroup>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaignGroup>>,
          TError,
          Awaited<ReturnType<typeof getCampaignGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignGroup<TData = Awaited<ReturnType<typeof getCampaignGroup>>, TError = ErrorType<ErrorResponse>>(
 groupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignGroup>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One campaign group
 */

export function useGetCampaignGroup<TData = Awaited<ReturnType<typeof getCampaignGroup>>, TError = ErrorType<ErrorResponse>>(
 groupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignGroup>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCampaignGroupQueryOptions(groupId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getReviewCampaignAdExtensionsUrl = (campaignId: string,) => {




  return `/api/v1/campaigns/${campaignId}/extensions/review`
}

/**
 * @summary Approve a Google campaign's ad extensions after reading them (owner or admin)
 */
export const reviewCampaignAdExtensions = async (campaignId: string, options?: Parameters<typeof apiFetch>[1]): Promise<void> => {

  return apiFetch<void>(getReviewCampaignAdExtensionsUrl(campaignId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getReviewCampaignAdExtensionsMutationKey = () => ['reviewCampaignAdExtensions'] as const;

export const getReviewCampaignAdExtensionsMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviewCampaignAdExtensions>>, TError,ReviewCampaignAdExtensionsMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reviewCampaignAdExtensions>>, TError,ReviewCampaignAdExtensionsMutationVariables, TContext> => {

const mutationKey = getReviewCampaignAdExtensionsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reviewCampaignAdExtensions>>, ReviewCampaignAdExtensionsMutationVariables> = (props) => {
          const {campaignId} = props ?? {};

          return  reviewCampaignAdExtensions(campaignId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReviewCampaignAdExtensionsMutationResult = NonNullable<Awaited<ReturnType<typeof reviewCampaignAdExtensions>>>

    export type ReviewCampaignAdExtensionsMutationError = ErrorType<ErrorResponse>
    export type ReviewCampaignAdExtensionsMutationVariables = {campaignId: string}

    /**
 * @summary Approve a Google campaign's ad extensions after reading them (owner or admin)
 */
export const useReviewCampaignAdExtensions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviewCampaignAdExtensions>>, TError,ReviewCampaignAdExtensionsMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reviewCampaignAdExtensions>>,
        TError,
        ReviewCampaignAdExtensionsMutationVariables,
        TContext
      > => {
      return useMutation(getReviewCampaignAdExtensionsMutationOptions(options), queryClient);
    }

export const getRemoveCampaignAdExtensionUrl = (campaignId: string,) => {




  return `/api/v1/campaigns/${campaignId}/extensions/remove`
}

/**
 * @summary Remove one ad extension before it reaches Google (owner or admin)
 */
export const removeCampaignAdExtension = async (campaignId: string,
    removeCampaignAdExtensionBody: RemoveCampaignAdExtensionBody, options?: Parameters<typeof apiFetch>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return apiFetch<void>(getRemoveCampaignAdExtensionUrl(campaignId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(removeCampaignAdExtensionBody)
  }
);}





export const getRemoveCampaignAdExtensionMutationKey = () => ['removeCampaignAdExtension'] as const;

export const getRemoveCampaignAdExtensionMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeCampaignAdExtension>>, TError,RemoveCampaignAdExtensionMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeCampaignAdExtension>>, TError,RemoveCampaignAdExtensionMutationVariables, TContext> => {

const mutationKey = getRemoveCampaignAdExtensionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeCampaignAdExtension>>, RemoveCampaignAdExtensionMutationVariables> = (props) => {
          const {campaignId,data} = props ?? {};

          return  removeCampaignAdExtension(campaignId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveCampaignAdExtensionMutationResult = NonNullable<Awaited<ReturnType<typeof removeCampaignAdExtension>>>
    export type RemoveCampaignAdExtensionMutationBody = BodyType<RemoveCampaignAdExtensionBody>
    export type RemoveCampaignAdExtensionMutationError = ErrorType<ErrorResponse>
    export type RemoveCampaignAdExtensionMutationVariables = {campaignId: string;data: BodyType<RemoveCampaignAdExtensionBody>}

    /**
 * @summary Remove one ad extension before it reaches Google (owner or admin)
 */
export const useRemoveCampaignAdExtension = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeCampaignAdExtension>>, TError,RemoveCampaignAdExtensionMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeCampaignAdExtension>>,
        TError,
        RemoveCampaignAdExtensionMutationVariables,
        TContext
      > => {
      return useMutation(getRemoveCampaignAdExtensionMutationOptions(options), queryClient);
    }

export const getChangeDraftTargetingUrl = (campaignId: string,) => {




  return `/api/v1/campaigns/${campaignId}/targeting`
}

/**
 * @summary Save explicit never-published targeting locally (owner/admin)
 */
export const changeDraftTargeting = async (campaignId: string,
    changeDraftTargetingBody: ChangeDraftTargetingBody, options?: Parameters<typeof apiFetch>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return apiFetch<void>(getChangeDraftTargetingUrl(campaignId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(changeDraftTargetingBody)
  }
);}





export const getChangeDraftTargetingMutationKey = () => ['changeDraftTargeting'] as const;

export const getChangeDraftTargetingMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeDraftTargeting>>, TError,ChangeDraftTargetingMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof changeDraftTargeting>>, TError,ChangeDraftTargetingMutationVariables, TContext> => {

const mutationKey = getChangeDraftTargetingMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeDraftTargeting>>, ChangeDraftTargetingMutationVariables> = (props) => {
          const {campaignId,data} = props ?? {};

          return  changeDraftTargeting(campaignId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChangeDraftTargetingMutationResult = NonNullable<Awaited<ReturnType<typeof changeDraftTargeting>>>
    export type ChangeDraftTargetingMutationBody = BodyType<ChangeDraftTargetingBody>
    export type ChangeDraftTargetingMutationError = ErrorType<ErrorResponse>
    export type ChangeDraftTargetingMutationVariables = {campaignId: string;data: BodyType<ChangeDraftTargetingBody>}

    /**
 * @summary Save explicit never-published targeting locally (owner/admin)
 */
export const useChangeDraftTargeting = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeDraftTargeting>>, TError,ChangeDraftTargetingMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changeDraftTargeting>>,
        TError,
        ChangeDraftTargetingMutationVariables,
        TContext
      > => {
      return useMutation(getChangeDraftTargetingMutationOptions(options), queryClient);
    }

export const getChangeLiveCountriesUrl = (campaignId: string,) => {




  return `/api/v1/campaigns/${campaignId}/countries`
}

/**
 * @summary Change a running Google campaign's countries (owner/admin)
 */
export const changeLiveCountries = async (campaignId: string,
    changeLiveCountriesBody: ChangeLiveCountriesBody, options?: Parameters<typeof apiFetch>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return apiFetch<void>(getChangeLiveCountriesUrl(campaignId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(changeLiveCountriesBody)
  }
);}





export const getChangeLiveCountriesMutationKey = () => ['changeLiveCountries'] as const;

export const getChangeLiveCountriesMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeLiveCountries>>, TError,ChangeLiveCountriesMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof changeLiveCountries>>, TError,ChangeLiveCountriesMutationVariables, TContext> => {

const mutationKey = getChangeLiveCountriesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeLiveCountries>>, ChangeLiveCountriesMutationVariables> = (props) => {
          const {campaignId,data} = props ?? {};

          return  changeLiveCountries(campaignId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChangeLiveCountriesMutationResult = NonNullable<Awaited<ReturnType<typeof changeLiveCountries>>>
    export type ChangeLiveCountriesMutationBody = BodyType<ChangeLiveCountriesBody>
    export type ChangeLiveCountriesMutationError = ErrorType<ErrorResponse>
    export type ChangeLiveCountriesMutationVariables = {campaignId: string;data: BodyType<ChangeLiveCountriesBody>}

    /**
 * @summary Change a running Google campaign's countries (owner/admin)
 */
export const useChangeLiveCountries = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeLiveCountries>>, TError,ChangeLiveCountriesMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changeLiveCountries>>,
        TError,
        ChangeLiveCountriesMutationVariables,
        TContext
      > => {
      return useMutation(getChangeLiveCountriesMutationOptions(options), queryClient);
    }

export const getDeleteCampaignCopyUrl = (campaignId: string,
    variantId: string,) => {




  return `/api/v1/campaigns/${campaignId}/copy/${variantId}`
}

/**
 * @summary Delete one never-published copy (owner/admin)
 */
export const deleteCampaignCopy = async (campaignId: string,
    variantId: string, options?: Parameters<typeof apiFetch>[1]): Promise<void> => {

  return apiFetch<void>(getDeleteCampaignCopyUrl(campaignId,variantId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteCampaignCopyMutationKey = () => ['deleteCampaignCopy'] as const;

export const getDeleteCampaignCopyMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCampaignCopy>>, TError,DeleteCampaignCopyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCampaignCopy>>, TError,DeleteCampaignCopyMutationVariables, TContext> => {

const mutationKey = getDeleteCampaignCopyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCampaignCopy>>, DeleteCampaignCopyMutationVariables> = (props) => {
          const {campaignId,variantId} = props ?? {};

          return  deleteCampaignCopy(campaignId,variantId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCampaignCopyMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCampaignCopy>>>

    export type DeleteCampaignCopyMutationError = ErrorType<ErrorResponse>
    export type DeleteCampaignCopyMutationVariables = {campaignId: string;variantId: string}

    /**
 * @summary Delete one never-published copy (owner/admin)
 */
export const useDeleteCampaignCopy = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCampaignCopy>>, TError,DeleteCampaignCopyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCampaignCopy>>,
        TError,
        DeleteCampaignCopyMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteCampaignCopyMutationOptions(options), queryClient);
    }

export const getEditCampaignCopyUrl = (campaignId: string,
    variantId: string,) => {




  return `/api/v1/campaigns/${campaignId}/copy/${variantId}`
}

/**
 * @summary Edit never-published campaign copy (owner or admin)
 */
export const editCampaignCopy = async (campaignId: string,
    variantId: string,
    editCampaignCopyBody: EditCampaignCopyBody, options?: Parameters<typeof apiFetch>[1]): Promise<EditCampaignCopy200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return apiFetch<EditCampaignCopy200>(getEditCampaignCopyUrl(campaignId,variantId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(editCampaignCopyBody)
  }
);}





export const getEditCampaignCopyMutationKey = () => ['editCampaignCopy'] as const;

export const getEditCampaignCopyMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editCampaignCopy>>, TError,EditCampaignCopyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof editCampaignCopy>>, TError,EditCampaignCopyMutationVariables, TContext> => {

const mutationKey = getEditCampaignCopyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editCampaignCopy>>, EditCampaignCopyMutationVariables> = (props) => {
          const {campaignId,variantId,data} = props ?? {};

          return  editCampaignCopy(campaignId,variantId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditCampaignCopyMutationResult = NonNullable<Awaited<ReturnType<typeof editCampaignCopy>>>
    export type EditCampaignCopyMutationBody = BodyType<EditCampaignCopyBody>
    export type EditCampaignCopyMutationError = ErrorType<ErrorResponse>
    export type EditCampaignCopyMutationVariables = {campaignId: string;variantId: string;data: BodyType<EditCampaignCopyBody>}

    /**
 * @summary Edit never-published campaign copy (owner or admin)
 */
export const useEditCampaignCopy = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editCampaignCopy>>, TError,EditCampaignCopyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editCampaignCopy>>,
        TError,
        EditCampaignCopyMutationVariables,
        TContext
      > => {
      return useMutation(getEditCampaignCopyMutationOptions(options), queryClient);
    }

export const getDeleteCampaignImageUrl = (campaignId: string,
    assetId: string,) => {




  return `/api/v1/campaigns/${campaignId}/images/${assetId}`
}

/**
 * @summary Delete one never-published image and retire dependent copies (owner/admin)
 */
export const deleteCampaignImage = async (campaignId: string,
    assetId: string, options?: Parameters<typeof apiFetch>[1]): Promise<void> => {

  return apiFetch<void>(getDeleteCampaignImageUrl(campaignId,assetId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteCampaignImageMutationKey = () => ['deleteCampaignImage'] as const;

export const getDeleteCampaignImageMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCampaignImage>>, TError,DeleteCampaignImageMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCampaignImage>>, TError,DeleteCampaignImageMutationVariables, TContext> => {

const mutationKey = getDeleteCampaignImageMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCampaignImage>>, DeleteCampaignImageMutationVariables> = (props) => {
          const {campaignId,assetId} = props ?? {};

          return  deleteCampaignImage(campaignId,assetId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCampaignImageMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCampaignImage>>>

    export type DeleteCampaignImageMutationError = ErrorType<ErrorResponse>
    export type DeleteCampaignImageMutationVariables = {campaignId: string;assetId: string}

    /**
 * @summary Delete one never-published image and retire dependent copies (owner/admin)
 */
export const useDeleteCampaignImage = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCampaignImage>>, TError,DeleteCampaignImageMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCampaignImage>>,
        TError,
        DeleteCampaignImageMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteCampaignImageMutationOptions(options), queryClient);
    }

export const getListCampaignsUrl = (params?: ListCampaignsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/campaigns?${stringifiedParams}` : `/api/v1/campaigns`
}

/**
 * @summary Every campaign in this organization, newest group first
 */
export const listCampaigns = async (params?: ListCampaignsParams, options?: Parameters<typeof apiFetch>[1]): Promise<ListCampaigns200> => {

  return apiFetch<ListCampaigns200>(getListCampaignsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCampaignsQueryKey = (params?: ListCampaignsParams,) => {
    return [
    `/api/v1/campaigns`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCampaignsQueryOptions = <TData = Awaited<ReturnType<typeof listCampaigns>>, TError = ErrorType<ErrorResponse>>(params?: ListCampaignsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampaigns>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCampaignsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCampaigns>>> = ({ signal }) => listCampaigns(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCampaigns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCampaignsQueryResult = NonNullable<Awaited<ReturnType<typeof listCampaigns>>>
export type ListCampaignsQueryError = ErrorType<ErrorResponse>


export function useListCampaigns<TData = Awaited<ReturnType<typeof listCampaigns>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ListCampaignsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampaigns>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCampaigns>>,
          TError,
          Awaited<ReturnType<typeof listCampaigns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCampaigns<TData = Awaited<ReturnType<typeof listCampaigns>>, TError = ErrorType<ErrorResponse>>(
 params?: ListCampaignsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampaigns>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCampaigns>>,
          TError,
          Awaited<ReturnType<typeof listCampaigns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCampaigns<TData = Awaited<ReturnType<typeof listCampaigns>>, TError = ErrorType<ErrorResponse>>(
 params?: ListCampaignsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampaigns>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Every campaign in this organization, newest group first
 */

export function useListCampaigns<TData = Awaited<ReturnType<typeof listCampaigns>>, TError = ErrorType<ErrorResponse>>(
 params?: ListCampaignsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampaigns>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCampaignsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetCampaignUrl = (campaignId: string,) => {




  return `/api/v1/campaigns/${campaignId}`
}

/**
 * @summary One campaign with its budget, targeting and platform state
 */
export const getCampaign = async (campaignId: string, options?: Parameters<typeof apiFetch>[1]): Promise<GetCampaign200> => {

  return apiFetch<GetCampaign200>(getGetCampaignUrl(campaignId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCampaignQueryKey = (campaignId: string,) => {
    return [
    `/api/v1/campaigns/${campaignId}`
    ] as const;
    }


export const getGetCampaignQueryOptions = <TData = Awaited<ReturnType<typeof getCampaign>>, TError = ErrorType<ErrorResponse>>(campaignId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaign>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCampaignQueryKey(campaignId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCampaign>>> = ({ signal }) => getCampaign(campaignId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: campaignId !== null && campaignId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCampaign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCampaignQueryResult = NonNullable<Awaited<ReturnType<typeof getCampaign>>>
export type GetCampaignQueryError = ErrorType<ErrorResponse>


export function useGetCampaign<TData = Awaited<ReturnType<typeof getCampaign>>, TError = ErrorType<ErrorResponse>>(
 campaignId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaign>>,
          TError,
          Awaited<ReturnType<typeof getCampaign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaign<TData = Awaited<ReturnType<typeof getCampaign>>, TError = ErrorType<ErrorResponse>>(
 campaignId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaign>>,
          TError,
          Awaited<ReturnType<typeof getCampaign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaign<TData = Awaited<ReturnType<typeof getCampaign>>, TError = ErrorType<ErrorResponse>>(
 campaignId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaign>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One campaign with its budget, targeting and platform state
 */

export function useGetCampaign<TData = Awaited<ReturnType<typeof getCampaign>>, TError = ErrorType<ErrorResponse>>(
 campaignId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaign>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCampaignQueryOptions(campaignId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getDeleteCampaignUrl = (campaignId: string,) => {




  return `/api/v1/campaigns/${campaignId}`
}

/**
 * @summary Remove a campaign after provider deletion is verified (owner or admin)
 */
export const deleteCampaign = async (campaignId: string, options?: Parameters<typeof apiFetch>[1]): Promise<void> => {

  return apiFetch<void>(getDeleteCampaignUrl(campaignId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteCampaignMutationKey = () => ['deleteCampaign'] as const;

export const getDeleteCampaignMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCampaign>>, TError,DeleteCampaignMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCampaign>>, TError,DeleteCampaignMutationVariables, TContext> => {

const mutationKey = getDeleteCampaignMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCampaign>>, DeleteCampaignMutationVariables> = (props) => {
          const {campaignId} = props ?? {};

          return  deleteCampaign(campaignId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCampaignMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCampaign>>>

    export type DeleteCampaignMutationError = ErrorType<ErrorResponse>
    export type DeleteCampaignMutationVariables = {campaignId: string}

    /**
 * @summary Remove a campaign after provider deletion is verified (owner or admin)
 */
export const useDeleteCampaign = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCampaign>>, TError,DeleteCampaignMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCampaign>>,
        TError,
        DeleteCampaignMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteCampaignMutationOptions(options), queryClient);
    }

export const getListCampaignEventsUrl = (campaignId: string,
    params?: ListCampaignEventsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/campaigns/${campaignId}/events?${stringifiedParams}` : `/api/v1/campaigns/${campaignId}/events`
}

/**
 * @summary What has happened to this campaign, newest first
 */
export const listCampaignEvents = async (campaignId: string,
    params?: ListCampaignEventsParams, options?: Parameters<typeof apiFetch>[1]): Promise<ListCampaignEvents200> => {

  return apiFetch<ListCampaignEvents200>(getListCampaignEventsUrl(campaignId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCampaignEventsQueryKey = (campaignId: string,
    params?: ListCampaignEventsParams,) => {
    return [
    `/api/v1/campaigns/${campaignId}/events`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCampaignEventsQueryOptions = <TData = Awaited<ReturnType<typeof listCampaignEvents>>, TError = ErrorType<ErrorResponse>>(campaignId: string,
    params?: ListCampaignEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampaignEvents>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCampaignEventsQueryKey(campaignId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCampaignEvents>>> = ({ signal }) => listCampaignEvents(campaignId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: campaignId !== null && campaignId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCampaignEvents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCampaignEventsQueryResult = NonNullable<Awaited<ReturnType<typeof listCampaignEvents>>>
export type ListCampaignEventsQueryError = ErrorType<ErrorResponse>


export function useListCampaignEvents<TData = Awaited<ReturnType<typeof listCampaignEvents>>, TError = ErrorType<ErrorResponse>>(
 campaignId: string,
    params: undefined |  ListCampaignEventsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampaignEvents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCampaignEvents>>,
          TError,
          Awaited<ReturnType<typeof listCampaignEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCampaignEvents<TData = Awaited<ReturnType<typeof listCampaignEvents>>, TError = ErrorType<ErrorResponse>>(
 campaignId: string,
    params?: ListCampaignEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampaignEvents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCampaignEvents>>,
          TError,
          Awaited<ReturnType<typeof listCampaignEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCampaignEvents<TData = Awaited<ReturnType<typeof listCampaignEvents>>, TError = ErrorType<ErrorResponse>>(
 campaignId: string,
    params?: ListCampaignEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampaignEvents>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What has happened to this campaign, newest first
 */

export function useListCampaignEvents<TData = Awaited<ReturnType<typeof listCampaignEvents>>, TError = ErrorType<ErrorResponse>>(
 campaignId: string,
    params?: ListCampaignEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampaignEvents>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCampaignEventsQueryOptions(campaignId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetCampaignMetricsUrl = (campaignId: string,
    params?: GetCampaignMetricsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/campaigns/${campaignId}/metrics?${stringifiedParams}` : `/api/v1/campaigns/${campaignId}/metrics`
}

/**
 * @summary Daily numbers over the last N of the account's own days
 */
export const getCampaignMetrics = async (campaignId: string,
    params?: GetCampaignMetricsParams, options?: Parameters<typeof apiFetch>[1]): Promise<GetCampaignMetrics200> => {

  return apiFetch<GetCampaignMetrics200>(getGetCampaignMetricsUrl(campaignId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCampaignMetricsQueryKey = (campaignId: string,
    params?: GetCampaignMetricsParams,) => {
    return [
    `/api/v1/campaigns/${campaignId}/metrics`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCampaignMetricsQueryOptions = <TData = Awaited<ReturnType<typeof getCampaignMetrics>>, TError = ErrorType<ErrorResponse>>(campaignId: string,
    params?: GetCampaignMetricsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignMetrics>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCampaignMetricsQueryKey(campaignId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCampaignMetrics>>> = ({ signal }) => getCampaignMetrics(campaignId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: campaignId !== null && campaignId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCampaignMetrics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCampaignMetricsQueryResult = NonNullable<Awaited<ReturnType<typeof getCampaignMetrics>>>
export type GetCampaignMetricsQueryError = ErrorType<ErrorResponse>


export function useGetCampaignMetrics<TData = Awaited<ReturnType<typeof getCampaignMetrics>>, TError = ErrorType<ErrorResponse>>(
 campaignId: string,
    params: undefined |  GetCampaignMetricsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignMetrics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaignMetrics>>,
          TError,
          Awaited<ReturnType<typeof getCampaignMetrics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignMetrics<TData = Awaited<ReturnType<typeof getCampaignMetrics>>, TError = ErrorType<ErrorResponse>>(
 campaignId: string,
    params?: GetCampaignMetricsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignMetrics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaignMetrics>>,
          TError,
          Awaited<ReturnType<typeof getCampaignMetrics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignMetrics<TData = Awaited<ReturnType<typeof getCampaignMetrics>>, TError = ErrorType<ErrorResponse>>(
 campaignId: string,
    params?: GetCampaignMetricsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignMetrics>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Daily numbers over the last N of the account's own days
 */

export function useGetCampaignMetrics<TData = Awaited<ReturnType<typeof getCampaignMetrics>>, TError = ErrorType<ErrorResponse>>(
 campaignId: string,
    params?: GetCampaignMetricsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignMetrics>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCampaignMetricsQueryOptions(campaignId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetCampaignCreativesUrl = (campaignId: string,) => {




  return `/api/v1/campaigns/${campaignId}/creatives`
}

/**
 * @summary The ad copy and images this campaign has
 */
export const getCampaignCreatives = async (campaignId: string, options?: Parameters<typeof apiFetch>[1]): Promise<GetCampaignCreatives200> => {

  return apiFetch<GetCampaignCreatives200>(getGetCampaignCreativesUrl(campaignId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCampaignCreativesQueryKey = (campaignId: string,) => {
    return [
    `/api/v1/campaigns/${campaignId}/creatives`
    ] as const;
    }


export const getGetCampaignCreativesQueryOptions = <TData = Awaited<ReturnType<typeof getCampaignCreatives>>, TError = ErrorType<ErrorResponse>>(campaignId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignCreatives>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCampaignCreativesQueryKey(campaignId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCampaignCreatives>>> = ({ signal }) => getCampaignCreatives(campaignId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: campaignId !== null && campaignId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCampaignCreatives>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCampaignCreativesQueryResult = NonNullable<Awaited<ReturnType<typeof getCampaignCreatives>>>
export type GetCampaignCreativesQueryError = ErrorType<ErrorResponse>


export function useGetCampaignCreatives<TData = Awaited<ReturnType<typeof getCampaignCreatives>>, TError = ErrorType<ErrorResponse>>(
 campaignId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignCreatives>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaignCreatives>>,
          TError,
          Awaited<ReturnType<typeof getCampaignCreatives>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignCreatives<TData = Awaited<ReturnType<typeof getCampaignCreatives>>, TError = ErrorType<ErrorResponse>>(
 campaignId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignCreatives>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaignCreatives>>,
          TError,
          Awaited<ReturnType<typeof getCampaignCreatives>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignCreatives<TData = Awaited<ReturnType<typeof getCampaignCreatives>>, TError = ErrorType<ErrorResponse>>(
 campaignId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignCreatives>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The ad copy and images this campaign has
 */

export function useGetCampaignCreatives<TData = Awaited<ReturnType<typeof getCampaignCreatives>>, TError = ErrorType<ErrorResponse>>(
 campaignId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignCreatives>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCampaignCreativesQueryOptions(campaignId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getReviewCampaignCopyUrl = (campaignId: string,
    variantId: string,) => {




  return `/api/v1/campaigns/${campaignId}/copy/${variantId}/review`
}

/**
 * @summary Approve staged campaign copy after reading it (owner or admin)
 */
export const reviewCampaignCopy = async (campaignId: string,
    variantId: string, options?: Parameters<typeof apiFetch>[1]): Promise<ReviewCampaignCopy200> => {

  return apiFetch<ReviewCampaignCopy200>(getReviewCampaignCopyUrl(campaignId,variantId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getReviewCampaignCopyMutationKey = () => ['reviewCampaignCopy'] as const;

export const getReviewCampaignCopyMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviewCampaignCopy>>, TError,ReviewCampaignCopyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reviewCampaignCopy>>, TError,ReviewCampaignCopyMutationVariables, TContext> => {

const mutationKey = getReviewCampaignCopyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reviewCampaignCopy>>, ReviewCampaignCopyMutationVariables> = (props) => {
          const {campaignId,variantId} = props ?? {};

          return  reviewCampaignCopy(campaignId,variantId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReviewCampaignCopyMutationResult = NonNullable<Awaited<ReturnType<typeof reviewCampaignCopy>>>

    export type ReviewCampaignCopyMutationError = ErrorType<ErrorResponse>
    export type ReviewCampaignCopyMutationVariables = {campaignId: string;variantId: string}

    /**
 * @summary Approve staged campaign copy after reading it (owner or admin)
 */
export const useReviewCampaignCopy = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviewCampaignCopy>>, TError,ReviewCampaignCopyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reviewCampaignCopy>>,
        TError,
        ReviewCampaignCopyMutationVariables,
        TContext
      > => {
      return useMutation(getReviewCampaignCopyMutationOptions(options), queryClient);
    }

export const getReviewCampaignImageUrl = (campaignId: string,
    assetId: string,) => {




  return `/api/v1/campaigns/${campaignId}/images/${assetId}/review`
}

/**
 * @summary Confirm a campaign image after visual inspection (owner or admin)
 */
export const reviewCampaignImage = async (campaignId: string,
    assetId: string, options?: Parameters<typeof apiFetch>[1]): Promise<ReviewCampaignImage200> => {

  return apiFetch<ReviewCampaignImage200>(getReviewCampaignImageUrl(campaignId,assetId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getReviewCampaignImageMutationKey = () => ['reviewCampaignImage'] as const;

export const getReviewCampaignImageMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviewCampaignImage>>, TError,ReviewCampaignImageMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reviewCampaignImage>>, TError,ReviewCampaignImageMutationVariables, TContext> => {

const mutationKey = getReviewCampaignImageMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reviewCampaignImage>>, ReviewCampaignImageMutationVariables> = (props) => {
          const {campaignId,assetId} = props ?? {};

          return  reviewCampaignImage(campaignId,assetId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReviewCampaignImageMutationResult = NonNullable<Awaited<ReturnType<typeof reviewCampaignImage>>>

    export type ReviewCampaignImageMutationError = ErrorType<ErrorResponse>
    export type ReviewCampaignImageMutationVariables = {campaignId: string;assetId: string}

    /**
 * @summary Confirm a campaign image after visual inspection (owner or admin)
 */
export const useReviewCampaignImage = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviewCampaignImage>>, TError,ReviewCampaignImageMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reviewCampaignImage>>,
        TError,
        ReviewCampaignImageMutationVariables,
        TContext
      > => {
      return useMutation(getReviewCampaignImageMutationOptions(options), queryClient);
    }

export const getGenerateCampaignCopyUrl = (campaignId: string,) => {




  return `/api/v1/campaigns/${campaignId}/copy`
}

/**
 * @summary Write ad copy for a campaign (owner or admin; costs credits)
 */
export const generateCampaignCopy = async (campaignId: string,
    generateCampaignCopyBody?: GenerateCampaignCopyBody, options?: Parameters<typeof apiFetch>[1]): Promise<GenerateCampaignCopy201> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return apiFetch<GenerateCampaignCopy201>(getGenerateCampaignCopyUrl(campaignId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(generateCampaignCopyBody)
  }
);}





export const getGenerateCampaignCopyMutationKey = () => ['generateCampaignCopy'] as const;

export const getGenerateCampaignCopyMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateCampaignCopy>>, TError,GenerateCampaignCopyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof generateCampaignCopy>>, TError,GenerateCampaignCopyMutationVariables, TContext> => {

const mutationKey = getGenerateCampaignCopyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateCampaignCopy>>, GenerateCampaignCopyMutationVariables> = (props) => {
          const {campaignId,data} = props ?? {};

          return  generateCampaignCopy(campaignId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateCampaignCopyMutationResult = NonNullable<Awaited<ReturnType<typeof generateCampaignCopy>>>
    export type GenerateCampaignCopyMutationBody = BodyType<GenerateCampaignCopyBody> | undefined
    export type GenerateCampaignCopyMutationError = ErrorType<ErrorResponse>
    export type GenerateCampaignCopyMutationVariables = {campaignId: string;data?: BodyType<GenerateCampaignCopyBody>}

    /**
 * @summary Write ad copy for a campaign (owner or admin; costs credits)
 */
export const useGenerateCampaignCopy = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateCampaignCopy>>, TError,GenerateCampaignCopyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateCampaignCopy>>,
        TError,
        GenerateCampaignCopyMutationVariables,
        TContext
      > => {
      return useMutation(getGenerateCampaignCopyMutationOptions(options), queryClient);
    }

export const getGenerateCampaignImagesUrl = (campaignId: string,) => {




  return `/api/v1/campaigns/${campaignId}/images`
}

/**
 * @summary Generate images for a campaign (owner or admin; costs one credit each)
 */
export const generateCampaignImages = async (campaignId: string,
    generateCampaignImagesBody?: GenerateCampaignImagesBody, options?: Parameters<typeof apiFetch>[1]): Promise<GenerateCampaignImages202> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return apiFetch<GenerateCampaignImages202>(getGenerateCampaignImagesUrl(campaignId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(generateCampaignImagesBody)
  }
);}





export const getGenerateCampaignImagesMutationKey = () => ['generateCampaignImages'] as const;

export const getGenerateCampaignImagesMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateCampaignImages>>, TError,GenerateCampaignImagesMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof generateCampaignImages>>, TError,GenerateCampaignImagesMutationVariables, TContext> => {

const mutationKey = getGenerateCampaignImagesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateCampaignImages>>, GenerateCampaignImagesMutationVariables> = (props) => {
          const {campaignId,data} = props ?? {};

          return  generateCampaignImages(campaignId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateCampaignImagesMutationResult = NonNullable<Awaited<ReturnType<typeof generateCampaignImages>>>
    export type GenerateCampaignImagesMutationBody = BodyType<GenerateCampaignImagesBody> | undefined
    export type GenerateCampaignImagesMutationError = ErrorType<ErrorResponse>
    export type GenerateCampaignImagesMutationVariables = {campaignId: string;data?: BodyType<GenerateCampaignImagesBody>}

    /**
 * @summary Generate images for a campaign (owner or admin; costs one credit each)
 */
export const useGenerateCampaignImages = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateCampaignImages>>, TError,GenerateCampaignImagesMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateCampaignImages>>,
        TError,
        GenerateCampaignImagesMutationVariables,
        TContext
      > => {
      return useMutation(getGenerateCampaignImagesMutationOptions(options), queryClient);
    }

export const getLaunchCampaignUrl = (campaignId: string,) => {




  return `/api/v1/campaigns/${campaignId}/launch`
}

/**
 * @summary Put a campaign live at its platform (owner or admin; starts spending)
 */
export const launchCampaign = async (campaignId: string,
    launchCampaignBody?: LaunchCampaignBody, options?: Parameters<typeof apiFetch>[1]): Promise<LaunchCampaign202> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return apiFetch<LaunchCampaign202>(getLaunchCampaignUrl(campaignId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(launchCampaignBody)
  }
);}





export const getLaunchCampaignMutationKey = () => ['launchCampaign'] as const;

export const getLaunchCampaignMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof launchCampaign>>, TError,LaunchCampaignMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof launchCampaign>>, TError,LaunchCampaignMutationVariables, TContext> => {

const mutationKey = getLaunchCampaignMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof launchCampaign>>, LaunchCampaignMutationVariables> = (props) => {
          const {campaignId,data} = props ?? {};

          return  launchCampaign(campaignId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LaunchCampaignMutationResult = NonNullable<Awaited<ReturnType<typeof launchCampaign>>>
    export type LaunchCampaignMutationBody = BodyType<LaunchCampaignBody> | undefined
    export type LaunchCampaignMutationError = ErrorType<ErrorResponse>
    export type LaunchCampaignMutationVariables = {campaignId: string;data?: BodyType<LaunchCampaignBody>}

    /**
 * @summary Put a campaign live at its platform (owner or admin; starts spending)
 */
export const useLaunchCampaign = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof launchCampaign>>, TError,LaunchCampaignMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof launchCampaign>>,
        TError,
        LaunchCampaignMutationVariables,
        TContext
      > => {
      return useMutation(getLaunchCampaignMutationOptions(options), queryClient);
    }

export const getPauseCampaignUrl = (campaignId: string,) => {




  return `/api/v1/campaigns/${campaignId}/pause`
}

/**
 * @summary Stop a campaign spending (owner or admin)
 */
export const pauseCampaign = async (campaignId: string, options?: Parameters<typeof apiFetch>[1]): Promise<PauseCampaign200> => {

  return apiFetch<PauseCampaign200>(getPauseCampaignUrl(campaignId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getPauseCampaignMutationKey = () => ['pauseCampaign'] as const;

export const getPauseCampaignMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pauseCampaign>>, TError,PauseCampaignMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof pauseCampaign>>, TError,PauseCampaignMutationVariables, TContext> => {

const mutationKey = getPauseCampaignMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pauseCampaign>>, PauseCampaignMutationVariables> = (props) => {
          const {campaignId} = props ?? {};

          return  pauseCampaign(campaignId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PauseCampaignMutationResult = NonNullable<Awaited<ReturnType<typeof pauseCampaign>>>

    export type PauseCampaignMutationError = ErrorType<ErrorResponse>
    export type PauseCampaignMutationVariables = {campaignId: string}

    /**
 * @summary Stop a campaign spending (owner or admin)
 */
export const usePauseCampaign = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pauseCampaign>>, TError,PauseCampaignMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof pauseCampaign>>,
        TError,
        PauseCampaignMutationVariables,
        TContext
      > => {
      return useMutation(getPauseCampaignMutationOptions(options), queryClient);
    }

export const getResumeCampaignUrl = (campaignId: string,) => {




  return `/api/v1/campaigns/${campaignId}/resume`
}

/**
 * @summary Let a paused campaign spend again (owner or admin)
 */
export const resumeCampaign = async (campaignId: string, options?: Parameters<typeof apiFetch>[1]): Promise<ResumeCampaign200> => {

  return apiFetch<ResumeCampaign200>(getResumeCampaignUrl(campaignId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getResumeCampaignMutationKey = () => ['resumeCampaign'] as const;

export const getResumeCampaignMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resumeCampaign>>, TError,ResumeCampaignMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resumeCampaign>>, TError,ResumeCampaignMutationVariables, TContext> => {

const mutationKey = getResumeCampaignMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resumeCampaign>>, ResumeCampaignMutationVariables> = (props) => {
          const {campaignId} = props ?? {};

          return  resumeCampaign(campaignId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResumeCampaignMutationResult = NonNullable<Awaited<ReturnType<typeof resumeCampaign>>>

    export type ResumeCampaignMutationError = ErrorType<ErrorResponse>
    export type ResumeCampaignMutationVariables = {campaignId: string}

    /**
 * @summary Let a paused campaign spend again (owner or admin)
 */
export const useResumeCampaign = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resumeCampaign>>, TError,ResumeCampaignMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resumeCampaign>>,
        TError,
        ResumeCampaignMutationVariables,
        TContext
      > => {
      return useMutation(getResumeCampaignMutationOptions(options), queryClient);
    }

export const getChangeCampaignBudgetUrl = (campaignId: string,) => {




  return `/api/v1/campaigns/${campaignId}/budget`
}

/**
 * @summary Change a daily budget, by at most 25% in one step (owner or admin)
 */
export const changeCampaignBudget = async (campaignId: string,
    changeCampaignBudgetBody: ChangeCampaignBudgetBody, options?: Parameters<typeof apiFetch>[1]): Promise<ChangeCampaignBudget200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return apiFetch<ChangeCampaignBudget200>(getChangeCampaignBudgetUrl(campaignId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(changeCampaignBudgetBody)
  }
);}





export const getChangeCampaignBudgetMutationKey = () => ['changeCampaignBudget'] as const;

export const getChangeCampaignBudgetMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeCampaignBudget>>, TError,ChangeCampaignBudgetMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof changeCampaignBudget>>, TError,ChangeCampaignBudgetMutationVariables, TContext> => {

const mutationKey = getChangeCampaignBudgetMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeCampaignBudget>>, ChangeCampaignBudgetMutationVariables> = (props) => {
          const {campaignId,data} = props ?? {};

          return  changeCampaignBudget(campaignId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChangeCampaignBudgetMutationResult = NonNullable<Awaited<ReturnType<typeof changeCampaignBudget>>>
    export type ChangeCampaignBudgetMutationBody = BodyType<ChangeCampaignBudgetBody>
    export type ChangeCampaignBudgetMutationError = ErrorType<ErrorResponse>
    export type ChangeCampaignBudgetMutationVariables = {campaignId: string;data: BodyType<ChangeCampaignBudgetBody>}

    /**
 * @summary Change a daily budget, by at most 25% in one step (owner or admin)
 */
export const useChangeCampaignBudget = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeCampaignBudget>>, TError,ChangeCampaignBudgetMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changeCampaignBudget>>,
        TError,
        ChangeCampaignBudgetMutationVariables,
        TContext
      > => {
      return useMutation(getChangeCampaignBudgetMutationOptions(options), queryClient);
    }

export const getListCampaignVideosUrl = (campaignId: string,) => {




  return `/api/v1/campaigns/${campaignId}/videos`
}

/**
 * @summary Video scripts for a campaign, with the state of each render
 */
export const listCampaignVideos = async (campaignId: string, options?: Parameters<typeof apiFetch>[1]): Promise<ListCampaignVideos200> => {

  return apiFetch<ListCampaignVideos200>(getListCampaignVideosUrl(campaignId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCampaignVideosQueryKey = (campaignId: string,) => {
    return [
    `/api/v1/campaigns/${campaignId}/videos`
    ] as const;
    }


export const getListCampaignVideosQueryOptions = <TData = Awaited<ReturnType<typeof listCampaignVideos>>, TError = ErrorType<ErrorResponse>>(campaignId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampaignVideos>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCampaignVideosQueryKey(campaignId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCampaignVideos>>> = ({ signal }) => listCampaignVideos(campaignId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: campaignId !== null && campaignId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCampaignVideos>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCampaignVideosQueryResult = NonNullable<Awaited<ReturnType<typeof listCampaignVideos>>>
export type ListCampaignVideosQueryError = ErrorType<ErrorResponse>


export function useListCampaignVideos<TData = Awaited<ReturnType<typeof listCampaignVideos>>, TError = ErrorType<ErrorResponse>>(
 campaignId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampaignVideos>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCampaignVideos>>,
          TError,
          Awaited<ReturnType<typeof listCampaignVideos>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCampaignVideos<TData = Awaited<ReturnType<typeof listCampaignVideos>>, TError = ErrorType<ErrorResponse>>(
 campaignId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampaignVideos>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCampaignVideos>>,
          TError,
          Awaited<ReturnType<typeof listCampaignVideos>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCampaignVideos<TData = Awaited<ReturnType<typeof listCampaignVideos>>, TError = ErrorType<ErrorResponse>>(
 campaignId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampaignVideos>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Video scripts for a campaign, with the state of each render
 */

export function useListCampaignVideos<TData = Awaited<ReturnType<typeof listCampaignVideos>>, TError = ErrorType<ErrorResponse>>(
 campaignId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampaignVideos>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCampaignVideosQueryOptions(campaignId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGenerateCampaignVideoUrl = (campaignId: string,) => {




  return `/api/v1/campaigns/${campaignId}/videos`
}

/**
 * @summary Write a three-scene video script (owner or admin; costs credits)
 */
export const generateCampaignVideo = async (campaignId: string,
    generateCampaignVideoBody?: GenerateCampaignVideoBody, options?: Parameters<typeof apiFetch>[1]): Promise<GenerateCampaignVideo201> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return apiFetch<GenerateCampaignVideo201>(getGenerateCampaignVideoUrl(campaignId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(generateCampaignVideoBody)
  }
);}





export const getGenerateCampaignVideoMutationKey = () => ['generateCampaignVideo'] as const;

export const getGenerateCampaignVideoMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateCampaignVideo>>, TError,GenerateCampaignVideoMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof generateCampaignVideo>>, TError,GenerateCampaignVideoMutationVariables, TContext> => {

const mutationKey = getGenerateCampaignVideoMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateCampaignVideo>>, GenerateCampaignVideoMutationVariables> = (props) => {
          const {campaignId,data} = props ?? {};

          return  generateCampaignVideo(campaignId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateCampaignVideoMutationResult = NonNullable<Awaited<ReturnType<typeof generateCampaignVideo>>>
    export type GenerateCampaignVideoMutationBody = BodyType<GenerateCampaignVideoBody> | undefined
    export type GenerateCampaignVideoMutationError = ErrorType<ErrorResponse>
    export type GenerateCampaignVideoMutationVariables = {campaignId: string;data?: BodyType<GenerateCampaignVideoBody>}

    /**
 * @summary Write a three-scene video script (owner or admin; costs credits)
 */
export const useGenerateCampaignVideo = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateCampaignVideo>>, TError,GenerateCampaignVideoMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateCampaignVideo>>,
        TError,
        GenerateCampaignVideoMutationVariables,
        TContext
      > => {
      return useMutation(getGenerateCampaignVideoMutationOptions(options), queryClient);
    }

export const getRequestVideoRenderUrl = (videoScriptId: string,) => {




  return `/api/v1/videos/${videoScriptId}/render`
}

/**
 * @summary Queue this video for rendering (owner or admin)
 */
export const requestVideoRender = async (videoScriptId: string, options?: Parameters<typeof apiFetch>[1]): Promise<RequestVideoRender202> => {

  return apiFetch<RequestVideoRender202>(getRequestVideoRenderUrl(videoScriptId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRequestVideoRenderMutationKey = () => ['requestVideoRender'] as const;

export const getRequestVideoRenderMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestVideoRender>>, TError,RequestVideoRenderMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestVideoRender>>, TError,RequestVideoRenderMutationVariables, TContext> => {

const mutationKey = getRequestVideoRenderMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestVideoRender>>, RequestVideoRenderMutationVariables> = (props) => {
          const {videoScriptId} = props ?? {};

          return  requestVideoRender(videoScriptId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestVideoRenderMutationResult = NonNullable<Awaited<ReturnType<typeof requestVideoRender>>>

    export type RequestVideoRenderMutationError = ErrorType<ErrorResponse>
    export type RequestVideoRenderMutationVariables = {videoScriptId: string}

    /**
 * @summary Queue this video for rendering (owner or admin)
 */
export const useRequestVideoRender = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestVideoRender>>, TError,RequestVideoRenderMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requestVideoRender>>,
        TError,
        RequestVideoRenderMutationVariables,
        TContext
      > => {
      return useMutation(getRequestVideoRenderMutationOptions(options), queryClient);
    }

export const getLinkHostedVideoUrl = (videoScriptId: string,) => {




  return `/api/v1/videos/${videoScriptId}/hosted`
}

/**
 * @summary Link a YouTube video for a Google campaign (owner or admin)
 */
export const linkHostedVideo = async (videoScriptId: string,
    linkHostedVideoBody?: LinkHostedVideoBody, options?: Parameters<typeof apiFetch>[1]): Promise<LinkHostedVideo200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return apiFetch<LinkHostedVideo200>(getLinkHostedVideoUrl(videoScriptId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(linkHostedVideoBody)
  }
);}





export const getLinkHostedVideoMutationKey = () => ['linkHostedVideo'] as const;

export const getLinkHostedVideoMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkHostedVideo>>, TError,LinkHostedVideoMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof linkHostedVideo>>, TError,LinkHostedVideoMutationVariables, TContext> => {

const mutationKey = getLinkHostedVideoMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof linkHostedVideo>>, LinkHostedVideoMutationVariables> = (props) => {
          const {videoScriptId,data} = props ?? {};

          return  linkHostedVideo(videoScriptId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LinkHostedVideoMutationResult = NonNullable<Awaited<ReturnType<typeof linkHostedVideo>>>
    export type LinkHostedVideoMutationBody = BodyType<LinkHostedVideoBody> | undefined
    export type LinkHostedVideoMutationError = ErrorType<ErrorResponse>
    export type LinkHostedVideoMutationVariables = {videoScriptId: string;data?: BodyType<LinkHostedVideoBody>}

    /**
 * @summary Link a YouTube video for a Google campaign (owner or admin)
 */
export const useLinkHostedVideo = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkHostedVideo>>, TError,LinkHostedVideoMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof linkHostedVideo>>,
        TError,
        LinkHostedVideoMutationVariables,
        TContext
      > => {
      return useMutation(getLinkHostedVideoMutationOptions(options), queryClient);
    }

export const getListCampaignStoriesUrl = (campaignId: string,) => {




  return `/api/v1/campaigns/${campaignId}/stories`
}

/**
 * @summary Three-act ad sequences for a campaign
 */
export const listCampaignStories = async (campaignId: string, options?: Parameters<typeof apiFetch>[1]): Promise<ListCampaignStories200> => {

  return apiFetch<ListCampaignStories200>(getListCampaignStoriesUrl(campaignId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCampaignStoriesQueryKey = (campaignId: string,) => {
    return [
    `/api/v1/campaigns/${campaignId}/stories`
    ] as const;
    }


export const getListCampaignStoriesQueryOptions = <TData = Awaited<ReturnType<typeof listCampaignStories>>, TError = ErrorType<ErrorResponse>>(campaignId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampaignStories>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCampaignStoriesQueryKey(campaignId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCampaignStories>>> = ({ signal }) => listCampaignStories(campaignId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: campaignId !== null && campaignId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCampaignStories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCampaignStoriesQueryResult = NonNullable<Awaited<ReturnType<typeof listCampaignStories>>>
export type ListCampaignStoriesQueryError = ErrorType<ErrorResponse>


export function useListCampaignStories<TData = Awaited<ReturnType<typeof listCampaignStories>>, TError = ErrorType<ErrorResponse>>(
 campaignId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampaignStories>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCampaignStories>>,
          TError,
          Awaited<ReturnType<typeof listCampaignStories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCampaignStories<TData = Awaited<ReturnType<typeof listCampaignStories>>, TError = ErrorType<ErrorResponse>>(
 campaignId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampaignStories>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCampaignStories>>,
          TError,
          Awaited<ReturnType<typeof listCampaignStories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCampaignStories<TData = Awaited<ReturnType<typeof listCampaignStories>>, TError = ErrorType<ErrorResponse>>(
 campaignId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampaignStories>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Three-act ad sequences for a campaign
 */

export function useListCampaignStories<TData = Awaited<ReturnType<typeof listCampaignStories>>, TError = ErrorType<ErrorResponse>>(
 campaignId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCampaignStories>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCampaignStoriesQueryOptions(campaignId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGenerateCampaignStoryUrl = (campaignId: string,) => {




  return `/api/v1/campaigns/${campaignId}/stories`
}

/**
 * @summary Write a three-act ad sequence (owner or admin; costs credits)
 */
export const generateCampaignStory = async (campaignId: string, options?: Parameters<typeof apiFetch>[1]): Promise<GenerateCampaignStory201> => {

  return apiFetch<GenerateCampaignStory201>(getGenerateCampaignStoryUrl(campaignId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getGenerateCampaignStoryMutationKey = () => ['generateCampaignStory'] as const;

export const getGenerateCampaignStoryMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateCampaignStory>>, TError,GenerateCampaignStoryMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof generateCampaignStory>>, TError,GenerateCampaignStoryMutationVariables, TContext> => {

const mutationKey = getGenerateCampaignStoryMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateCampaignStory>>, GenerateCampaignStoryMutationVariables> = (props) => {
          const {campaignId} = props ?? {};

          return  generateCampaignStory(campaignId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateCampaignStoryMutationResult = NonNullable<Awaited<ReturnType<typeof generateCampaignStory>>>

    export type GenerateCampaignStoryMutationError = ErrorType<ErrorResponse>
    export type GenerateCampaignStoryMutationVariables = {campaignId: string}

    /**
 * @summary Write a three-act ad sequence (owner or admin; costs credits)
 */
export const useGenerateCampaignStory = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateCampaignStory>>, TError,GenerateCampaignStoryMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateCampaignStory>>,
        TError,
        GenerateCampaignStoryMutationVariables,
        TContext
      > => {
      return useMutation(getGenerateCampaignStoryMutationOptions(options), queryClient);
    }

export const getListAudiencesUrl = () => {




  return `/api/v1/audiences`
}

/**
 * @summary Retargeting audiences and how each platform's copy is doing
 */
export const listAudiences = async ( options?: Parameters<typeof apiFetch>[1]): Promise<ListAudiences200> => {

  return apiFetch<ListAudiences200>(getListAudiencesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAudiencesQueryKey = () => {
    return [
    `/api/v1/audiences`
    ] as const;
    }


export const getListAudiencesQueryOptions = <TData = Awaited<ReturnType<typeof listAudiences>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAudiences>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAudiencesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAudiences>>> = ({ signal }) => listAudiences({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAudiences>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAudiencesQueryResult = NonNullable<Awaited<ReturnType<typeof listAudiences>>>
export type ListAudiencesQueryError = ErrorType<ErrorResponse>


export function useListAudiences<TData = Awaited<ReturnType<typeof listAudiences>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAudiences>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAudiences>>,
          TError,
          Awaited<ReturnType<typeof listAudiences>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAudiences<TData = Awaited<ReturnType<typeof listAudiences>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAudiences>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAudiences>>,
          TError,
          Awaited<ReturnType<typeof listAudiences>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAudiences<TData = Awaited<ReturnType<typeof listAudiences>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAudiences>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retargeting audiences and how each platform's copy is doing
 */

export function useListAudiences<TData = Awaited<ReturnType<typeof listAudiences>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAudiences>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAudiencesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetRetargetingStateUrl = () => {




  return `/api/v1/audiences/retargeting`
}

/**
 * @summary Whether retargeting can run, and which campaigns already carry a layer
 */
export const getRetargetingState = async ( options?: Parameters<typeof apiFetch>[1]): Promise<GetRetargetingState200> => {

  return apiFetch<GetRetargetingState200>(getGetRetargetingStateUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRetargetingStateQueryKey = () => {
    return [
    `/api/v1/audiences/retargeting`
    ] as const;
    }


export const getGetRetargetingStateQueryOptions = <TData = Awaited<ReturnType<typeof getRetargetingState>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRetargetingState>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRetargetingStateQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRetargetingState>>> = ({ signal }) => getRetargetingState({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRetargetingState>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRetargetingStateQueryResult = NonNullable<Awaited<ReturnType<typeof getRetargetingState>>>
export type GetRetargetingStateQueryError = ErrorType<ErrorResponse>


export function useGetRetargetingState<TData = Awaited<ReturnType<typeof getRetargetingState>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRetargetingState>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRetargetingState>>,
          TError,
          Awaited<ReturnType<typeof getRetargetingState>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRetargetingState<TData = Awaited<ReturnType<typeof getRetargetingState>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRetargetingState>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRetargetingState>>,
          TError,
          Awaited<ReturnType<typeof getRetargetingState>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRetargetingState<TData = Awaited<ReturnType<typeof getRetargetingState>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRetargetingState>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Whether retargeting can run, and which campaigns already carry a layer
 */

export function useGetRetargetingState<TData = Awaited<ReturnType<typeof getRetargetingState>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRetargetingState>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRetargetingStateQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetTrackingSettingsUrl = () => {




  return `/api/v1/tracking/settings`
}

/**
 * @summary Install snippet, rules, keys and pixel
 */
export const getTrackingSettings = async ( options?: Parameters<typeof apiFetch>[1]): Promise<GetTrackingSettings200> => {

  return apiFetch<GetTrackingSettings200>(getGetTrackingSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTrackingSettingsQueryKey = () => {
    return [
    `/api/v1/tracking/settings`
    ] as const;
    }


export const getGetTrackingSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getTrackingSettings>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrackingSettings>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTrackingSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrackingSettings>>> = ({ signal }) => getTrackingSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTrackingSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTrackingSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getTrackingSettings>>>
export type GetTrackingSettingsQueryError = ErrorType<ErrorResponse>


export function useGetTrackingSettings<TData = Awaited<ReturnType<typeof getTrackingSettings>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrackingSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrackingSettings>>,
          TError,
          Awaited<ReturnType<typeof getTrackingSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrackingSettings<TData = Awaited<ReturnType<typeof getTrackingSettings>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrackingSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrackingSettings>>,
          TError,
          Awaited<ReturnType<typeof getTrackingSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrackingSettings<TData = Awaited<ReturnType<typeof getTrackingSettings>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrackingSettings>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Install snippet, rules, keys and pixel
 */

export function useGetTrackingSettings<TData = Awaited<ReturnType<typeof getTrackingSettings>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrackingSettings>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTrackingSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateTrackingSettingsUrl = () => {




  return `/api/v1/tracking/settings`
}

/**
 * @summary Register the site the snippet runs on
 */
export const updateTrackingSettings = async (updateTrackingSettingsBody: UpdateTrackingSettingsBody, options?: Parameters<typeof apiFetch>[1]): Promise<UpdateTrackingSettings200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return apiFetch<UpdateTrackingSettings200>(getUpdateTrackingSettingsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateTrackingSettingsBody)
  }
);}





export const getUpdateTrackingSettingsMutationKey = () => ['updateTrackingSettings'] as const;

export const getUpdateTrackingSettingsMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTrackingSettings>>, TError,UpdateTrackingSettingsMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTrackingSettings>>, TError,UpdateTrackingSettingsMutationVariables, TContext> => {

const mutationKey = getUpdateTrackingSettingsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTrackingSettings>>, UpdateTrackingSettingsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateTrackingSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTrackingSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateTrackingSettings>>>
    export type UpdateTrackingSettingsMutationBody = BodyType<UpdateTrackingSettingsBody>
    export type UpdateTrackingSettingsMutationError = ErrorType<ErrorResponse>
    export type UpdateTrackingSettingsMutationVariables = {data: BodyType<UpdateTrackingSettingsBody>}

    /**
 * @summary Register the site the snippet runs on
 */
export const useUpdateTrackingSettings = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTrackingSettings>>, TError,UpdateTrackingSettingsMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateTrackingSettings>>,
        TError,
        UpdateTrackingSettingsMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateTrackingSettingsMutationOptions(options), queryClient);
    }

export const getGetTrackingHealthUrl = () => {




  return `/api/v1/tracking/health`
}

/**
 * @summary Whether tracking is working, and if not, why
 */
export const getTrackingHealth = async ( options?: Parameters<typeof apiFetch>[1]): Promise<GetTrackingHealth200> => {

  return apiFetch<GetTrackingHealth200>(getGetTrackingHealthUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTrackingHealthQueryKey = () => {
    return [
    `/api/v1/tracking/health`
    ] as const;
    }


export const getGetTrackingHealthQueryOptions = <TData = Awaited<ReturnType<typeof getTrackingHealth>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrackingHealth>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTrackingHealthQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrackingHealth>>> = ({ signal }) => getTrackingHealth({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTrackingHealth>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTrackingHealthQueryResult = NonNullable<Awaited<ReturnType<typeof getTrackingHealth>>>
export type GetTrackingHealthQueryError = ErrorType<ErrorResponse>


export function useGetTrackingHealth<TData = Awaited<ReturnType<typeof getTrackingHealth>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrackingHealth>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrackingHealth>>,
          TError,
          Awaited<ReturnType<typeof getTrackingHealth>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrackingHealth<TData = Awaited<ReturnType<typeof getTrackingHealth>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrackingHealth>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrackingHealth>>,
          TError,
          Awaited<ReturnType<typeof getTrackingHealth>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTrackingHealth<TData = Awaited<ReturnType<typeof getTrackingHealth>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrackingHealth>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Whether tracking is working, and if not, why
 */

export function useGetTrackingHealth<TData = Awaited<ReturnType<typeof getTrackingHealth>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTrackingHealth>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTrackingHealthQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateConversionRuleUrl = () => {




  return `/api/v1/tracking/rules`
}

/**
 * @summary Say what a conversion is
 */
export const createConversionRule = async (createConversionRuleBody: CreateConversionRuleBody, options?: Parameters<typeof apiFetch>[1]): Promise<CreateConversionRule201> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return apiFetch<CreateConversionRule201>(getCreateConversionRuleUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createConversionRuleBody)
  }
);}





export const getCreateConversionRuleMutationKey = () => ['createConversionRule'] as const;

export const getCreateConversionRuleMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createConversionRule>>, TError,CreateConversionRuleMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createConversionRule>>, TError,CreateConversionRuleMutationVariables, TContext> => {

const mutationKey = getCreateConversionRuleMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createConversionRule>>, CreateConversionRuleMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createConversionRule(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateConversionRuleMutationResult = NonNullable<Awaited<ReturnType<typeof createConversionRule>>>
    export type CreateConversionRuleMutationBody = BodyType<CreateConversionRuleBody>
    export type CreateConversionRuleMutationError = ErrorType<ErrorResponse>
    export type CreateConversionRuleMutationVariables = {data: BodyType<CreateConversionRuleBody>}

    /**
 * @summary Say what a conversion is
 */
export const useCreateConversionRule = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createConversionRule>>, TError,CreateConversionRuleMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createConversionRule>>,
        TError,
        CreateConversionRuleMutationVariables,
        TContext
      > => {
      return useMutation(getCreateConversionRuleMutationOptions(options), queryClient);
    }

export const getConfirmConversionRuleUrl = (ruleId: string,) => {




  return `/api/v1/tracking/rules/${ruleId}/confirm`
}

/**
 * @summary Stand behind a rule that was guessed
 */
export const confirmConversionRule = async (ruleId: string, options?: Parameters<typeof apiFetch>[1]): Promise<ConfirmConversionRule200> => {

  return apiFetch<ConfirmConversionRule200>(getConfirmConversionRuleUrl(ruleId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getConfirmConversionRuleMutationKey = () => ['confirmConversionRule'] as const;

export const getConfirmConversionRuleMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmConversionRule>>, TError,ConfirmConversionRuleMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof confirmConversionRule>>, TError,ConfirmConversionRuleMutationVariables, TContext> => {

const mutationKey = getConfirmConversionRuleMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmConversionRule>>, ConfirmConversionRuleMutationVariables> = (props) => {
          const {ruleId} = props ?? {};

          return  confirmConversionRule(ruleId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmConversionRuleMutationResult = NonNullable<Awaited<ReturnType<typeof confirmConversionRule>>>

    export type ConfirmConversionRuleMutationError = ErrorType<ErrorResponse>
    export type ConfirmConversionRuleMutationVariables = {ruleId: string}

    /**
 * @summary Stand behind a rule that was guessed
 */
export const useConfirmConversionRule = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmConversionRule>>, TError,ConfirmConversionRuleMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof confirmConversionRule>>,
        TError,
        ConfirmConversionRuleMutationVariables,
        TContext
      > => {
      return useMutation(getConfirmConversionRuleMutationOptions(options), queryClient);
    }

export const getDeleteConversionRuleUrl = (ruleId: string,) => {




  return `/api/v1/tracking/rules/${ruleId}`
}

/**
 * @summary Remove a rule
 */
export const deleteConversionRule = async (ruleId: string, options?: Parameters<typeof apiFetch>[1]): Promise<void> => {

  return apiFetch<void>(getDeleteConversionRuleUrl(ruleId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteConversionRuleMutationKey = () => ['deleteConversionRule'] as const;

export const getDeleteConversionRuleMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteConversionRule>>, TError,DeleteConversionRuleMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteConversionRule>>, TError,DeleteConversionRuleMutationVariables, TContext> => {

const mutationKey = getDeleteConversionRuleMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteConversionRule>>, DeleteConversionRuleMutationVariables> = (props) => {
          const {ruleId} = props ?? {};

          return  deleteConversionRule(ruleId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteConversionRuleMutationResult = NonNullable<Awaited<ReturnType<typeof deleteConversionRule>>>

    export type DeleteConversionRuleMutationError = ErrorType<ErrorResponse>
    export type DeleteConversionRuleMutationVariables = {ruleId: string}

    /**
 * @summary Remove a rule
 */
export const useDeleteConversionRule = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteConversionRule>>, TError,DeleteConversionRuleMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteConversionRule>>,
        TError,
        DeleteConversionRuleMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteConversionRuleMutationOptions(options), queryClient);
    }

export const getListConversionCandidatesUrl = () => {




  return `/api/v1/tracking/candidates`
}

/**
 * @summary Signals the snippet noticed, and the likeliest one
 */
export const listConversionCandidates = async ( options?: Parameters<typeof apiFetch>[1]): Promise<ListConversionCandidates200> => {

  return apiFetch<ListConversionCandidates200>(getListConversionCandidatesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListConversionCandidatesQueryKey = () => {
    return [
    `/api/v1/tracking/candidates`
    ] as const;
    }


export const getListConversionCandidatesQueryOptions = <TData = Awaited<ReturnType<typeof listConversionCandidates>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConversionCandidates>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListConversionCandidatesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listConversionCandidates>>> = ({ signal }) => listConversionCandidates({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listConversionCandidates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListConversionCandidatesQueryResult = NonNullable<Awaited<ReturnType<typeof listConversionCandidates>>>
export type ListConversionCandidatesQueryError = ErrorType<ErrorResponse>


export function useListConversionCandidates<TData = Awaited<ReturnType<typeof listConversionCandidates>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConversionCandidates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listConversionCandidates>>,
          TError,
          Awaited<ReturnType<typeof listConversionCandidates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListConversionCandidates<TData = Awaited<ReturnType<typeof listConversionCandidates>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConversionCandidates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listConversionCandidates>>,
          TError,
          Awaited<ReturnType<typeof listConversionCandidates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListConversionCandidates<TData = Awaited<ReturnType<typeof listConversionCandidates>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConversionCandidates>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Signals the snippet noticed, and the likeliest one
 */

export function useListConversionCandidates<TData = Awaited<ReturnType<typeof listConversionCandidates>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConversionCandidates>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListConversionCandidatesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListMetaPixelsUrl = () => {




  return `/api/v1/tracking/pixels`
}

/**
 * @summary The Meta account's pixels
 */
export const listMetaPixels = async ( options?: Parameters<typeof apiFetch>[1]): Promise<ListMetaPixels200> => {

  return apiFetch<ListMetaPixels200>(getListMetaPixelsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMetaPixelsQueryKey = () => {
    return [
    `/api/v1/tracking/pixels`
    ] as const;
    }


export const getListMetaPixelsQueryOptions = <TData = Awaited<ReturnType<typeof listMetaPixels>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMetaPixels>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMetaPixelsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMetaPixels>>> = ({ signal }) => listMetaPixels({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMetaPixels>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMetaPixelsQueryResult = NonNullable<Awaited<ReturnType<typeof listMetaPixels>>>
export type ListMetaPixelsQueryError = ErrorType<ErrorResponse>


export function useListMetaPixels<TData = Awaited<ReturnType<typeof listMetaPixels>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMetaPixels>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMetaPixels>>,
          TError,
          Awaited<ReturnType<typeof listMetaPixels>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMetaPixels<TData = Awaited<ReturnType<typeof listMetaPixels>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMetaPixels>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMetaPixels>>,
          TError,
          Awaited<ReturnType<typeof listMetaPixels>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMetaPixels<TData = Awaited<ReturnType<typeof listMetaPixels>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMetaPixels>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The Meta account's pixels
 */

export function useListMetaPixels<TData = Awaited<ReturnType<typeof listMetaPixels>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMetaPixels>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMetaPixelsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSelectMetaPixelUrl = () => {




  return `/api/v1/tracking/pixel`
}

/**
 * @summary Choose which pixel the snippet fires
 */
export const selectMetaPixel = async (selectMetaPixelBody: SelectMetaPixelBody, options?: Parameters<typeof apiFetch>[1]): Promise<SelectMetaPixel200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return apiFetch<SelectMetaPixel200>(getSelectMetaPixelUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(selectMetaPixelBody)
  }
);}





export const getSelectMetaPixelMutationKey = () => ['selectMetaPixel'] as const;

export const getSelectMetaPixelMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof selectMetaPixel>>, TError,SelectMetaPixelMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof selectMetaPixel>>, TError,SelectMetaPixelMutationVariables, TContext> => {

const mutationKey = getSelectMetaPixelMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof selectMetaPixel>>, SelectMetaPixelMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  selectMetaPixel(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SelectMetaPixelMutationResult = NonNullable<Awaited<ReturnType<typeof selectMetaPixel>>>
    export type SelectMetaPixelMutationBody = BodyType<SelectMetaPixelBody>
    export type SelectMetaPixelMutationError = ErrorType<ErrorResponse>
    export type SelectMetaPixelMutationVariables = {data: BodyType<SelectMetaPixelBody>}

    /**
 * @summary Choose which pixel the snippet fires
 */
export const useSelectMetaPixel = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof selectMetaPixel>>, TError,SelectMetaPixelMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof selectMetaPixel>>,
        TError,
        SelectMetaPixelMutationVariables,
        TContext
      > => {
      return useMutation(getSelectMetaPixelMutationOptions(options), queryClient);
    }

export const getClearMetaPixelUrl = () => {




  return `/api/v1/tracking/pixel`
}

/**
 * @summary Stop firing a pixel
 */
export const clearMetaPixel = async ( options?: Parameters<typeof apiFetch>[1]): Promise<ClearMetaPixel200> => {

  return apiFetch<ClearMetaPixel200>(getClearMetaPixelUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getClearMetaPixelMutationKey = () => ['clearMetaPixel'] as const;

export const getClearMetaPixelMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearMetaPixel>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof clearMetaPixel>>, TError,void, TContext> => {

const mutationKey = getClearMetaPixelMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clearMetaPixel>>, void> = () => {


          return  clearMetaPixel(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClearMetaPixelMutationResult = NonNullable<Awaited<ReturnType<typeof clearMetaPixel>>>

    export type ClearMetaPixelMutationError = ErrorType<ErrorResponse>


    /**
 * @summary Stop firing a pixel
 */
export const useClearMetaPixel = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearMetaPixel>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clearMetaPixel>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getClearMetaPixelMutationOptions(options), queryClient);
    }

export const getCreateTrackingApiKeyUrl = () => {




  return `/api/v1/tracking/api-keys`
}

/**
 * @summary Mint a server-side key (owner or admin, recently authenticated)
 */
export const createTrackingApiKey = async (createTrackingApiKeyBody: CreateTrackingApiKeyBody, options?: Parameters<typeof apiFetch>[1]): Promise<CreateTrackingApiKey201> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return apiFetch<CreateTrackingApiKey201>(getCreateTrackingApiKeyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createTrackingApiKeyBody)
  }
);}





export const getCreateTrackingApiKeyMutationKey = () => ['createTrackingApiKey'] as const;

export const getCreateTrackingApiKeyMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTrackingApiKey>>, TError,CreateTrackingApiKeyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTrackingApiKey>>, TError,CreateTrackingApiKeyMutationVariables, TContext> => {

const mutationKey = getCreateTrackingApiKeyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTrackingApiKey>>, CreateTrackingApiKeyMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createTrackingApiKey(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTrackingApiKeyMutationResult = NonNullable<Awaited<ReturnType<typeof createTrackingApiKey>>>
    export type CreateTrackingApiKeyMutationBody = BodyType<CreateTrackingApiKeyBody>
    export type CreateTrackingApiKeyMutationError = ErrorType<ErrorResponse>
    export type CreateTrackingApiKeyMutationVariables = {data: BodyType<CreateTrackingApiKeyBody>}

    /**
 * @summary Mint a server-side key (owner or admin, recently authenticated)
 */
export const useCreateTrackingApiKey = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTrackingApiKey>>, TError,CreateTrackingApiKeyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createTrackingApiKey>>,
        TError,
        CreateTrackingApiKeyMutationVariables,
        TContext
      > => {
      return useMutation(getCreateTrackingApiKeyMutationOptions(options), queryClient);
    }

export const getRevokeTrackingApiKeyUrl = (keyId: string,) => {




  return `/api/v1/tracking/api-keys/${keyId}`
}

/**
 * @summary Revoke a server-side key (owner or admin, recently authenticated)
 */
export const revokeTrackingApiKey = async (keyId: string, options?: Parameters<typeof apiFetch>[1]): Promise<void> => {

  return apiFetch<void>(getRevokeTrackingApiKeyUrl(keyId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRevokeTrackingApiKeyMutationKey = () => ['revokeTrackingApiKey'] as const;

export const getRevokeTrackingApiKeyMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeTrackingApiKey>>, TError,RevokeTrackingApiKeyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeTrackingApiKey>>, TError,RevokeTrackingApiKeyMutationVariables, TContext> => {

const mutationKey = getRevokeTrackingApiKeyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeTrackingApiKey>>, RevokeTrackingApiKeyMutationVariables> = (props) => {
          const {keyId} = props ?? {};

          return  revokeTrackingApiKey(keyId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeTrackingApiKeyMutationResult = NonNullable<Awaited<ReturnType<typeof revokeTrackingApiKey>>>

    export type RevokeTrackingApiKeyMutationError = ErrorType<ErrorResponse>
    export type RevokeTrackingApiKeyMutationVariables = {keyId: string}

    /**
 * @summary Revoke a server-side key (owner or admin, recently authenticated)
 */
export const useRevokeTrackingApiKey = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeTrackingApiKey>>, TError,RevokeTrackingApiKeyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof revokeTrackingApiKey>>,
        TError,
        RevokeTrackingApiKeyMutationVariables,
        TContext
      > => {
      return useMutation(getRevokeTrackingApiKeyMutationOptions(options), queryClient);
    }

export const getListTrackedConversionsUrl = (params?: ListTrackedConversionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/tracking/conversions?${stringifiedParams}` : `/api/v1/tracking/conversions`
}

/**
 * @summary Recent conversions and their totals
 */
export const listTrackedConversions = async (params?: ListTrackedConversionsParams, options?: Parameters<typeof apiFetch>[1]): Promise<ListTrackedConversions200> => {

  return apiFetch<ListTrackedConversions200>(getListTrackedConversionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTrackedConversionsQueryKey = (params?: ListTrackedConversionsParams,) => {
    return [
    `/api/v1/tracking/conversions`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTrackedConversionsQueryOptions = <TData = Awaited<ReturnType<typeof listTrackedConversions>>, TError = ErrorType<ErrorResponse>>(params?: ListTrackedConversionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTrackedConversions>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTrackedConversionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTrackedConversions>>> = ({ signal }) => listTrackedConversions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTrackedConversions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTrackedConversionsQueryResult = NonNullable<Awaited<ReturnType<typeof listTrackedConversions>>>
export type ListTrackedConversionsQueryError = ErrorType<ErrorResponse>


export function useListTrackedConversions<TData = Awaited<ReturnType<typeof listTrackedConversions>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ListTrackedConversionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTrackedConversions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTrackedConversions>>,
          TError,
          Awaited<ReturnType<typeof listTrackedConversions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTrackedConversions<TData = Awaited<ReturnType<typeof listTrackedConversions>>, TError = ErrorType<ErrorResponse>>(
 params?: ListTrackedConversionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTrackedConversions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTrackedConversions>>,
          TError,
          Awaited<ReturnType<typeof listTrackedConversions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTrackedConversions<TData = Awaited<ReturnType<typeof listTrackedConversions>>, TError = ErrorType<ErrorResponse>>(
 params?: ListTrackedConversionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTrackedConversions>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Recent conversions and their totals
 */

export function useListTrackedConversions<TData = Awaited<ReturnType<typeof listTrackedConversions>>, TError = ErrorType<ErrorResponse>>(
 params?: ListTrackedConversionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTrackedConversions>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTrackedConversionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAutopilotSettingsUrl = () => {




  return `/api/v1/autopilot/settings`
}

/**
 * @summary What the autopilot may do for this organization
 */
export const getAutopilotSettings = async ( options?: Parameters<typeof apiFetch>[1]): Promise<GetAutopilotSettings200> => {

  return apiFetch<GetAutopilotSettings200>(getGetAutopilotSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAutopilotSettingsQueryKey = () => {
    return [
    `/api/v1/autopilot/settings`
    ] as const;
    }


export const getGetAutopilotSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getAutopilotSettings>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAutopilotSettings>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAutopilotSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAutopilotSettings>>> = ({ signal }) => getAutopilotSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAutopilotSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAutopilotSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getAutopilotSettings>>>
export type GetAutopilotSettingsQueryError = ErrorType<ErrorResponse>


export function useGetAutopilotSettings<TData = Awaited<ReturnType<typeof getAutopilotSettings>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAutopilotSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAutopilotSettings>>,
          TError,
          Awaited<ReturnType<typeof getAutopilotSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAutopilotSettings<TData = Awaited<ReturnType<typeof getAutopilotSettings>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAutopilotSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAutopilotSettings>>,
          TError,
          Awaited<ReturnType<typeof getAutopilotSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAutopilotSettings<TData = Awaited<ReturnType<typeof getAutopilotSettings>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAutopilotSettings>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What the autopilot may do for this organization
 */

export function useGetAutopilotSettings<TData = Awaited<ReturnType<typeof getAutopilotSettings>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAutopilotSettings>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAutopilotSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateAutopilotSettingsUrl = () => {




  return `/api/v1/autopilot/settings`
}

/**
 * @summary Change the switches and caps (owner or admin)
 */
export const updateAutopilotSettings = async (updateAutopilotSettingsBody: UpdateAutopilotSettingsBody, options?: Parameters<typeof apiFetch>[1]): Promise<UpdateAutopilotSettings200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return apiFetch<UpdateAutopilotSettings200>(getUpdateAutopilotSettingsUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateAutopilotSettingsBody)
  }
);}





export const getUpdateAutopilotSettingsMutationKey = () => ['updateAutopilotSettings'] as const;

export const getUpdateAutopilotSettingsMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAutopilotSettings>>, TError,UpdateAutopilotSettingsMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAutopilotSettings>>, TError,UpdateAutopilotSettingsMutationVariables, TContext> => {

const mutationKey = getUpdateAutopilotSettingsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAutopilotSettings>>, UpdateAutopilotSettingsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateAutopilotSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAutopilotSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateAutopilotSettings>>>
    export type UpdateAutopilotSettingsMutationBody = BodyType<UpdateAutopilotSettingsBody>
    export type UpdateAutopilotSettingsMutationError = ErrorType<ErrorResponse>
    export type UpdateAutopilotSettingsMutationVariables = {data: BodyType<UpdateAutopilotSettingsBody>}

    /**
 * @summary Change the switches and caps (owner or admin)
 */
export const useUpdateAutopilotSettings = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAutopilotSettings>>, TError,UpdateAutopilotSettingsMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateAutopilotSettings>>,
        TError,
        UpdateAutopilotSettingsMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateAutopilotSettingsMutationOptions(options), queryClient);
    }

export const getGetCampaignPolicyUrl = (campaignId: string,) => {




  return `/api/v1/campaigns/${campaignId}/policy`
}

/**
 * @summary The campaign's automation switch, its group's target and the organization's caps
 */
export const getCampaignPolicy = async (campaignId: string, options?: Parameters<typeof apiFetch>[1]): Promise<GetCampaignPolicy200> => {

  return apiFetch<GetCampaignPolicy200>(getGetCampaignPolicyUrl(campaignId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCampaignPolicyQueryKey = (campaignId: string,) => {
    return [
    `/api/v1/campaigns/${campaignId}/policy`
    ] as const;
    }


export const getGetCampaignPolicyQueryOptions = <TData = Awaited<ReturnType<typeof getCampaignPolicy>>, TError = ErrorType<ErrorResponse>>(campaignId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignPolicy>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCampaignPolicyQueryKey(campaignId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCampaignPolicy>>> = ({ signal }) => getCampaignPolicy(campaignId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: campaignId !== null && campaignId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCampaignPolicy>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCampaignPolicyQueryResult = NonNullable<Awaited<ReturnType<typeof getCampaignPolicy>>>
export type GetCampaignPolicyQueryError = ErrorType<ErrorResponse>


export function useGetCampaignPolicy<TData = Awaited<ReturnType<typeof getCampaignPolicy>>, TError = ErrorType<ErrorResponse>>(
 campaignId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignPolicy>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaignPolicy>>,
          TError,
          Awaited<ReturnType<typeof getCampaignPolicy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignPolicy<TData = Awaited<ReturnType<typeof getCampaignPolicy>>, TError = ErrorType<ErrorResponse>>(
 campaignId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignPolicy>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaignPolicy>>,
          TError,
          Awaited<ReturnType<typeof getCampaignPolicy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignPolicy<TData = Awaited<ReturnType<typeof getCampaignPolicy>>, TError = ErrorType<ErrorResponse>>(
 campaignId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignPolicy>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The campaign's automation switch, its group's target and the organization's caps
 */

export function useGetCampaignPolicy<TData = Awaited<ReturnType<typeof getCampaignPolicy>>, TError = ErrorType<ErrorResponse>>(
 campaignId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignPolicy>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCampaignPolicyQueryOptions(campaignId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateCampaignPolicyUrl = (campaignId: string,) => {




  return `/api/v1/campaigns/${campaignId}/policy`
}

/**
 * @summary Pause or resume the autopilot for one campaign (owner or admin)
 */
export const updateCampaignPolicy = async (campaignId: string,
    updateCampaignPolicyBody: UpdateCampaignPolicyBody, options?: Parameters<typeof apiFetch>[1]): Promise<UpdateCampaignPolicy200> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return apiFetch<UpdateCampaignPolicy200>(getUpdateCampaignPolicyUrl(campaignId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateCampaignPolicyBody)
  }
);}





export const getUpdateCampaignPolicyMutationKey = () => ['updateCampaignPolicy'] as const;

export const getUpdateCampaignPolicyMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCampaignPolicy>>, TError,UpdateCampaignPolicyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCampaignPolicy>>, TError,UpdateCampaignPolicyMutationVariables, TContext> => {

const mutationKey = getUpdateCampaignPolicyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCampaignPolicy>>, UpdateCampaignPolicyMutationVariables> = (props) => {
          const {campaignId,data} = props ?? {};

          return  updateCampaignPolicy(campaignId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCampaignPolicyMutationResult = NonNullable<Awaited<ReturnType<typeof updateCampaignPolicy>>>
    export type UpdateCampaignPolicyMutationBody = BodyType<UpdateCampaignPolicyBody>
    export type UpdateCampaignPolicyMutationError = ErrorType<ErrorResponse>
    export type UpdateCampaignPolicyMutationVariables = {campaignId: string;data: BodyType<UpdateCampaignPolicyBody>}

    /**
 * @summary Pause or resume the autopilot for one campaign (owner or admin)
 */
export const useUpdateCampaignPolicy = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCampaignPolicy>>, TError,UpdateCampaignPolicyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateCampaignPolicy>>,
        TError,
        UpdateCampaignPolicyMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateCampaignPolicyMutationOptions(options), queryClient);
    }

export const getGetCampaignIntelUrl = (campaignId: string,) => {




  return `/api/v1/campaigns/${campaignId}/intel`
}

/**
 * @summary Competitive report, rules, adjustments, suggestions, goal ladder and group insights
 */
export const getCampaignIntel = async (campaignId: string, options?: Parameters<typeof apiFetch>[1]): Promise<GetCampaignIntel200> => {

  return apiFetch<GetCampaignIntel200>(getGetCampaignIntelUrl(campaignId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCampaignIntelQueryKey = (campaignId: string,) => {
    return [
    `/api/v1/campaigns/${campaignId}/intel`
    ] as const;
    }


export const getGetCampaignIntelQueryOptions = <TData = Awaited<ReturnType<typeof getCampaignIntel>>, TError = ErrorType<ErrorResponse>>(campaignId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignIntel>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCampaignIntelQueryKey(campaignId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCampaignIntel>>> = ({ signal }) => getCampaignIntel(campaignId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: campaignId !== null && campaignId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCampaignIntel>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCampaignIntelQueryResult = NonNullable<Awaited<ReturnType<typeof getCampaignIntel>>>
export type GetCampaignIntelQueryError = ErrorType<ErrorResponse>


export function useGetCampaignIntel<TData = Awaited<ReturnType<typeof getCampaignIntel>>, TError = ErrorType<ErrorResponse>>(
 campaignId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignIntel>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaignIntel>>,
          TError,
          Awaited<ReturnType<typeof getCampaignIntel>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignIntel<TData = Awaited<ReturnType<typeof getCampaignIntel>>, TError = ErrorType<ErrorResponse>>(
 campaignId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignIntel>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCampaignIntel>>,
          TError,
          Awaited<ReturnType<typeof getCampaignIntel>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCampaignIntel<TData = Awaited<ReturnType<typeof getCampaignIntel>>, TError = ErrorType<ErrorResponse>>(
 campaignId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignIntel>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Competitive report, rules, adjustments, suggestions, goal ladder and group insights
 */

export function useGetCampaignIntel<TData = Awaited<ReturnType<typeof getCampaignIntel>>, TError = ErrorType<ErrorResponse>>(
 campaignId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCampaignIntel>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCampaignIntelQueryOptions(campaignId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRefreshCampaignIntelUrl = (campaignId: string,) => {




  return `/api/v1/campaigns/${campaignId}/intel/refresh`
}

/**
 * @summary Queue a competitive-intelligence refresh now (owner or admin)
 */
export const refreshCampaignIntel = async (campaignId: string, options?: Parameters<typeof apiFetch>[1]): Promise<RefreshCampaignIntel202> => {

  return apiFetch<RefreshCampaignIntel202>(getRefreshCampaignIntelUrl(campaignId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRefreshCampaignIntelMutationKey = () => ['refreshCampaignIntel'] as const;

export const getRefreshCampaignIntelMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshCampaignIntel>>, TError,RefreshCampaignIntelMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof refreshCampaignIntel>>, TError,RefreshCampaignIntelMutationVariables, TContext> => {

const mutationKey = getRefreshCampaignIntelMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshCampaignIntel>>, RefreshCampaignIntelMutationVariables> = (props) => {
          const {campaignId} = props ?? {};

          return  refreshCampaignIntel(campaignId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefreshCampaignIntelMutationResult = NonNullable<Awaited<ReturnType<typeof refreshCampaignIntel>>>

    export type RefreshCampaignIntelMutationError = ErrorType<ErrorResponse>
    export type RefreshCampaignIntelMutationVariables = {campaignId: string}

    /**
 * @summary Queue a competitive-intelligence refresh now (owner or admin)
 */
export const useRefreshCampaignIntel = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshCampaignIntel>>, TError,RefreshCampaignIntelMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof refreshCampaignIntel>>,
        TError,
        RefreshCampaignIntelMutationVariables,
        TContext
      > => {
      return useMutation(getRefreshCampaignIntelMutationOptions(options), queryClient);
    }

export const getDismissTargetingRuleUrl = (campaignId: string,
    ruleId: string,) => {




  return `/api/v1/campaigns/${campaignId}/targeting-rules/${ruleId}/dismiss`
}

/**
 * @summary Stop a rule from steering the next generation (owner or admin)
 */
export const dismissTargetingRule = async (campaignId: string,
    ruleId: string, options?: Parameters<typeof apiFetch>[1]): Promise<void> => {

  return apiFetch<void>(getDismissTargetingRuleUrl(campaignId,ruleId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDismissTargetingRuleMutationKey = () => ['dismissTargetingRule'] as const;

export const getDismissTargetingRuleMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dismissTargetingRule>>, TError,DismissTargetingRuleMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof dismissTargetingRule>>, TError,DismissTargetingRuleMutationVariables, TContext> => {

const mutationKey = getDismissTargetingRuleMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dismissTargetingRule>>, DismissTargetingRuleMutationVariables> = (props) => {
          const {campaignId,ruleId} = props ?? {};

          return  dismissTargetingRule(campaignId,ruleId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DismissTargetingRuleMutationResult = NonNullable<Awaited<ReturnType<typeof dismissTargetingRule>>>

    export type DismissTargetingRuleMutationError = ErrorType<ErrorResponse>
    export type DismissTargetingRuleMutationVariables = {campaignId: string;ruleId: string}

    /**
 * @summary Stop a rule from steering the next generation (owner or admin)
 */
export const useDismissTargetingRule = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dismissTargetingRule>>, TError,DismissTargetingRuleMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof dismissTargetingRule>>,
        TError,
        DismissTargetingRuleMutationVariables,
        TContext
      > => {
      return useMutation(getDismissTargetingRuleMutationOptions(options), queryClient);
    }

export const getDismissTargetingSuggestionUrl = (campaignId: string,
    suggestionId: string,) => {




  return `/api/v1/campaigns/${campaignId}/targeting-suggestions/${suggestionId}/dismiss`
}

/**
 * @summary Decline a proposed targeting change (owner or admin)
 */
export const dismissTargetingSuggestion = async (campaignId: string,
    suggestionId: string, options?: Parameters<typeof apiFetch>[1]): Promise<DismissTargetingSuggestion200> => {

  return apiFetch<DismissTargetingSuggestion200>(getDismissTargetingSuggestionUrl(campaignId,suggestionId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDismissTargetingSuggestionMutationKey = () => ['dismissTargetingSuggestion'] as const;

export const getDismissTargetingSuggestionMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dismissTargetingSuggestion>>, TError,DismissTargetingSuggestionMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof dismissTargetingSuggestion>>, TError,DismissTargetingSuggestionMutationVariables, TContext> => {

const mutationKey = getDismissTargetingSuggestionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dismissTargetingSuggestion>>, DismissTargetingSuggestionMutationVariables> = (props) => {
          const {campaignId,suggestionId} = props ?? {};

          return  dismissTargetingSuggestion(campaignId,suggestionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DismissTargetingSuggestionMutationResult = NonNullable<Awaited<ReturnType<typeof dismissTargetingSuggestion>>>

    export type DismissTargetingSuggestionMutationError = ErrorType<ErrorResponse>
    export type DismissTargetingSuggestionMutationVariables = {campaignId: string;suggestionId: string}

    /**
 * @summary Decline a proposed targeting change (owner or admin)
 */
export const useDismissTargetingSuggestion = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dismissTargetingSuggestion>>, TError,DismissTargetingSuggestionMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof dismissTargetingSuggestion>>,
        TError,
        DismissTargetingSuggestionMutationVariables,
        TContext
      > => {
      return useMutation(getDismissTargetingSuggestionMutationOptions(options), queryClient);
    }

export const getAcceptSuggestionUrl = (suggestionId: string,) => {




  return `/api/v1/suggestions/${suggestionId}/accept`
}

/**
 * @summary Accept a suggestion and apply it through the bounded path (owner or admin)
 */
export const acceptSuggestion = async (suggestionId: string, options?: Parameters<typeof apiFetch>[1]): Promise<AcceptSuggestion200> => {

  return apiFetch<AcceptSuggestion200>(getAcceptSuggestionUrl(suggestionId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAcceptSuggestionMutationKey = () => ['acceptSuggestion'] as const;

export const getAcceptSuggestionMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptSuggestion>>, TError,AcceptSuggestionMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof acceptSuggestion>>, TError,AcceptSuggestionMutationVariables, TContext> => {

const mutationKey = getAcceptSuggestionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptSuggestion>>, AcceptSuggestionMutationVariables> = (props) => {
          const {suggestionId} = props ?? {};

          return  acceptSuggestion(suggestionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcceptSuggestionMutationResult = NonNullable<Awaited<ReturnType<typeof acceptSuggestion>>>

    export type AcceptSuggestionMutationError = ErrorType<ErrorResponse>
    export type AcceptSuggestionMutationVariables = {suggestionId: string}

    /**
 * @summary Accept a suggestion and apply it through the bounded path (owner or admin)
 */
export const useAcceptSuggestion = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptSuggestion>>, TError,AcceptSuggestionMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof acceptSuggestion>>,
        TError,
        AcceptSuggestionMutationVariables,
        TContext
      > => {
      return useMutation(getAcceptSuggestionMutationOptions(options), queryClient);
    }

export const getDismissSuggestionUrl = (suggestionId: string,) => {




  return `/api/v1/suggestions/${suggestionId}/dismiss`
}

/**
 * @summary Dismiss a suggestion (owner or admin)
 */
export const dismissSuggestion = async (suggestionId: string, options?: Parameters<typeof apiFetch>[1]): Promise<DismissSuggestion200> => {

  return apiFetch<DismissSuggestion200>(getDismissSuggestionUrl(suggestionId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDismissSuggestionMutationKey = () => ['dismissSuggestion'] as const;

export const getDismissSuggestionMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dismissSuggestion>>, TError,DismissSuggestionMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof dismissSuggestion>>, TError,DismissSuggestionMutationVariables, TContext> => {

const mutationKey = getDismissSuggestionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dismissSuggestion>>, DismissSuggestionMutationVariables> = (props) => {
          const {suggestionId} = props ?? {};

          return  dismissSuggestion(suggestionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DismissSuggestionMutationResult = NonNullable<Awaited<ReturnType<typeof dismissSuggestion>>>

    export type DismissSuggestionMutationError = ErrorType<ErrorResponse>
    export type DismissSuggestionMutationVariables = {suggestionId: string}

    /**
 * @summary Dismiss a suggestion (owner or admin)
 */
export const useDismissSuggestion = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dismissSuggestion>>, TError,DismissSuggestionMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof dismissSuggestion>>,
        TError,
        DismissSuggestionMutationVariables,
        TContext
      > => {
      return useMutation(getDismissSuggestionMutationOptions(options), queryClient);
    }

export const getGetLatestForecastUrl = (campaignId: string,) => {




  return `/api/v1/campaigns/${campaignId}/forecast`
}

/**
 * @summary The last forecast asked for this campaign
 */
export const getLatestForecast = async (campaignId: string, options?: Parameters<typeof apiFetch>[1]): Promise<GetLatestForecast200> => {

  return apiFetch<GetLatestForecast200>(getGetLatestForecastUrl(campaignId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLatestForecastQueryKey = (campaignId: string,) => {
    return [
    `/api/v1/campaigns/${campaignId}/forecast`
    ] as const;
    }


export const getGetLatestForecastQueryOptions = <TData = Awaited<ReturnType<typeof getLatestForecast>>, TError = ErrorType<ErrorResponse>>(campaignId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestForecast>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLatestForecastQueryKey(campaignId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLatestForecast>>> = ({ signal }) => getLatestForecast(campaignId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: campaignId !== null && campaignId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLatestForecast>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLatestForecastQueryResult = NonNullable<Awaited<ReturnType<typeof getLatestForecast>>>
export type GetLatestForecastQueryError = ErrorType<ErrorResponse>


export function useGetLatestForecast<TData = Awaited<ReturnType<typeof getLatestForecast>>, TError = ErrorType<ErrorResponse>>(
 campaignId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestForecast>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLatestForecast>>,
          TError,
          Awaited<ReturnType<typeof getLatestForecast>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLatestForecast<TData = Awaited<ReturnType<typeof getLatestForecast>>, TError = ErrorType<ErrorResponse>>(
 campaignId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestForecast>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLatestForecast>>,
          TError,
          Awaited<ReturnType<typeof getLatestForecast>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLatestForecast<TData = Awaited<ReturnType<typeof getLatestForecast>>, TError = ErrorType<ErrorResponse>>(
 campaignId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestForecast>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The last forecast asked for this campaign
 */

export function useGetLatestForecast<TData = Awaited<ReturnType<typeof getLatestForecast>>, TError = ErrorType<ErrorResponse>>(
 campaignId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestForecast>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLatestForecastQueryOptions(campaignId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateForecastUrl = (campaignId: string,) => {




  return `/api/v1/campaigns/${campaignId}/forecast`
}

/**
 * @summary Forecast the given monthly budgets; metered (owner or admin)
 */
export const createForecast = async (campaignId: string,
    createForecastBody: CreateForecastBody, options?: Parameters<typeof apiFetch>[1]): Promise<CreateForecast201> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return apiFetch<CreateForecast201>(getCreateForecastUrl(campaignId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createForecastBody)
  }
);}





export const getCreateForecastMutationKey = () => ['createForecast'] as const;

export const getCreateForecastMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createForecast>>, TError,CreateForecastMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createForecast>>, TError,CreateForecastMutationVariables, TContext> => {

const mutationKey = getCreateForecastMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createForecast>>, CreateForecastMutationVariables> = (props) => {
          const {campaignId,data} = props ?? {};

          return  createForecast(campaignId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateForecastMutationResult = NonNullable<Awaited<ReturnType<typeof createForecast>>>
    export type CreateForecastMutationBody = BodyType<CreateForecastBody>
    export type CreateForecastMutationError = ErrorType<ErrorResponse>
    export type CreateForecastMutationVariables = {campaignId: string;data: BodyType<CreateForecastBody>}

    /**
 * @summary Forecast the given monthly budgets; metered (owner or admin)
 */
export const useCreateForecast = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createForecast>>, TError,CreateForecastMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createForecast>>,
        TError,
        CreateForecastMutationVariables,
        TContext
      > => {
      return useMutation(getCreateForecastMutationOptions(options), queryClient);
    }

export const getGetActivityUrl = (params?: GetActivityParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/activity?${stringifiedParams}` : `/api/v1/activity`
}

/**
 * @summary Everything that happened to the account's campaigns, newest first
 */
export const getActivity = async (params?: GetActivityParams, options?: Parameters<typeof apiFetch>[1]): Promise<GetActivity200> => {

  return apiFetch<GetActivity200>(getGetActivityUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetActivityQueryKey = (params?: GetActivityParams,) => {
    return [
    `/api/v1/activity`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetActivityQueryOptions = <TData = Awaited<ReturnType<typeof getActivity>>, TError = ErrorType<ErrorResponse>>(params?: GetActivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivity>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActivityQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActivity>>> = ({ signal }) => getActivity(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActivity>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetActivityQueryResult = NonNullable<Awaited<ReturnType<typeof getActivity>>>
export type GetActivityQueryError = ErrorType<ErrorResponse>


export function useGetActivity<TData = Awaited<ReturnType<typeof getActivity>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  GetActivityParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivity>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActivity>>,
          TError,
          Awaited<ReturnType<typeof getActivity>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivity<TData = Awaited<ReturnType<typeof getActivity>>, TError = ErrorType<ErrorResponse>>(
 params?: GetActivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivity>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActivity>>,
          TError,
          Awaited<ReturnType<typeof getActivity>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivity<TData = Awaited<ReturnType<typeof getActivity>>, TError = ErrorType<ErrorResponse>>(
 params?: GetActivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivity>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Everything that happened to the account's campaigns, newest first
 */

export function useGetActivity<TData = Awaited<ReturnType<typeof getActivity>>, TError = ErrorType<ErrorResponse>>(
 params?: GetActivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivity>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetActivityQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListWeeklyInsightsUrl = () => {




  return `/api/v1/insights/weekly`
}

/**
 * @summary The weekly reports, newest week first
 */
export const listWeeklyInsights = async ( options?: Parameters<typeof apiFetch>[1]): Promise<ListWeeklyInsights200> => {

  return apiFetch<ListWeeklyInsights200>(getListWeeklyInsightsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListWeeklyInsightsQueryKey = () => {
    return [
    `/api/v1/insights/weekly`
    ] as const;
    }


export const getListWeeklyInsightsQueryOptions = <TData = Awaited<ReturnType<typeof listWeeklyInsights>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWeeklyInsights>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListWeeklyInsightsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWeeklyInsights>>> = ({ signal }) => listWeeklyInsights({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listWeeklyInsights>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListWeeklyInsightsQueryResult = NonNullable<Awaited<ReturnType<typeof listWeeklyInsights>>>
export type ListWeeklyInsightsQueryError = ErrorType<ErrorResponse>


export function useListWeeklyInsights<TData = Awaited<ReturnType<typeof listWeeklyInsights>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWeeklyInsights>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWeeklyInsights>>,
          TError,
          Awaited<ReturnType<typeof listWeeklyInsights>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListWeeklyInsights<TData = Awaited<ReturnType<typeof listWeeklyInsights>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWeeklyInsights>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listWeeklyInsights>>,
          TError,
          Awaited<ReturnType<typeof listWeeklyInsights>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListWeeklyInsights<TData = Awaited<ReturnType<typeof listWeeklyInsights>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWeeklyInsights>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The weekly reports, newest week first
 */

export function useListWeeklyInsights<TData = Awaited<ReturnType<typeof listWeeklyInsights>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWeeklyInsights>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListWeeklyInsightsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetLatestInsightUrl = () => {




  return `/api/v1/insights/latest`
}

/**
 * @summary The newest weekly report, for the dashboard
 */
export const getLatestInsight = async ( options?: Parameters<typeof apiFetch>[1]): Promise<GetLatestInsight200> => {

  return apiFetch<GetLatestInsight200>(getGetLatestInsightUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLatestInsightQueryKey = () => {
    return [
    `/api/v1/insights/latest`
    ] as const;
    }


export const getGetLatestInsightQueryOptions = <TData = Awaited<ReturnType<typeof getLatestInsight>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestInsight>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLatestInsightQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLatestInsight>>> = ({ signal }) => getLatestInsight({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLatestInsight>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLatestInsightQueryResult = NonNullable<Awaited<ReturnType<typeof getLatestInsight>>>
export type GetLatestInsightQueryError = ErrorType<ErrorResponse>


export function useGetLatestInsight<TData = Awaited<ReturnType<typeof getLatestInsight>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestInsight>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLatestInsight>>,
          TError,
          Awaited<ReturnType<typeof getLatestInsight>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLatestInsight<TData = Awaited<ReturnType<typeof getLatestInsight>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestInsight>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLatestInsight>>,
          TError,
          Awaited<ReturnType<typeof getLatestInsight>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLatestInsight<TData = Awaited<ReturnType<typeof getLatestInsight>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestInsight>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The newest weekly report, for the dashboard
 */

export function useGetLatestInsight<TData = Awaited<ReturnType<typeof getLatestInsight>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestInsight>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLatestInsightQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetBrandVoiceUrl = () => {




  return `/api/v1/brand-voice`
}

/**
 * @summary The brand voice extracted from the account's own copy
 */
export const getBrandVoice = async ( options?: Parameters<typeof apiFetch>[1]): Promise<GetBrandVoice200> => {

  return apiFetch<GetBrandVoice200>(getGetBrandVoiceUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBrandVoiceQueryKey = () => {
    return [
    `/api/v1/brand-voice`
    ] as const;
    }


export const getGetBrandVoiceQueryOptions = <TData = Awaited<ReturnType<typeof getBrandVoice>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrandVoice>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBrandVoiceQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBrandVoice>>> = ({ signal }) => getBrandVoice({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBrandVoice>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBrandVoiceQueryResult = NonNullable<Awaited<ReturnType<typeof getBrandVoice>>>
export type GetBrandVoiceQueryError = ErrorType<ErrorResponse>


export function useGetBrandVoice<TData = Awaited<ReturnType<typeof getBrandVoice>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrandVoice>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrandVoice>>,
          TError,
          Awaited<ReturnType<typeof getBrandVoice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrandVoice<TData = Awaited<ReturnType<typeof getBrandVoice>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrandVoice>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBrandVoice>>,
          TError,
          Awaited<ReturnType<typeof getBrandVoice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBrandVoice<TData = Awaited<ReturnType<typeof getBrandVoice>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrandVoice>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The brand voice extracted from the account's own copy
 */

export function useGetBrandVoice<TData = Awaited<ReturnType<typeof getBrandVoice>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBrandVoice>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBrandVoiceQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAnalyzeBrandVoiceUrl = () => {




  return `/api/v1/brand-voice/analyze`
}

/**
 * @summary Analyze the brand voice now; metered (owner or admin)
 */
export const analyzeBrandVoice = async ( options?: Parameters<typeof apiFetch>[1]): Promise<AnalyzeBrandVoice200> => {

  return apiFetch<AnalyzeBrandVoice200>(getAnalyzeBrandVoiceUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAnalyzeBrandVoiceMutationKey = () => ['analyzeBrandVoice'] as const;

export const getAnalyzeBrandVoiceMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof analyzeBrandVoice>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof analyzeBrandVoice>>, TError,void, TContext> => {

const mutationKey = getAnalyzeBrandVoiceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof analyzeBrandVoice>>, void> = () => {


          return  analyzeBrandVoice(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AnalyzeBrandVoiceMutationResult = NonNullable<Awaited<ReturnType<typeof analyzeBrandVoice>>>

    export type AnalyzeBrandVoiceMutationError = ErrorType<ErrorResponse>


    /**
 * @summary Analyze the brand voice now; metered (owner or admin)
 */
export const useAnalyzeBrandVoice = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof analyzeBrandVoice>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof analyzeBrandVoice>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getAnalyzeBrandVoiceMutationOptions(options), queryClient);
    }

export const getAdminLearningStatsUrl = () => {




  return `/api/v1/admin/learning`
}

/**
 * @summary What the learning brain holds: counts by type, industry and platform (staff only)
 */
export const adminLearningStats = async ( options?: Parameters<typeof apiFetch>[1]): Promise<AdminLearningStats200> => {

  return apiFetch<AdminLearningStats200>(getAdminLearningStatsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminLearningStatsQueryKey = () => {
    return [
    `/api/v1/admin/learning`
    ] as const;
    }


export const getAdminLearningStatsQueryOptions = <TData = Awaited<ReturnType<typeof adminLearningStats>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminLearningStats>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminLearningStatsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminLearningStats>>> = ({ signal }) => adminLearningStats({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminLearningStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminLearningStatsQueryResult = NonNullable<Awaited<ReturnType<typeof adminLearningStats>>>
export type AdminLearningStatsQueryError = ErrorType<ErrorResponse>


export function useAdminLearningStats<TData = Awaited<ReturnType<typeof adminLearningStats>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminLearningStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminLearningStats>>,
          TError,
          Awaited<ReturnType<typeof adminLearningStats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminLearningStats<TData = Awaited<ReturnType<typeof adminLearningStats>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminLearningStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminLearningStats>>,
          TError,
          Awaited<ReturnType<typeof adminLearningStats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminLearningStats<TData = Awaited<ReturnType<typeof adminLearningStats>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminLearningStats>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What the learning brain holds: counts by type, industry and platform (staff only)
 */

export function useAdminLearningStats<TData = Awaited<ReturnType<typeof adminLearningStats>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminLearningStats>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminLearningStatsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAdminAiUsageUrl = (params?: AdminAiUsageParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/ai-usage?${stringifiedParams}` : `/api/v1/admin/ai-usage`
}

/**
 * @summary Credits consumed per organization and feature (staff only)
 */
export const adminAiUsage = async (params?: AdminAiUsageParams, options?: Parameters<typeof apiFetch>[1]): Promise<AdminAiUsage200> => {

  return apiFetch<AdminAiUsage200>(getAdminAiUsageUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminAiUsageQueryKey = (params?: AdminAiUsageParams,) => {
    return [
    `/api/v1/admin/ai-usage`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminAiUsageQueryOptions = <TData = Awaited<ReturnType<typeof adminAiUsage>>, TError = ErrorType<ErrorResponse>>(params?: AdminAiUsageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAiUsage>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminAiUsageQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminAiUsage>>> = ({ signal }) => adminAiUsage(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminAiUsage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminAiUsageQueryResult = NonNullable<Awaited<ReturnType<typeof adminAiUsage>>>
export type AdminAiUsageQueryError = ErrorType<ErrorResponse>


export function useAdminAiUsage<TData = Awaited<ReturnType<typeof adminAiUsage>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  AdminAiUsageParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAiUsage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAiUsage>>,
          TError,
          Awaited<ReturnType<typeof adminAiUsage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminAiUsage<TData = Awaited<ReturnType<typeof adminAiUsage>>, TError = ErrorType<ErrorResponse>>(
 params?: AdminAiUsageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAiUsage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAiUsage>>,
          TError,
          Awaited<ReturnType<typeof adminAiUsage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminAiUsage<TData = Awaited<ReturnType<typeof adminAiUsage>>, TError = ErrorType<ErrorResponse>>(
 params?: AdminAiUsageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAiUsage>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Credits consumed per organization and feature (staff only)
 */

export function useAdminAiUsage<TData = Awaited<ReturnType<typeof adminAiUsage>>, TError = ErrorType<ErrorResponse>>(
 params?: AdminAiUsageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAiUsage>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminAiUsageQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAdminCostSupervisionUrl = (params?: AdminCostSupervisionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/cost-supervision?${stringifiedParams}` : `/api/v1/admin/cost-supervision`
}

/**
 * @summary Consumption against each plan's allowance and price (staff only)
 */
export const adminCostSupervision = async (params?: AdminCostSupervisionParams, options?: Parameters<typeof apiFetch>[1]): Promise<AdminCostSupervision200> => {

  return apiFetch<AdminCostSupervision200>(getAdminCostSupervisionUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminCostSupervisionQueryKey = (params?: AdminCostSupervisionParams,) => {
    return [
    `/api/v1/admin/cost-supervision`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminCostSupervisionQueryOptions = <TData = Awaited<ReturnType<typeof adminCostSupervision>>, TError = ErrorType<ErrorResponse>>(params?: AdminCostSupervisionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCostSupervision>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminCostSupervisionQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminCostSupervision>>> = ({ signal }) => adminCostSupervision(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminCostSupervision>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminCostSupervisionQueryResult = NonNullable<Awaited<ReturnType<typeof adminCostSupervision>>>
export type AdminCostSupervisionQueryError = ErrorType<ErrorResponse>


export function useAdminCostSupervision<TData = Awaited<ReturnType<typeof adminCostSupervision>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  AdminCostSupervisionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCostSupervision>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCostSupervision>>,
          TError,
          Awaited<ReturnType<typeof adminCostSupervision>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCostSupervision<TData = Awaited<ReturnType<typeof adminCostSupervision>>, TError = ErrorType<ErrorResponse>>(
 params?: AdminCostSupervisionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCostSupervision>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminCostSupervision>>,
          TError,
          Awaited<ReturnType<typeof adminCostSupervision>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminCostSupervision<TData = Awaited<ReturnType<typeof adminCostSupervision>>, TError = ErrorType<ErrorResponse>>(
 params?: AdminCostSupervisionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCostSupervision>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Consumption against each plan's allowance and price (staff only)
 */

export function useAdminCostSupervision<TData = Awaited<ReturnType<typeof adminCostSupervision>>, TError = ErrorType<ErrorResponse>>(
 params?: AdminCostSupervisionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminCostSupervision>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminCostSupervisionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAdminWatchdogUrl = () => {




  return `/api/v1/admin/watchdog`
}

/**
 * @summary Model catalogue findings and live per-model health (staff only)
 */
export const adminWatchdog = async ( options?: Parameters<typeof apiFetch>[1]): Promise<AdminWatchdog200> => {

  return apiFetch<AdminWatchdog200>(getAdminWatchdogUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminWatchdogQueryKey = () => {
    return [
    `/api/v1/admin/watchdog`
    ] as const;
    }


export const getAdminWatchdogQueryOptions = <TData = Awaited<ReturnType<typeof adminWatchdog>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminWatchdog>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminWatchdogQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminWatchdog>>> = ({ signal }) => adminWatchdog({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminWatchdog>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminWatchdogQueryResult = NonNullable<Awaited<ReturnType<typeof adminWatchdog>>>
export type AdminWatchdogQueryError = ErrorType<ErrorResponse>


export function useAdminWatchdog<TData = Awaited<ReturnType<typeof adminWatchdog>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminWatchdog>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminWatchdog>>,
          TError,
          Awaited<ReturnType<typeof adminWatchdog>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminWatchdog<TData = Awaited<ReturnType<typeof adminWatchdog>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminWatchdog>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminWatchdog>>,
          TError,
          Awaited<ReturnType<typeof adminWatchdog>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminWatchdog<TData = Awaited<ReturnType<typeof adminWatchdog>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminWatchdog>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Model catalogue findings and live per-model health (staff only)
 */

export function useAdminWatchdog<TData = Awaited<ReturnType<typeof adminWatchdog>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminWatchdog>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminWatchdogQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAdminRunWatchdogUrl = () => {




  return `/api/v1/admin/watchdog/run`
}

/**
 * @summary Queue a model watchdog run now (staff only)
 */
export const adminRunWatchdog = async ( options?: Parameters<typeof apiFetch>[1]): Promise<AdminRunWatchdog202> => {

  return apiFetch<AdminRunWatchdog202>(getAdminRunWatchdogUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdminRunWatchdogMutationKey = () => ['adminRunWatchdog'] as const;

export const getAdminRunWatchdogMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminRunWatchdog>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminRunWatchdog>>, TError,void, TContext> => {

const mutationKey = getAdminRunWatchdogMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminRunWatchdog>>, void> = () => {


          return  adminRunWatchdog(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminRunWatchdogMutationResult = NonNullable<Awaited<ReturnType<typeof adminRunWatchdog>>>

    export type AdminRunWatchdogMutationError = ErrorType<ErrorResponse>


    /**
 * @summary Queue a model watchdog run now (staff only)
 */
export const useAdminRunWatchdog = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminRunWatchdog>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminRunWatchdog>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getAdminRunWatchdogMutationOptions(options), queryClient);
    }

export const getAdminProbeAiHealthUrl = () => {




  return `/api/v1/admin/ai-health/probe`
}

/**
 * @summary Queue a probe of every model now (staff only)
 */
export const adminProbeAiHealth = async ( options?: Parameters<typeof apiFetch>[1]): Promise<AdminProbeAiHealth202> => {

  return apiFetch<AdminProbeAiHealth202>(getAdminProbeAiHealthUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdminProbeAiHealthMutationKey = () => ['adminProbeAiHealth'] as const;

export const getAdminProbeAiHealthMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminProbeAiHealth>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminProbeAiHealth>>, TError,void, TContext> => {

const mutationKey = getAdminProbeAiHealthMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminProbeAiHealth>>, void> = () => {


          return  adminProbeAiHealth(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminProbeAiHealthMutationResult = NonNullable<Awaited<ReturnType<typeof adminProbeAiHealth>>>

    export type AdminProbeAiHealthMutationError = ErrorType<ErrorResponse>


    /**
 * @summary Queue a probe of every model now (staff only)
 */
export const useAdminProbeAiHealth = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminProbeAiHealth>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminProbeAiHealth>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getAdminProbeAiHealthMutationOptions(options), queryClient);
    }

export const getAdminLaunchFailuresUrl = () => {




  return `/api/v1/admin/launch-failures`
}

/**
 * @summary Campaigns whose launch failed or stalled, across tenants (staff only)
 */
export const adminLaunchFailures = async ( options?: Parameters<typeof apiFetch>[1]): Promise<AdminLaunchFailures200> => {

  return apiFetch<AdminLaunchFailures200>(getAdminLaunchFailuresUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminLaunchFailuresQueryKey = () => {
    return [
    `/api/v1/admin/launch-failures`
    ] as const;
    }


export const getAdminLaunchFailuresQueryOptions = <TData = Awaited<ReturnType<typeof adminLaunchFailures>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminLaunchFailures>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminLaunchFailuresQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminLaunchFailures>>> = ({ signal }) => adminLaunchFailures({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminLaunchFailures>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminLaunchFailuresQueryResult = NonNullable<Awaited<ReturnType<typeof adminLaunchFailures>>>
export type AdminLaunchFailuresQueryError = ErrorType<ErrorResponse>


export function useAdminLaunchFailures<TData = Awaited<ReturnType<typeof adminLaunchFailures>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminLaunchFailures>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminLaunchFailures>>,
          TError,
          Awaited<ReturnType<typeof adminLaunchFailures>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminLaunchFailures<TData = Awaited<ReturnType<typeof adminLaunchFailures>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminLaunchFailures>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminLaunchFailures>>,
          TError,
          Awaited<ReturnType<typeof adminLaunchFailures>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminLaunchFailures<TData = Awaited<ReturnType<typeof adminLaunchFailures>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminLaunchFailures>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Campaigns whose launch failed or stalled, across tenants (staff only)
 */

export function useAdminLaunchFailures<TData = Awaited<ReturnType<typeof adminLaunchFailures>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminLaunchFailures>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminLaunchFailuresQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAdminQueuesUrl = () => {




  return `/api/v1/admin/queues`
}

/**
 * @summary Every queue with its policy, schedule, depth and last failure (staff only)
 */
export const adminQueues = async ( options?: Parameters<typeof apiFetch>[1]): Promise<AdminQueues200> => {

  return apiFetch<AdminQueues200>(getAdminQueuesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminQueuesQueryKey = () => {
    return [
    `/api/v1/admin/queues`
    ] as const;
    }


export const getAdminQueuesQueryOptions = <TData = Awaited<ReturnType<typeof adminQueues>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminQueues>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminQueuesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminQueues>>> = ({ signal }) => adminQueues({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminQueues>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminQueuesQueryResult = NonNullable<Awaited<ReturnType<typeof adminQueues>>>
export type AdminQueuesQueryError = ErrorType<ErrorResponse>


export function useAdminQueues<TData = Awaited<ReturnType<typeof adminQueues>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminQueues>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminQueues>>,
          TError,
          Awaited<ReturnType<typeof adminQueues>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminQueues<TData = Awaited<ReturnType<typeof adminQueues>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminQueues>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminQueues>>,
          TError,
          Awaited<ReturnType<typeof adminQueues>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminQueues<TData = Awaited<ReturnType<typeof adminQueues>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminQueues>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Every queue with its policy, schedule, depth and last failure (staff only)
 */

export function useAdminQueues<TData = Awaited<ReturnType<typeof adminQueues>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminQueues>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminQueuesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAdminModelsUrl = () => {




  return `/api/v1/admin/models`
}

/**
 * @summary Text models per tier, their evaluations and plan margins (staff only)
 */
export const adminModels = async ( options?: Parameters<typeof apiFetch>[1]): Promise<AdminModels200> => {

  return apiFetch<AdminModels200>(getAdminModelsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminModelsQueryKey = () => {
    return [
    `/api/v1/admin/models`
    ] as const;
    }


export const getAdminModelsQueryOptions = <TData = Awaited<ReturnType<typeof adminModels>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminModels>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminModelsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminModels>>> = ({ signal }) => adminModels({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminModels>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminModelsQueryResult = NonNullable<Awaited<ReturnType<typeof adminModels>>>
export type AdminModelsQueryError = ErrorType<ErrorResponse>


export function useAdminModels<TData = Awaited<ReturnType<typeof adminModels>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminModels>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminModels>>,
          TError,
          Awaited<ReturnType<typeof adminModels>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminModels<TData = Awaited<ReturnType<typeof adminModels>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminModels>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminModels>>,
          TError,
          Awaited<ReturnType<typeof adminModels>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminModels<TData = Awaited<ReturnType<typeof adminModels>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminModels>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Text models per tier, their evaluations and plan margins (staff only)
 */

export function useAdminModels<TData = Awaited<ReturnType<typeof adminModels>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminModels>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminModelsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAdminAddModelCandidateUrl = () => {




  return `/api/v1/admin/models/candidates`
}

/**
 * @summary Queue an evaluation of a text model for a tier (staff only, audited)
 */
export const adminAddModelCandidate = async (adminAddModelCandidateBody: AdminAddModelCandidateBody, options?: Parameters<typeof apiFetch>[1]): Promise<AdminAddModelCandidate202> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return apiFetch<AdminAddModelCandidate202>(getAdminAddModelCandidateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminAddModelCandidateBody)
  }
);}





export const getAdminAddModelCandidateMutationKey = () => ['adminAddModelCandidate'] as const;

export const getAdminAddModelCandidateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAddModelCandidate>>, TError,AdminAddModelCandidateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminAddModelCandidate>>, TError,AdminAddModelCandidateMutationVariables, TContext> => {

const mutationKey = getAdminAddModelCandidateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminAddModelCandidate>>, AdminAddModelCandidateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  adminAddModelCandidate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminAddModelCandidateMutationResult = NonNullable<Awaited<ReturnType<typeof adminAddModelCandidate>>>
    export type AdminAddModelCandidateMutationBody = BodyType<AdminAddModelCandidateBody>
    export type AdminAddModelCandidateMutationError = ErrorType<ErrorResponse>
    export type AdminAddModelCandidateMutationVariables = {data: BodyType<AdminAddModelCandidateBody>}

    /**
 * @summary Queue an evaluation of a text model for a tier (staff only, audited)
 */
export const useAdminAddModelCandidate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminAddModelCandidate>>, TError,AdminAddModelCandidateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminAddModelCandidate>>,
        TError,
        AdminAddModelCandidateMutationVariables,
        TContext
      > => {
      return useMutation(getAdminAddModelCandidateMutationOptions(options), queryClient);
    }

export const getAdminApproveModelUrl = (evaluationId: string,) => {




  return `/api/v1/admin/models/evaluations/${evaluationId}/approve`
}

/**
 * @summary Put a passed candidate into use on its tier (staff only, audited)
 */
export const adminApproveModel = async (evaluationId: string, options?: Parameters<typeof apiFetch>[1]): Promise<AdminApproveModel200> => {

  return apiFetch<AdminApproveModel200>(getAdminApproveModelUrl(evaluationId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdminApproveModelMutationKey = () => ['adminApproveModel'] as const;

export const getAdminApproveModelMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminApproveModel>>, TError,AdminApproveModelMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminApproveModel>>, TError,AdminApproveModelMutationVariables, TContext> => {

const mutationKey = getAdminApproveModelMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminApproveModel>>, AdminApproveModelMutationVariables> = (props) => {
          const {evaluationId} = props ?? {};

          return  adminApproveModel(evaluationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminApproveModelMutationResult = NonNullable<Awaited<ReturnType<typeof adminApproveModel>>>

    export type AdminApproveModelMutationError = ErrorType<ErrorResponse>
    export type AdminApproveModelMutationVariables = {evaluationId: string}

    /**
 * @summary Put a passed candidate into use on its tier (staff only, audited)
 */
export const useAdminApproveModel = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminApproveModel>>, TError,AdminApproveModelMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminApproveModel>>,
        TError,
        AdminApproveModelMutationVariables,
        TContext
      > => {
      return useMutation(getAdminApproveModelMutationOptions(options), queryClient);
    }

export const getAdminRejectModelUrl = (evaluationId: string,) => {




  return `/api/v1/admin/models/evaluations/${evaluationId}/reject`
}

/**
 * @summary Close an evaluation without a change (staff only, audited)
 */
export const adminRejectModel = async (evaluationId: string, options?: Parameters<typeof apiFetch>[1]): Promise<AdminRejectModel200> => {

  return apiFetch<AdminRejectModel200>(getAdminRejectModelUrl(evaluationId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdminRejectModelMutationKey = () => ['adminRejectModel'] as const;

export const getAdminRejectModelMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminRejectModel>>, TError,AdminRejectModelMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminRejectModel>>, TError,AdminRejectModelMutationVariables, TContext> => {

const mutationKey = getAdminRejectModelMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminRejectModel>>, AdminRejectModelMutationVariables> = (props) => {
          const {evaluationId} = props ?? {};

          return  adminRejectModel(evaluationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminRejectModelMutationResult = NonNullable<Awaited<ReturnType<typeof adminRejectModel>>>

    export type AdminRejectModelMutationError = ErrorType<ErrorResponse>
    export type AdminRejectModelMutationVariables = {evaluationId: string}

    /**
 * @summary Close an evaluation without a change (staff only, audited)
 */
export const useAdminRejectModel = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminRejectModel>>, TError,AdminRejectModelMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminRejectModel>>,
        TError,
        AdminRejectModelMutationVariables,
        TContext
      > => {
      return useMutation(getAdminRejectModelMutationOptions(options), queryClient);
    }

export const getAdminRestoreModelUrl = (tier: 'light' | 'content' | 'core',) => {




  return `/api/v1/admin/models/tiers/${tier}/restore`
}

/**
 * @summary Return a tier to the model it ran before (staff only, audited)
 */
export const adminRestoreModel = async (tier: 'light' | 'content' | 'core', options?: Parameters<typeof apiFetch>[1]): Promise<AdminRestoreModel200> => {

  return apiFetch<AdminRestoreModel200>(getAdminRestoreModelUrl(tier),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdminRestoreModelMutationKey = () => ['adminRestoreModel'] as const;

export const getAdminRestoreModelMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminRestoreModel>>, TError,AdminRestoreModelMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof adminRestoreModel>>, TError,AdminRestoreModelMutationVariables, TContext> => {

const mutationKey = getAdminRestoreModelMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminRestoreModel>>, AdminRestoreModelMutationVariables> = (props) => {
          const {tier} = props ?? {};

          return  adminRestoreModel(tier,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdminRestoreModelMutationResult = NonNullable<Awaited<ReturnType<typeof adminRestoreModel>>>

    export type AdminRestoreModelMutationError = ErrorType<ErrorResponse>
    export type AdminRestoreModelMutationVariables = {tier: 'light' | 'content' | 'core'}

    /**
 * @summary Return a tier to the model it ran before (staff only, audited)
 */
export const useAdminRestoreModel = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminRestoreModel>>, TError,AdminRestoreModelMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminRestoreModel>>,
        TError,
        AdminRestoreModelMutationVariables,
        TContext
      > => {
      return useMutation(getAdminRestoreModelMutationOptions(options), queryClient);
    }

export const getAdminMarketingUrl = (params?: AdminMarketingParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/admin/marketing?${stringifiedParams}` : `/api/v1/admin/marketing`
}

/**
 * @summary Visitors to the public pages and the sign-ups they became (staff only)
 */
export const adminMarketing = async (params?: AdminMarketingParams, options?: Parameters<typeof apiFetch>[1]): Promise<AdminMarketing200> => {

  return apiFetch<AdminMarketing200>(getAdminMarketingUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAdminMarketingQueryKey = (params?: AdminMarketingParams,) => {
    return [
    `/api/v1/admin/marketing`, ...(params ? [params] : [])
    ] as const;
    }


export const getAdminMarketingQueryOptions = <TData = Awaited<ReturnType<typeof adminMarketing>>, TError = ErrorType<ErrorResponse>>(params?: AdminMarketingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMarketing>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminMarketingQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminMarketing>>> = ({ signal }) => adminMarketing(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminMarketing>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminMarketingQueryResult = NonNullable<Awaited<ReturnType<typeof adminMarketing>>>
export type AdminMarketingQueryError = ErrorType<ErrorResponse>


export function useAdminMarketing<TData = Awaited<ReturnType<typeof adminMarketing>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  AdminMarketingParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMarketing>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMarketing>>,
          TError,
          Awaited<ReturnType<typeof adminMarketing>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMarketing<TData = Awaited<ReturnType<typeof adminMarketing>>, TError = ErrorType<ErrorResponse>>(
 params?: AdminMarketingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMarketing>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMarketing>>,
          TError,
          Awaited<ReturnType<typeof adminMarketing>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMarketing<TData = Awaited<ReturnType<typeof adminMarketing>>, TError = ErrorType<ErrorResponse>>(
 params?: AdminMarketingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMarketing>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Visitors to the public pages and the sign-ups they became (staff only)
 */

export function useAdminMarketing<TData = Awaited<ReturnType<typeof adminMarketing>>, TError = ErrorType<ErrorResponse>>(
 params?: AdminMarketingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMarketing>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminMarketingQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







